(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.ReaderApp = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * SelectedDocumentModel
 */
module.exports = Backbone.Model.extend({
  
    rnapi:null,

    defaults: {
        publicationId:0,
        documentId:0,
        publicationTitle:null,
        publicationDate:null
    },

    urlRoot:function(){
        return this.rnapi+"/selections";
    },

    /**
     * @param  {Object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    }

});
},{"backbone":55,"underscore":61}],2:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * UserModel
 */
module.exports = Backbone.Model.extend({
  
    defaults: {
        id:0,
        name:null,
        admin:false,
        premium:false,
        pro:false,
        bnf:false
    },

    /**
     * @param  {Object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    },

    isLoggedIn:function(){
        return this.get("id")?true:false;
    },

    isAdmin:function(){
        if(this.isLoggedIn() && this.get("admin")){
            return true;
        }
        else{
            return false;
        }
    },

    
    isPremium:function(){
        if(this.get("premium")){// on peut être premium sans être logué, dans le cas ezproxy par exemple
            return true;
        }
        else{
            return false;
        }
    },

    isPro:function(){
        if(this.isLoggedIn() && this.get("pro")){
            return true;
        }
        else{
            return false;
        }
    },

    isBnf:function(){
        if(this.isLoggedIn() && this.get("bnf")){
            return true;
        }
        else{
            return false;
        }
    }

});
},{"backbone":55,"underscore":61}],3:[function(require,module,exports){
"use strict";

var Backbone            = require("backbone");
var _                   = require("underscore");

var AnnotationModel     = require("../models/annotation-model");

/**
 * AnnotationCollection 
 */
module.exports = Backbone.Collection.extend({
  
    model:AnnotationModel,
    rnapi:null,
    publicationId:0,
    documentId:0,

    initialize: function (models, options) {
        _.extend(this, options);
    },

    url: function() {
        var T=this;
        return T.rnapi+"/documents/"+T.publicationId+"/"+T.documentId+"/annotations";
    }

});
},{"../models/annotation-model":4,"backbone":55,"underscore":61}],4:[function(require,module,exports){
"use strict";

var Backbone            = require("backbone");

/**
 * AnnotationModel : annotation sur une page de document
 */
module.exports = Backbone.Model.extend({
  
    defaults: {
        publicationId:0,
        documentId:0,
        page:0,
        text:null,
        top:0,
        left:0,
        timestamp:0
    }

});
},{"backbone":55}],5:[function(require,module,exports){
"use strict";

var _               = require("underscore");

var BaseModel       = require("@immanens-com/pv5js/common/models/base-model");


/**
 * RetronewsPageSemanticModel :  all semantics informations extracted by syllabs + page blocks
 */
module.exports= BaseModel.extend({

    pv5api:null,

    defaults: {
        id:0,
        publicationId:0,
        readability:0,
        documentId:0,
        entities:null,
        width:0,
        height:0,
        blocks:null,
        articles:null
    },

    urlRoot:function(){
        return this.pv5api+"/document/"+this.get("publicationId")+"/"+this.get("documentId")+"/page-semantic";
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        _.extend(this, options);
    },


    /**
     * retrieve text block
     * @param  {[type]} block_id [description]
     * @return {[type]}          [description]
     */
    block:function(block_id){
        return _.findWhere(this.get("blocks"),{id:block_id});
    },

    article:function(article_id){
        return _.findWhere(this.get("articles"),{id:article_id});
    },

    /**
     * small adjustment: the server returns the response from syllabs as is, we cut multipage behaviour
     * @param  {Object} data
     * @return {Object}
     */
    parse:function(data){
        var d={};
        if(data.documents&&data.documents.length&&data.documents[0].pages&&data.documents[0].pages.length){
            d=data.documents[0].pages[0];
            if(d.articles && d.articles.page){
                d.articles=d.articles.page;
            }
            else{
                d.articles = [];
            }
            delete(d.id);
        }
        return d;
    }

});
},{"@immanens-com/pv5js/common/models/base-model":37,"underscore":61}],6:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * SharedCropModel
 */
module.exports = Backbone.Model.extend({
  
    rnapi:null,

    defaults: {
        publicationId:0,
        documentId:0,
        publicationTitle:null,
        publicationDate:null
    },

    urlRoot:function(){
        return this.rnapi+"/crops";
    },

    /**
     * @param  {Object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    }

});
},{"backbone":55,"underscore":61}],7:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var Router = require("./router");
var Strings = require("./strings");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");
var debug = require("debug")("app"); //https://github.com/visionmedia/debug

/**
 * Retronews Reader App : singleton representing entire application
 */
var ReaderApp = function(options) {
    var T = this;

    T.pv5api = null;
    T.rnapi = null;
    T.version = "2.11.5"; // will be replaced by package version at compile time
    T.lang = "fr";
    T.hostname="www.retronews.fr";
    T.canonicalUrl="https://www.retronews.fr/journal";
    T.canonicalEmbedUrl="https://www.retronews.fr/embed-journal";
    T.trackPage=null;
    T.embed=false;
    T.bot = /bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent); // teste si c'est un robot
    T.user = {
        admin: false,
        premium: false,
        id: 0,
        name: null
    };
    T.googleAnalytics = {
        enable: false,
        path: "/"
    };

    // activate debug message, use debug=* for all messages
    var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["debug"]);
    if (query_obj.debug == "true") {
        localStorage.debug = "*";
    } else if (query_obj.debug == "false") {
        delete(localStorage.debug);
    } else if (query_obj.debug) {
        localStorage.debug = query_obj.debug;
    }

    _.extend(T, options);
    _.extend(T, Backbone.Events); // trigger stuff

    window.STR = Strings[T.lang]; // make strings available globally

    // ezproxy transforme toutes les urls dans le code html, donc on met des | à la place des points
    if(T.hostname){
        T.hostname=T.hostname.replace(/\|/g,".");
    }
    if(T.canonicalUrl){
        T.canonicalUrl=T.canonicalUrl.replace(/\|/g,".");
    }
    if(T.canonicalEmbedUrl){
        T.canonicalEmbedUrl=T.canonicalEmbedUrl.replace(/\|/g,".");
    }
    if(T.pv5api){
        T.pv5api=T.pv5api.replace(/\|/g,".");
    }

    debug("retronews reader %s", T.version);
    debug("debug enable %s", localStorage.debug);

    T.router = new Router({
        app: this
    });

    Backbone.history.start({
        pushState: true,
        root: T.path
    });
};


ReaderApp.prototype.notify = function(data) {
    this.trigger("app:notify", data);
};

ReaderApp.prototype.loginScreen = function() {
    window.alert("Veuillez vous identifier pour ce service");
};

ReaderApp.prototype.premiumScreen = function() {
    window.alert("Service réservé aux abonnés");
};

ReaderApp.prototype.proScreen = function() {
    window.alert("Service réservé aux abonnés pro");
};

ReaderApp.prototype.comingSoonScreen = function() {
    window.alert("Service bientôt disponible");
};

ReaderApp.prototype.addToBasket = function(model) {
    window.alert("Panier: " + JSON.stringify(model.toJSON()));
};

ReaderApp.prototype.help = function() {
    window.open("https://www.retronews.fr/les-fonctionnalites-du-lecteur", "_blank");
};

module.exports = ReaderApp;

},{"./router":8,"./strings":9,"@immanens-com/pv5js/common/utils/url-util":41,"backbone":55,"debug":56,"underscore":61}],8:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var ReaderView = require("./views/reader-view");
var $ = require("jquery");
var _ = require("underscore");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var debug = require("debug")("router"); //https://github.com/visionmedia/debug

// Router
var Router = Backbone.Router.extend({

    routes: {
        "*querystring": "reader"
    },

    initialize: function(options) {
        this.app = options.app;
    },

    reader: function(querystring) {

        $("#app-reader").show();
        $("#error-404").hide();

        if (this.view) {
            this.view.close();
        }

        var publication_title,
            document_date,
            publication_id,
            document_id,
            page,
            from,
            fit,
            highlight,
            article_id,
            index;

        //
        // urls possibles:
        //  131/100001
        //  131/100001/1
        //  131/100001/1?from=xxx
        //  le-figaro/18-mars-1893/131/100001
        //  le-figaro/18-mars-1893/131/100001/1
        //  le-figaro/18-mars-1893/131/100001/1/9caf84f846d1f58947a9239faa88e52c
        //  le-figaro/18-mars-1893/131/100001/1?fit=998,1105,517,701
        //  trop compliqué à exprimer pour le router backbone, donc on fait à la main
        //

        var url_split = querystring.split("?");
        var path_split = url_split[0].split("/");

        if (path_split.length == 6 || path_split.length == 5 || path_split.length == 4) {
            publication_title = path_split[0];
            document_date = path_split[1];
            publication_id = path_split[2];
            document_id = path_split[3];
            page = path_split[4];
            article_id=path_split[5];

        } else if (path_split.length == 2 || path_split.length == 3) {
            publication_id = path_split[0];
            document_id = path_split[1];
            page = path_split[2];
        } else {
            return this.error404();
        }

        if (url_split.length == 2) {
            from = url_split[1];
        }

        //from peut aussi être dans la query string globale
        var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["from", "fit", "highlight","index"]);
        if (query_obj.from) {
            from = query_obj.from;
        }

        if (query_obj.fit) {
            var fit_array = query_obj.fit.split(".");
            if (fit_array.length == 4) {
                fit = {
                    x: parseInt(fit_array[0]),
                    y: parseInt(fit_array[1]),
                    width: parseInt(fit_array[2]),
                    height: parseInt(fit_array[3])
                };
            }
        }

        if (query_obj.highlight) {
            var highlight_array = query_obj.highlight.split(".");
            if (highlight_array.length == 4) {
                highlight = {
                    x: parseInt(highlight_array[0]),
                    y: parseInt(highlight_array[1]),
                    width: parseInt(highlight_array[2]),
                    height: parseInt(highlight_array[3])
                };
            }
        }

        if (!_.isUndefined(query_obj.index)) {
            index = parseInt(query_obj.index);
        }

        debug("reader %s %s %s %s %s %s %j %j %s %s", publication_title, document_date, publication_id, document_id, page, from, fit, highlight, index);

        this.view = new ReaderView({
            app: this.app,
            routePublicationTitle: publication_title, // optionnel
            routeDocumentDate: document_date, // optionnel
            publicationId: parseInt(publication_id, 10) || 1,
            documentId: parseInt(document_id, 10) || 1,
            page: parseInt(page, 10) || 1,
            from: from, // optionnel
            fit: fit, // optionnel
            highlight: highlight, // optionnel
            articleId:article_id, // optionnel
            index: index // optionnel
        });
    },


    error404: function(invalid_route) {
        debug("error404 %s", invalid_route);
        $("#app-reader").hide();
        $("#error-404").show();
    }

});

module.exports = Router;
},{"./views/reader-view":30,"@immanens-com/pv5js/common/utils/url-util":41,"backbone":55,"debug":56,"jquery":58,"underscore":61}],9:[function(require,module,exports){
"use strict";

/** global strings used in templates */
module.exports = {
    fr: {
        month_1: "janvier",
        month_2: "février",
        month_3: "mars",
        month_4: "avril",
        month_5: "mai",
        month_6: "juin",
        month_7: "juillet",
        month_8: "août",
        month_9: "septembre",
        month_10: "octobre",
        month_11: "novembre",
        month_12: "décembre",
        day_0: "dimanche",
        day_1: "lundi",
        day_2: "mardi",
        day_3: "mercredi",
        day_4: "jeudi",
        day_5: "vendredi",
        day_6: "samedi",

        theme_arts: "arts",
        theme_catastrophes: "catastrophes",
        theme_colonies: "colonies",
        theme_conflits_et_relations_internationales: "conflits et relations internationales",
        theme_economie: "économie",
        theme_education: "éducation",
        theme_justice: "justice",
        theme_medias: "médias",
        theme_politique: "politique",
        theme_religions: "religions",
        theme_sante: "santé",
        theme_sciences: "sciences",
        theme_societe: "société",
        theme_sports_et_loisirs: "sports et loisirs",

        theme_l2_architecture: "Architecture",
        theme_l2_arts_decoratifs: "Arts décoratifs",
        theme_l2_musee: "Musée",
        theme_l2_bibliotheque: "Bibliothèque",
        theme_l2_cabinet_des_estampes: "Cabinet des estampes",
        theme_l2_cinema: "Cinéma",
        theme_l2_collection_doeuvres_dart: "Collection d'œuvres d'art",
        theme_l2_cabinet_de_curiosites: "Cabinet de curiosités",
        theme_l2_coutumes_et_traditions: "Coutumes et traditions",
        theme_l2_culture_religieuse: "Culture religieuse",
        theme_l2_culture_militaire: "Culture militaire",
        theme_l2_culture_populaire: "Culture populaire",
        theme_l2_danse: "Danse",
        theme_l2_exposition_dart: "Exposition d'art",
        theme_l2_foire: "Foire",
        theme_l2_exposition_universelle: "Exposition universelle",
        theme_l2_gastronomie: "Gastronomie",
        theme_l2_litterature: "Littérature",
        theme_l2_marche_de_lart: "Marché de l'art",
        theme_l2_mode: "Mode",
        theme_l2_musique: "Musique",
        theme_l2_patrimoine_naturel: "Patrimoine naturel",
        theme_l2_patrimoine_artistique: "Patrimoine artistique",
        theme_l2_patrimoine_architectural: "Patrimoine architectural",
        theme_l2_peinture: "Peinture",
        theme_l2_photographie: "Photographie",
        theme_l2_radio: "Radio",
        theme_l2_sculpture: "Sculpture",
        theme_l2_theatre: "Théâtre",
        theme_l2_urbanisme: "Urbanisme",
        theme_l2_dessin_anime: "Dessin animé",
        theme_l2_bande_dessinee: "Bande dessinée",
        theme_l2_opera: "Opéra",
        theme_l2_television: "Télévision",
        theme_l2_parfumerie: "Parfumerie",
        theme_l2_accident_aerien: "Accident aérien",
        theme_l2_accident_maritime: "Accident maritime",
        theme_l2_accident_ferroviaire: "Accident ferroviaire",
        theme_l2_accident_routier: "Accident routier",
        theme_l2_accident_industriel: "Accident industriel",
        theme_l2_desastre_meteorologique: "Désastre météorologique",
        theme_l2_epizooties: "Épizooties",
        theme_l2_eruption_volcanique: "Éruption volcanique",
        theme_l2_famine: "Famine",
        theme_l2_incendie: "Incendie",
        theme_l2_inondation: "Inondation",
        theme_l2_pollution: "Pollution",
        theme_l2_secheresse: "Sécheresse",
        theme_l2_tremblement_de_terre: "Tremblement de terre",
        theme_l2_maree_noire: "Marée noire",
        theme_l2_catastrophe_miniere: "Catastrophe minière",
        theme_l2_rupture_de_barrage: "Rupture de barrage",
        theme_l2_explosion_accidentelle: "Explosion accidentelle",
        theme_l2_administration_coloniale: "Administration coloniale",
        theme_l2_colons: "Colons",
        theme_l2_compagnies_coloniales: "Compagnies coloniales",
        theme_l2_conquetes: "Conquêtes",
        theme_l2_economie_coloniale: "Économie coloniale",
        theme_l2_exposition_coloniale: "Exposition coloniale",
        theme_l2_peuples_colonises: "Peuples colonisés",
        theme_l2_presse_coloniale: "Presse coloniale",
        theme_l2_propagande_coloniale: "Propagande coloniale",
        theme_l2_rivalites_coloniales: "Rivalités coloniales",
        theme_l2_expedition_coloniale: "Expédition coloniale",
        theme_l2_armement: "Armement",
        theme_l2_conferences_et_sommets: "Conférences et sommets",
        theme_l2_coup_detat: "Coup d'État",
        theme_l2_economie_de_guerre: "Économie de guerre",
        theme_l2_guerre: "Guerre",
        theme_l2_massacre: "Massacre",
        theme_l2_traites_et_accords: "Traités et accords",
        theme_l2_agriculture: "Agriculture",
        theme_l2_elevage: "Élevage",
        theme_l2_viticulture: "Viticulture",
        theme_l2_finances_publiques: "Finances publiques",
        theme_l2_analyse_financiere: "Analyse financière",
        theme_l2_industrie_chimique: "Industrie chimique",
        theme_l2_commerce: "Commerce",
        theme_l2_distribution: "Distribution",
        theme_l2_energie_nucleaire: "Énergie nucléaire",
        theme_l2_electricite: "Électricité",
        theme_l2_petrole: "Pétrole",
        theme_l2_mineraux: "Minéraux",
        theme_l2_charbon: "Charbon",
        theme_l2_gaz_naturel: "Gaz naturel",
        theme_l2_immobilier: "Immobilier",
        theme_l2_industrie_de_transformation: "Industrie de transformation",
        theme_l2_industries_metallurgiques_et_mecaniques: "Industries métallurgiques et mécaniques",
        theme_l2_macro_economie: "Macro économie",
        theme_l2_marches: "Marchés",
        theme_l2_metaux: "Métaux",
        theme_l2_services_financiers: "Services financiers",
        theme_l2_transport: "Transport",
        theme_l2_vie_des_affaires: "Vie des affaires",
        theme_l2_concours: "Concours",
        theme_l2_etablissement_denseignement_superieur: "Établissement d'enseignement supérieur",
        theme_l2_ecole_secondaire: "École secondaire",
        theme_l2_ecole_professionnelle: "École professionnelle",
        theme_l2_ecole_primaire: "École primaire",
        theme_l2_maternelle: "Maternelle",
        theme_l2_education_des_filles: "Éducation des filles",
        theme_l2_education_religieuse: "Éducation religieuse",
        theme_l2_enseignants: "Enseignants",
        theme_l2_lois_scolaires: "Lois scolaires",
        theme_l2_pedagogie: "Pédagogie",
        theme_l2_universite: "Université",
        theme_l2_parc_naturel: "Parc naturel",
        theme_l2_dechets: "Déchets",
        theme_l2_reserve_naturelle: "Réserve naturelle",
        theme_l2_ecosysteme: "Écosystème",
        theme_l2_espece_menacee: "Espèce menacée",
        theme_l2_meteo: "Météo",
        theme_l2_attentat: "Attentat",
        theme_l2_crime_de_guerre: "Crime de guerre",
        theme_l2_assassinat: "Assassinat",
        theme_l2_evasion: "Évasion",
        theme_l2_piraterie: "Piraterie",
        theme_l2_infraction_sexuelle: "Infraction sexuelle",
        theme_l2_braquage: "Braquage",
        theme_l2_faux_en_art: "Faux en art",
        theme_l2_contrebande: "Contrebande",
        theme_l2_incendie_volontaire: "Incendie volontaire",
        theme_l2_agression: "Agression",
        theme_l2_enlevement: "Enlèvement",
        theme_l2_crime_organise: "Crime organisé",
        theme_l2_terrorisme: "Terrorisme",
        theme_l2_vol: "Vol",
        theme_l2_detournement_davion: "Détournement d'avion",
        theme_l2_prise_dotages: "Prise d'otages",
        theme_l2_faux_monnayage: "Faux-monnayage",
        theme_l2_corruption: "Corruption",
        theme_l2_fraude_fiscale: "Fraude fiscale",
        theme_l2_droits: "Droits",
        theme_l2_lois: "Lois",
        theme_l2_prison: "Prison",
        theme_l2_condamnation_a_perpetuite: "Condamnation à perpétuité",
        theme_l2_torture_et_punition_corporelle: "Torture et punition corporelle",
        theme_l2_police: "Police",
        theme_l2_etablissement_penitentiaire: "Établissement pénitentiaire",
        theme_l2_proces: "Procès",
        theme_l2_scandale: "Scandale",
        theme_l2_systeme_judiciaire: "Système judiciaire",
        theme_l2_journalistes_et_reporters: "Journalistes et reporters",
        theme_l2_liberte_de_la_presse_et_censure: "Liberté de la presse et censure",
        theme_l2_patrons_de_presse: "Patrons de presse",
        theme_l2_presse_ecrite: "Presse écrite",
        theme_l2_propagande: "Propagande",
        theme_l2_agence_de_presse: "Agence de presse",
        theme_l2_aide_internationale: "Aide internationale",
        theme_l2_dette_publique: "Dette publique",
        theme_l2_fiscalite: "Fiscalité",
        theme_l2_impot_religieux: "Impôt religieux",
        theme_l2_communisme: "Communisme",
        theme_l2_constitution: "Constitution",
        theme_l2_renseignement_militaire: "Renseignement militaire",
        theme_l2_armee: "Armée",
        theme_l2_mercenariat: "Mercenariat",
        theme_l2_diplomatie: "Diplomatie",
        theme_l2_droits_de_lhomme: "Droits de l'homme",
        theme_l2_elections: "Élections",
        theme_l2_espionnage: "Espionnage",
        theme_l2_gouvernement: "Gouvernement",
        theme_l2_groupe_de_pression: "Groupe de pression",
        theme_l2_ideologies_et_systemes: "Idéologies et systèmes",
        theme_l2_institutions_locales: "Institutions locales",
        theme_l2_migration: "Migration",
        theme_l2_parlement: "Parlement",
        theme_l2_partis_politiques: "Partis politiques",
        theme_l2_politique_sociale_en_france: "Politique sociale en France",
        theme_l2_politique_culturelle_en_france: "Politique culturelle en France",
        theme_l2_politique_des_transports_en_france: "Politique des transports en France",
        theme_l2_politique_energetique_en_france: "Politique énergétique en France",
        theme_l2_amenagement_du_territoire_en_france: "Aménagement du territoire en France",
        theme_l2_referendum: "Référendum",
        theme_l2_socialisme: "Socialisme",
        theme_l2_organisation_internationale: "Organisation internationale",
        theme_l2_nationalisation: "Nationalisation",
        theme_l2_privatisation: "Privatisation",
        theme_l2_chefs_religieux: "Chefs religieux",
        theme_l2_eglise_institution: "Église - Institution",
        theme_l2_evenement_religieux: "Événement religieux",
        theme_l2_ordres_religieux: "Ordres religieux",
        theme_l2_relations_entre_institutions_religieuses_et_letat: "Relations entre Institutions religieuses et l'État",
        theme_l2_rite: "Rite",
        theme_l2_texte_religieux: "Texte religieux",
        theme_l2_epidemie: "Épidémie",
        theme_l2_examens_medicaux: "Examens médicaux",
        theme_l2_hopitaux_et_cliniques: "Hôpitaux et cliniques",
        theme_l2_hygiene: "Hygiène",
        theme_l2_maladies: "Maladies",
        theme_l2_medicament: "Médicament",
        theme_l2_organisation_de_sante: "Organisation de santé",
        theme_l2_personnel_medical: "Personnel médical",
        theme_l2_politique_de_sante: "Politique de santé",
        theme_l2_traitement_medical: "Traitement médical",
        theme_l2_chirurgie: "Chirurgie",
        theme_l2_vaccin: "Vaccin",
        theme_l2_climatologie: "Climatologie",
        theme_l2_ethnologie: "Ethnologie",
        theme_l2_geographie: "Géographie",
        theme_l2_geologie: "Géologie",
        theme_l2_histoire: "Histoire",
        theme_l2_institutions_scientifiques: "Institutions scientifiques",
        theme_l2_mathematiques: "Mathématiques",
        theme_l2_oceanographie: "Océanographie",
        theme_l2_philosophie_des_sciences: "Philosophie des sciences",
        theme_l2_prix_et_recompenses: "Prix et récompenses",
        theme_l2_societe_savante: "Société savante",
        theme_l2_laboratoire_de_recherche: "Laboratoire de recherche",
        theme_l2_recherche_medicale: "Recherche médicale",
        theme_l2_archeologie: "Archéologie",
        theme_l2_sylviculture: "Sylviculture",
        theme_l2_artisanat: "Artisanat",
        theme_l2_technique_policiere: "Technique policière",
        theme_l2_metallurgie: "Métallurgie",
        theme_l2_pharmacie: "Pharmacie",
        theme_l2_aeronautique: "Aéronautique",
        theme_l2_optique: "Optique",
        theme_l2_astronautique: "Astronautique",
        theme_l2_astronomie: "Astronomie",
        theme_l2_construction: "Construction",
        theme_l2_metrologie: "Métrologie",
        theme_l2_armurerie: "Armurerie",
        theme_l2_medecine: "Médecine",
        theme_l2_technologie_miniere: "Technologie minière",
        theme_l2_technologie_du_transport: "Technologie du transport",
        theme_l2_genie_civil: "Génie civil",
        theme_l2_genie_chimique: "Génie chimique",
        theme_l2_genie_mecanique: "Génie mécanique",
        theme_l2_hydraulique: "Hydraulique",
        theme_l2_agronomie: "Agronomie",
        theme_l2_electronique: "Électronique",
        theme_l2_zoologie: "Zoologie",
        theme_l2_botanique: "Botanique",
        theme_l2_paleontologie: "Paléontologie",
        theme_l2_chimie: "Chimie",
        theme_l2_horticulture: "Horticulture",
        theme_l2_physique: "Physique",
        theme_l2_exploration_scientifique: "Exploration scientifique",
        theme_l2_anthropologie: "Anthropologie",
        theme_l2_linguistique: "Linguistique",
        theme_l2_sociologie: "Sociologie",
        theme_l2_activites_caritatives: "Activités caritatives",
        theme_l2_noblesse: "Noblesse",
        theme_l2_proletariat: "Prolétariat",
        theme_l2_domesticite: "Domesticité",
        theme_l2_bourgeoisie_urbaine: "Bourgeoisie urbaine",
        theme_l2_categories_sociales_et_professionnelles: "Catégories sociales et professionnelles",
        theme_l2_chomage: "Chômage",
        theme_l2_condition_feminine: "Condition féminine",
        theme_l2_duree_du_travail: "Durée du travail",
        theme_l2_syndicalisme: "Syndicalisme",
        theme_l2_travail_des_enfants: "Travail des enfants",
        theme_l2_demographie: "Démographie",
        theme_l2_esclavage: "Esclavage",
        theme_l2_homosexualite: "Homosexualité",
        theme_l2_mariage: "Mariage",
        theme_l2_divorce: "Divorce",
        theme_l2_avortement: "Avortement",
        theme_l2_greve: "Grève",
        theme_l2_lois_sur_le_travail: "Lois sur le travail",
        theme_l2_orphelinat: "Orphelinat",
        theme_l2_pauvrete: "Pauvreté",
        theme_l2_protection_sociale: "Protection sociale",
        theme_l2_racisme_et_xenophobie: "Racisme et Xénophobie",
        theme_l2_salaires: "Salaires",
        theme_l2_delinquance_juvenile: "Délinquance juvénile",
        theme_l2_prostitution: "Prostitution",
        theme_l2_suicide: "Suicide",
        theme_l2_pornographie: "Pornographie",
        theme_l2_troubles_civils: "Troubles civils",
        theme_l2_alpinisme_et_escalade: "Alpinisme et escalade",
        theme_l2_athletisme: "Athlétisme",
        theme_l2_automobile: "Automobile",
        theme_l2_aviron: "Aviron",
        theme_l2_badminton: "Badminton",
        theme_l2_boule_anglaise_et_petanque: "Boule anglaise et pétanque",
        theme_l2_bowling: "Bowling",
        theme_l2_boxe: "Boxe",
        theme_l2_carnavals_et_corteges: "Carnavals et cortèges",
        theme_l2_chasse: "Chasse",
        theme_l2_clubs_et_associations: "Clubs et associations",
        theme_l2_course_de_chiens: "Course de chiens",
        theme_l2_cricket: "Cricket",
        theme_l2_curling: "Curling",
        theme_l2_cyclisme: "Cyclisme",
        theme_l2_equitation: "Équitation",
        theme_l2_escrime: "Escrime",
        theme_l2_evenements_sportifs: "Événements sportifs",
        theme_l2_football: "Football",
        theme_l2_golf: "Golf",
        theme_l2_gymnastique_artistique: "Gymnastique artistique",
        theme_l2_halterophilie: "Haltérophilie",
        theme_l2_hippisme: "Hippisme",
        theme_l2_hockey_sur_gazon: "Hockey sur gazon",
        theme_l2_jeux_de_societe: "Jeux de société",
        theme_l2_echecs: "Échecs",
        theme_l2_jeux_de_cartes: "Jeux de cartes",
        theme_l2_jeux_de_hasard_et_loteries: "Jeux de hasard et loteries",
        theme_l2_jeux_olympiques: "Jeux olympiques",
        theme_l2_judo: "Judo",
        theme_l2_karate: "Karaté",
        theme_l2_lacrosse: "Lacrosse",
        theme_l2_luge: "Luge",
        theme_l2_lutte: "Lutte",
        theme_l2_natation: "Natation",
        theme_l2_patinage_artistique: "Patinage artistique",
        theme_l2_patinage_de_vitesse: "Patinage de vitesse",
        theme_l2_peche: "Pêche",
        theme_l2_pelote_basque: "Pelote basque",
        theme_l2_polo: "Polo",
        theme_l2_rodeo: "Rodéo",
        theme_l2_rugby_a_xv: "Rugby à XV",
        theme_l2_ski: "Ski",
        theme_l2_sports_aeriens_et_daviation: "Sports aériens et d'aviation",
        theme_l2_tennis: "Tennis",
        theme_l2_tennis_de_table: "Tennis de table",
        theme_l2_tir: "Tir",
        theme_l2_tir_a_larc: "Tir à l'arc",
        theme_l2_tourisme: "Tourisme",
        theme_l2_voile: "Voile",
        theme_l2_basket_ball: "Basket-ball",
        theme_l2_tauromachie: "Tauromachie",
        theme_l2_handball: "Handball",
        theme_l2_hockey_sur_glace: "Hockey sur glace",
        theme_l2_marathon: "Marathon",
        theme_l2_moto: "Moto",
        theme_l2_sumo: "Sumo",
        theme_l2_volley_ball: "Volley-ball",
        theme_l2_water_polo: "Water-polo",
        theme_l2_catch: "Catch",

        theme_l2_bibliotheque_et_musee: "Bibliothèque et musée",
        theme_l2_arts_radio: "Radio",
        theme_l2_patrimoine: "Patrimoine",
        theme_l2_divertissement: "Divertissement",
        theme_l2_culture: "Culture",
        theme_l2_expositions_et_salons: "Expositions et salons",
        theme_l2_collections: "Collections",
        theme_l2_marches_de_l_art: "Marché de l'art",
        theme_l2_expositions_universelles: "Expositions universelles",
        theme_l2_criminalite: "Criminalité",
        theme_l2_peines: "Peines",
        theme_l2_accusation: "Accusation",
        theme_l2_delinquance_financiere: "Délinquance financière",
        theme_l2_crimes_de_guerre: "Crime de guerre",
        theme_l2_attentats: "Attentat",
        theme_l2_scandales: "Scandale",
        theme_l2_faits_divers: "Fait divers",
        theme_l2_accidents_industriels: "Accident industriel",
        theme_l2_desastres_meteorologiques: "Désastre météorologique",
        theme_l2_accident_de_transport: "Accident de transport",
        theme_l2_equipement_et_immobilier: "Equipement et immobilier",
        theme_l2_energie_et_ressources: "Energie et ressources",
        theme_l2_metaux_et_mineraux: "Métaux et minéraux",
        theme_l2_industries_de_transformation: "Industries de transformation",
        theme_l2_commerce_international: "Commerce",
        theme_l2_banques_et_finances: "Banques et Finances",
        theme_l2_enfance: "Enfance",
        theme_l2_ecole: "Ecoles",
        theme_l2_epidemies: "Epidémies",
        theme_l2_traitements: "Traitements",
        theme_l2_organisations_de_sante: "Organisations de santé",
        theme_l2_medicaments: "Médicaments",
        theme_l2_blessures: "Blessures",
        theme_l2_specialisation_medicale: "Spécialisations médicales",
        theme_l2_defense: "Défense",
        theme_l2_droits_de_l_homme: "Droits de l'homme",
        theme_l2_budget_de_l_etat_et_impots: "Budget de l'Etat et impôts",
        theme_l2_traites_et_organisations_internationales: "Traités et organisations internationales",
        theme_l2_politique_interieure: "Politique Intérieure",
        theme_l2_migrations: "Migrations",
        theme_l2_medias_radio: "Radio",
        theme_l2_croyance: "Croyances (cultes et sectes > Christianisme, Judaïsme)",
        theme_l2_eglise: "Eglise",
        theme_l2_relations_entre_institutions_religieuses_et_l_etat: "Relations entre Institutions religieuses et l'Etat (Concordat)",
        theme_l2_textes_religieux: "Textes religieux",
        theme_l2_evenements_religieux: "Evénement religieux",
        theme_l2_sciences_et_religions: "Sciences et religions",
        theme_l2_rites: "Rites",
        theme_l2_sciences_appliquees: "Sciences appliquées",
        theme_l2_recherche: "Recherche",
        theme_l2_technologie_et_ingenierie: "Technologie et Ingénierie",
        theme_l2_instituts_scientifiques: "Institutions scientifiques",
        theme_l2_activites_caricatives: "Activités caritatives",
        theme_l2_famille: "Famille",
        theme_l2_problemes_de_societe: "Problèmes de société",
        theme_l2_greves: "Grève",
        theme_l2_conditions_feminines: "Condition féminine",
        theme_l2_syndicats: "Syndicats",
        theme_l2_orphelinats: "Orphelinats",
        theme_l2_ascension_sociale_carriere: "Carrière/Ascension sociale",
        theme_l2_conditions_de_travail: "Conditions de travail",
        theme_l2_sports_aeriens_et_d_aviation: "Sports aériens et d'aviation",
        theme_l2_tir_a_l_arc: "Tir à l'arc",
        theme_l2_ski_acrobatique: "Ski acrobatique",
        theme_l2_rugby: "Rugby à XV",
        theme_l2_organisations_sportives: "Organisations sportives",
        theme_l2_desordres_civils: "Désordres civils",
        theme_l2_coup_d_etat: "Coup d'état",
        theme_l2_traites_et_accords_de_guerre: "Traités et acccords",
        theme_l2_sommets_et_conferences: "Conférences et sommets",
        theme_l2_enjeux_territoriaux: "Enjeux territoriaux",
        theme_l2_expositions_coloniales: "Expositions coloniales",
        theme_l2_colonialisme: "Colonialisme",       

        document_not_found: "document non trouvé",
        save_in_progress: "Sauvegarde en cours",
        unable_to_save: "Impossible de sauver pour le moment",
        save_ok: "Sauvegarde réussie",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        something_wrong: "something goes wrong...",
        no_result: "Pas de résultat pour cette recherche",
        search_in_progress: "Recherche en cours...",
        facebook_message: "Explorer, trouver, comprendre",
        confirm_delete_annotation: "Etes-vous sûr de vouloir supprimer cette annotation?",
        text_is_missing: "Les fonctions texte, entités et recherche ne sont pas disponibles pour ce document",
        copy_url_ok: "L'URL pour accéder directement à cette page avec la zone surligée dans le lecteur est dans votre presse-papier.<br><br>Vous pouvez la coller avec CTRL+V",
        search_results: "résultats de recherche",
        no_other_result: "Pas d'autre résultat pour cette recherche",
        time_ago: {
            prefix: "Il y a ",
            suffix: "",
            seconds: "moins d'une minute",
            minute: "environ une minute",
            minutes: "%d minutes",
            hour: "environ une heure",
            hours: "environ %d heures",
            day: "un jour",
            days: "%d jours",
            month: "environ un mois",
            months: "%d mois",
            year: "un an",
            years: "%d ans"
        },
        comment_mini: "Veuillez saisir au minimum 20 caractères",
        no_main_articles: "Aucun article n'a été détecté dans cette page.",
        embed_activated:"Lecteur activé, vous pouvez vous déplacer",
        date: function(date,day_name) {
            if (!date) return;
            var date_array = date.split("-"),
                date_fr;
            if (date_array.length == 3) {
                date_fr = parseInt(date_array[2]) + " " + STR["month_" + parseInt(date_array[1])] + " " + date_array[0];
                if(day_name){
                    var date_obj=new Date(Date.UTC(parseInt(date_array[0]),parseInt(date_array[1])-1,parseInt(date_array[2])));
                    date_fr=STR["day_" +date_obj.getUTCDay()]+" "+date_fr;
                }
            }
            return date_fr;
        },
        number: function(n) {
            if (!n) return;
            return Number(n).toLocaleString(STR.locale, {
                useGrouping: true
            });
        },
        documentTitle:function(doc_title){
            if(!doc_title)return;
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(doc_title)) {
                doc_title = "N°" + doc_title;
            }
            return doc_title;
        }
    },
    en: {
        month_1: "january",
        month_2: "february",
        month_3: "march",
        month_4: "april",
        month_5: "may",
        month_6: "june",
        month_7: "july",
        month_8: "august",
        month_9: "september",
        month_10: "october",
        month_11: "november",
        month_12: "december",
        day_0: "Sunday",
        day_1: "Monday",
        day_2: "Tuesday",
        day_3: "Wednesday",
        day_4: "Thursday",
        day_5: "Saturday",
        day_6: "samedi",
        theme_arts: "arts",
        theme_catastrophes: "catastrophes",
        theme_colonies: "colonies",
        theme_conflits_et_relations_internationales: "conflits et relations internationales",
        theme_economie: "économie",
        theme_education: "éducation",
        theme_justice: "justice",
        theme_medias: "médias",
        theme_politique: "politique",
        theme_religions: "religions",
        theme_sante: "santé",
        theme_sciences: "sciences",
        theme_societe: "société",
        theme_sports_et_loisirs: "sports et loisirs",

        theme_l2_architecture: "Architecture",
        theme_l2_arts_decoratifs: "Arts décoratifs",
        theme_l2_musee: "Musée",
        theme_l2_bibliotheque: "Bibliothèque",
        theme_l2_cabinet_des_estampes: "Cabinet des estampes",
        theme_l2_cinema: "Cinéma",
        theme_l2_collection_doeuvres_dart: "Collection d'œuvres d'art",
        theme_l2_cabinet_de_curiosites: "Cabinet de curiosités",
        theme_l2_coutumes_et_traditions: "Coutumes et traditions",
        theme_l2_culture_religieuse: "Culture religieuse",
        theme_l2_culture_militaire: "Culture militaire",
        theme_l2_culture_populaire: "Culture populaire",
        theme_l2_danse: "Danse",
        theme_l2_exposition_dart: "Exposition d'art",
        theme_l2_foire: "Foire",
        theme_l2_exposition_universelle: "Exposition universelle",
        theme_l2_gastronomie: "Gastronomie",
        theme_l2_litterature: "Littérature",
        theme_l2_marche_de_lart: "Marché de l'art",
        theme_l2_mode: "Mode",
        theme_l2_musique: "Musique",
        theme_l2_patrimoine_naturel: "Patrimoine naturel",
        theme_l2_patrimoine_artistique: "Patrimoine artistique",
        theme_l2_patrimoine_architectural: "Patrimoine architectural",
        theme_l2_peinture: "Peinture",
        theme_l2_photographie: "Photographie",
        theme_l2_radio: "Radio",
        theme_l2_sculpture: "Sculpture",
        theme_l2_theatre: "Théâtre",
        theme_l2_urbanisme: "Urbanisme",
        theme_l2_dessin_anime: "Dessin animé",
        theme_l2_bande_dessinee: "Bande dessinée",
        theme_l2_opera: "Opéra",
        theme_l2_television: "Télévision",
        theme_l2_parfumerie: "Parfumerie",
        theme_l2_accident_aerien: "Accident aérien",
        theme_l2_accident_maritime: "Accident maritime",
        theme_l2_accident_ferroviaire: "Accident ferroviaire",
        theme_l2_accident_routier: "Accident routier",
        theme_l2_accident_industriel: "Accident industriel",
        theme_l2_desastre_meteorologique: "Désastre météorologique",
        theme_l2_epizooties: "Épizooties",
        theme_l2_eruption_volcanique: "Éruption volcanique",
        theme_l2_famine: "Famine",
        theme_l2_incendie: "Incendie",
        theme_l2_inondation: "Inondation",
        theme_l2_pollution: "Pollution",
        theme_l2_secheresse: "Sécheresse",
        theme_l2_tremblement_de_terre: "Tremblement de terre",
        theme_l2_maree_noire: "Marée noire",
        theme_l2_catastrophe_miniere: "Catastrophe minière",
        theme_l2_rupture_de_barrage: "Rupture de barrage",
        theme_l2_explosion_accidentelle: "Explosion accidentelle",
        theme_l2_administration_coloniale: "Administration coloniale",
        theme_l2_colons: "Colons",
        theme_l2_compagnies_coloniales: "Compagnies coloniales",
        theme_l2_conquetes: "Conquêtes",
        theme_l2_economie_coloniale: "Économie coloniale",
        theme_l2_exposition_coloniale: "Exposition coloniale",
        theme_l2_peuples_colonises: "Peuples colonisés",
        theme_l2_presse_coloniale: "Presse coloniale",
        theme_l2_propagande_coloniale: "Propagande coloniale",
        theme_l2_rivalites_coloniales: "Rivalités coloniales",
        theme_l2_expedition_coloniale: "Expédition coloniale",
        theme_l2_armement: "Armement",
        theme_l2_conferences_et_sommets: "Conférences et sommets",
        theme_l2_coup_detat: "Coup d'État",
        theme_l2_economie_de_guerre: "Économie de guerre",
        theme_l2_guerre: "Guerre",
        theme_l2_massacre: "Massacre",
        theme_l2_traites_et_accords: "Traités et accords",
        theme_l2_agriculture: "Agriculture",
        theme_l2_elevage: "Élevage",
        theme_l2_viticulture: "Viticulture",
        theme_l2_finances_publiques: "Finances publiques",
        theme_l2_analyse_financiere: "Analyse financière",
        theme_l2_industrie_chimique: "Industrie chimique",
        theme_l2_commerce: "Commerce",
        theme_l2_distribution: "Distribution",
        theme_l2_energie_nucleaire: "Énergie nucléaire",
        theme_l2_electricite: "Électricité",
        theme_l2_petrole: "Pétrole",
        theme_l2_mineraux: "Minéraux",
        theme_l2_charbon: "Charbon",
        theme_l2_gaz_naturel: "Gaz naturel",
        theme_l2_immobilier: "Immobilier",
        theme_l2_industrie_de_transformation: "Industrie de transformation",
        theme_l2_industries_metallurgiques_et_mecaniques: "Industries métallurgiques et mécaniques",
        theme_l2_macro_economie: "Macro économie",
        theme_l2_marches: "Marchés",
        theme_l2_metaux: "Métaux",
        theme_l2_services_financiers: "Services financiers",
        theme_l2_transport: "Transport",
        theme_l2_vie_des_affaires: "Vie des affaires",
        theme_l2_concours: "Concours",
        theme_l2_etablissement_denseignement_superieur: "Établissement d'enseignement supérieur",
        theme_l2_ecole_secondaire: "École secondaire",
        theme_l2_ecole_professionnelle: "École professionnelle",
        theme_l2_ecole_primaire: "École primaire",
        theme_l2_maternelle: "Maternelle",
        theme_l2_education_des_filles: "Éducation des filles",
        theme_l2_education_religieuse: "Éducation religieuse",
        theme_l2_enseignants: "Enseignants",
        theme_l2_lois_scolaires: "Lois scolaires",
        theme_l2_pedagogie: "Pédagogie",
        theme_l2_universite: "Université",
        theme_l2_parc_naturel: "Parc naturel",
        theme_l2_dechets: "Déchets",
        theme_l2_reserve_naturelle: "Réserve naturelle",
        theme_l2_ecosysteme: "Écosystème",
        theme_l2_espece_menacee: "Espèce menacée",
        theme_l2_meteo: "Météo",
        theme_l2_attentat: "Attentat",
        theme_l2_crime_de_guerre: "Crime de guerre",
        theme_l2_assassinat: "Assassinat",
        theme_l2_evasion: "Évasion",
        theme_l2_piraterie: "Piraterie",
        theme_l2_infraction_sexuelle: "Infraction sexuelle",
        theme_l2_braquage: "Braquage",
        theme_l2_faux_en_art: "Faux en art",
        theme_l2_contrebande: "Contrebande",
        theme_l2_incendie_volontaire: "Incendie volontaire",
        theme_l2_agression: "Agression",
        theme_l2_enlevement: "Enlèvement",
        theme_l2_crime_organise: "Crime organisé",
        theme_l2_terrorisme: "Terrorisme",
        theme_l2_vol: "Vol",
        theme_l2_detournement_davion: "Détournement d'avion",
        theme_l2_prise_dotages: "Prise d'otages",
        theme_l2_faux_monnayage: "Faux-monnayage",
        theme_l2_corruption: "Corruption",
        theme_l2_fraude_fiscale: "Fraude fiscale",
        theme_l2_droits: "Droits",
        theme_l2_lois: "Lois",
        theme_l2_prison: "Prison",
        theme_l2_condamnation_a_perpetuite: "Condamnation à perpétuité",
        theme_l2_torture_et_punition_corporelle: "Torture et punition corporelle",
        theme_l2_police: "Police",
        theme_l2_etablissement_penitentiaire: "Établissement pénitentiaire",
        theme_l2_proces: "Procès",
        theme_l2_scandale: "Scandale",
        theme_l2_systeme_judiciaire: "Système judiciaire",
        theme_l2_journalistes_et_reporters: "Journalistes et reporters",
        theme_l2_liberte_de_la_presse_et_censure: "Liberté de la presse et censure",
        theme_l2_patrons_de_presse: "Patrons de presse",
        theme_l2_presse_ecrite: "Presse écrite",
        theme_l2_propagande: "Propagande",
        theme_l2_agence_de_presse: "Agence de presse",
        theme_l2_aide_internationale: "Aide internationale",
        theme_l2_dette_publique: "Dette publique",
        theme_l2_fiscalite: "Fiscalité",
        theme_l2_impot_religieux: "Impôt religieux",
        theme_l2_communisme: "Communisme",
        theme_l2_constitution: "Constitution",
        theme_l2_renseignement_militaire: "Renseignement militaire",
        theme_l2_armee: "Armée",
        theme_l2_mercenariat: "Mercenariat",
        theme_l2_diplomatie: "Diplomatie",
        theme_l2_droits_de_lhomme: "Droits de l'homme",
        theme_l2_elections: "Élections",
        theme_l2_espionnage: "Espionnage",
        theme_l2_gouvernement: "Gouvernement",
        theme_l2_groupe_de_pression: "Groupe de pression",
        theme_l2_ideologies_et_systemes: "Idéologies et systèmes",
        theme_l2_institutions_locales: "Institutions locales",
        theme_l2_migration: "Migration",
        theme_l2_parlement: "Parlement",
        theme_l2_partis_politiques: "Partis politiques",
        theme_l2_politique_sociale_en_france: "Politique sociale en France",
        theme_l2_politique_culturelle_en_france: "Politique culturelle en France",
        theme_l2_politique_des_transports_en_france: "Politique des transports en France",
        theme_l2_politique_energetique_en_france: "Politique énergétique en France",
        theme_l2_amenagement_du_territoire_en_france: "Aménagement du territoire en France",
        theme_l2_referendum: "Référendum",
        theme_l2_socialisme: "Socialisme",
        theme_l2_organisation_internationale: "Organisation internationale",
        theme_l2_nationalisation: "Nationalisation",
        theme_l2_privatisation: "Privatisation",
        theme_l2_chefs_religieux: "Chefs religieux",
        theme_l2_eglise_institution: "Église - Institution",
        theme_l2_evenement_religieux: "Événement religieux",
        theme_l2_ordres_religieux: "Ordres religieux",
        theme_l2_relations_entre_institutions_religieuses_et_letat: "Relations entre Institutions religieuses et l'État",
        theme_l2_rite: "Rite",
        theme_l2_texte_religieux: "Texte religieux",
        theme_l2_epidemie: "Épidémie",
        theme_l2_examens_medicaux: "Examens médicaux",
        theme_l2_hopitaux_et_cliniques: "Hôpitaux et cliniques",
        theme_l2_hygiene: "Hygiène",
        theme_l2_maladies: "Maladies",
        theme_l2_medicament: "Médicament",
        theme_l2_organisation_de_sante: "Organisation de santé",
        theme_l2_personnel_medical: "Personnel médical",
        theme_l2_politique_de_sante: "Politique de santé",
        theme_l2_traitement_medical: "Traitement médical",
        theme_l2_chirurgie: "Chirurgie",
        theme_l2_vaccin: "Vaccin",
        theme_l2_climatologie: "Climatologie",
        theme_l2_ethnologie: "Ethnologie",
        theme_l2_geographie: "Géographie",
        theme_l2_geologie: "Géologie",
        theme_l2_histoire: "Histoire",
        theme_l2_institutions_scientifiques: "Institutions scientifiques",
        theme_l2_mathematiques: "Mathématiques",
        theme_l2_oceanographie: "Océanographie",
        theme_l2_philosophie_des_sciences: "Philosophie des sciences",
        theme_l2_prix_et_recompenses: "Prix et récompenses",
        theme_l2_societe_savante: "Société savante",
        theme_l2_laboratoire_de_recherche: "Laboratoire de recherche",
        theme_l2_recherche_medicale: "Recherche médicale",
        theme_l2_archeologie: "Archéologie",
        theme_l2_sylviculture: "Sylviculture",
        theme_l2_artisanat: "Artisanat",
        theme_l2_technique_policiere: "Technique policière",
        theme_l2_metallurgie: "Métallurgie",
        theme_l2_pharmacie: "Pharmacie",
        theme_l2_aeronautique: "Aéronautique",
        theme_l2_optique: "Optique",
        theme_l2_astronautique: "Astronautique",
        theme_l2_astronomie: "Astronomie",
        theme_l2_construction: "Construction",
        theme_l2_metrologie: "Métrologie",
        theme_l2_armurerie: "Armurerie",
        theme_l2_medecine: "Médecine",
        theme_l2_technologie_miniere: "Technologie minière",
        theme_l2_technologie_du_transport: "Technologie du transport",
        theme_l2_genie_civil: "Génie civil",
        theme_l2_genie_chimique: "Génie chimique",
        theme_l2_genie_mecanique: "Génie mécanique",
        theme_l2_hydraulique: "Hydraulique",
        theme_l2_agronomie: "Agronomie",
        theme_l2_electronique: "Électronique",
        theme_l2_zoologie: "Zoologie",
        theme_l2_botanique: "Botanique",
        theme_l2_paleontologie: "Paléontologie",
        theme_l2_chimie: "Chimie",
        theme_l2_horticulture: "Horticulture",
        theme_l2_physique: "Physique",
        theme_l2_exploration_scientifique: "Exploration scientifique",
        theme_l2_anthropologie: "Anthropologie",
        theme_l2_linguistique: "Linguistique",
        theme_l2_sociologie: "Sociologie",
        theme_l2_activites_caritatives: "Activités caritatives",
        theme_l2_noblesse: "Noblesse",
        theme_l2_proletariat: "Prolétariat",
        theme_l2_domesticite: "Domesticité",
        theme_l2_bourgeoisie_urbaine: "Bourgeoisie urbaine",
        theme_l2_categories_sociales_et_professionnelles: "Catégories sociales et professionnelles",
        theme_l2_chomage: "Chômage",
        theme_l2_condition_feminine: "Condition féminine",
        theme_l2_duree_du_travail: "Durée du travail",
        theme_l2_syndicalisme: "Syndicalisme",
        theme_l2_travail_des_enfants: "Travail des enfants",
        theme_l2_demographie: "Démographie",
        theme_l2_esclavage: "Esclavage",
        theme_l2_homosexualite: "Homosexualité",
        theme_l2_mariage: "Mariage",
        theme_l2_divorce: "Divorce",
        theme_l2_avortement: "Avortement",
        theme_l2_greve: "Grève",
        theme_l2_lois_sur_le_travail: "Lois sur le travail",
        theme_l2_orphelinat: "Orphelinat",
        theme_l2_pauvrete: "Pauvreté",
        theme_l2_protection_sociale: "Protection sociale",
        theme_l2_racisme_et_xenophobie: "Racisme et Xénophobie",
        theme_l2_salaires: "Salaires",
        theme_l2_delinquance_juvenile: "Délinquance juvénile",
        theme_l2_prostitution: "Prostitution",
        theme_l2_suicide: "Suicide",
        theme_l2_pornographie: "Pornographie",
        theme_l2_troubles_civils: "Troubles civils",
        theme_l2_alpinisme_et_escalade: "Alpinisme et escalade",
        theme_l2_athletisme: "Athlétisme",
        theme_l2_automobile: "Automobile",
        theme_l2_aviron: "Aviron",
        theme_l2_badminton: "Badminton",
        theme_l2_boule_anglaise_et_petanque: "Boule anglaise et pétanque",
        theme_l2_bowling: "Bowling",
        theme_l2_boxe: "Boxe",
        theme_l2_carnavals_et_corteges: "Carnavals et cortèges",
        theme_l2_chasse: "Chasse",
        theme_l2_clubs_et_associations: "Clubs et associations",
        theme_l2_course_de_chiens: "Course de chiens",
        theme_l2_cricket: "Cricket",
        theme_l2_curling: "Curling",
        theme_l2_cyclisme: "Cyclisme",
        theme_l2_equitation: "Équitation",
        theme_l2_escrime: "Escrime",
        theme_l2_evenements_sportifs: "Événements sportifs",
        theme_l2_football: "Football",
        theme_l2_golf: "Golf",
        theme_l2_gymnastique_artistique: "Gymnastique artistique",
        theme_l2_halterophilie: "Haltérophilie",
        theme_l2_hippisme: "Hippisme",
        theme_l2_hockey_sur_gazon: "Hockey sur gazon",
        theme_l2_jeux_de_societe: "Jeux de société",
        theme_l2_echecs: "Échecs",
        theme_l2_jeux_de_cartes: "Jeux de cartes",
        theme_l2_jeux_de_hasard_et_loteries: "Jeux de hasard et loteries",
        theme_l2_jeux_olympiques: "Jeux olympiques",
        theme_l2_judo: "Judo",
        theme_l2_karate: "Karaté",
        theme_l2_lacrosse: "Lacrosse",
        theme_l2_luge: "Luge",
        theme_l2_lutte: "Lutte",
        theme_l2_natation: "Natation",
        theme_l2_patinage_artistique: "Patinage artistique",
        theme_l2_patinage_de_vitesse: "Patinage de vitesse",
        theme_l2_peche: "Pêche",
        theme_l2_pelote_basque: "Pelote basque",
        theme_l2_polo: "Polo",
        theme_l2_rodeo: "Rodéo",
        theme_l2_rugby_a_xv: "Rugby à XV",
        theme_l2_ski: "Ski",
        theme_l2_sports_aeriens_et_daviation: "Sports aériens et d'aviation",
        theme_l2_tennis: "Tennis",
        theme_l2_tennis_de_table: "Tennis de table",
        theme_l2_tir: "Tir",
        theme_l2_tir_a_larc: "Tir à l'arc",
        theme_l2_tourisme: "Tourisme",
        theme_l2_voile: "Voile",
        theme_l2_basket_ball: "Basket-ball",
        theme_l2_tauromachie: "Tauromachie",
        theme_l2_handball: "Handball",
        theme_l2_hockey_sur_glace: "Hockey sur glace",
        theme_l2_marathon: "Marathon",
        theme_l2_moto: "Moto",
        theme_l2_sumo: "Sumo",
        theme_l2_volley_ball: "Volley-ball",
        theme_l2_water_polo: "Water-polo",
        theme_l2_catch: "Catch",

        theme_l2_bibliotheque_et_musee: "Bibliothèque et musée",
        theme_l2_arts_radio: "Radio",
        theme_l2_patrimoine: "Patrimoine",
        theme_l2_divertissement: "Divertissement",
        theme_l2_culture: "Culture",
        theme_l2_expositions_et_salons: "Expositions et salons",
        theme_l2_collections: "Collections",
        theme_l2_marches_de_l_art: "Marché de l'art",
        theme_l2_expositions_universelles: "Expositions universelles",
        theme_l2_criminalite: "Criminalité",
        theme_l2_peines: "Peines",
        theme_l2_accusation: "Accusation",
        theme_l2_delinquance_financiere: "Délinquance financière",
        theme_l2_crimes_de_guerre: "Crime de guerre",
        theme_l2_attentats: "Attentat",
        theme_l2_scandales: "Scandale",
        theme_l2_faits_divers: "Fait divers",
        theme_l2_accidents_industriels: "Accident industriel",
        theme_l2_desastres_meteorologiques: "Désastre météorologique",
        theme_l2_accident_de_transport: "Accident de transport",
        theme_l2_equipement_et_immobilier: "Equipement et immobilier",
        theme_l2_energie_et_ressources: "Energie et ressources",
        theme_l2_metaux_et_mineraux: "Métaux et minéraux",
        theme_l2_industries_de_transformation: "Industries de transformation",
        theme_l2_commerce_international: "Commerce",
        theme_l2_banques_et_finances: "Banques et Finances",
        theme_l2_enfance: "Enfance",
        theme_l2_ecole: "Ecoles",
        theme_l2_epidemies: "Epidémies",
        theme_l2_traitements: "Traitements",
        theme_l2_organisations_de_sante: "Organisations de santé",
        theme_l2_medicaments: "Médicaments",
        theme_l2_blessures: "Blessures",
        theme_l2_specialisation_medicale: "Spécialisations médicales",
        theme_l2_defense: "Défense",
        theme_l2_droits_de_l_homme: "Droits de l'homme",
        theme_l2_budget_de_l_etat_et_impots: "Budget de l'Etat et impôts",
        theme_l2_traites_et_organisations_internationales: "Traités et organisations internationales",
        theme_l2_politique_interieure: "Politique Intérieure",
        theme_l2_migrations: "Migrations",
        theme_l2_medias_radio: "Radio",
        theme_l2_croyance: "Croyances (cultes et sectes > Christianisme, Judaïsme)",
        theme_l2_eglise: "Eglise",
        theme_l2_relations_entre_institutions_religieuses_et_l_etat: "Relations entre Institutions religieuses et l'Etat (Concordat)",
        theme_l2_textes_religieux: "Textes religieux",
        theme_l2_evenements_religieux: "Evénement religieux",
        theme_l2_sciences_et_religions: "Sciences et religions",
        theme_l2_rites: "Rites",
        theme_l2_sciences_appliquees: "Sciences appliquées",
        theme_l2_recherche: "Recherche",
        theme_l2_technologie_et_ingenierie: "Technologie et Ingénierie",
        theme_l2_instituts_scientifiques: "Institutions scientifiques",
        theme_l2_activites_caricatives: "Activités caritatives",
        theme_l2_famille: "Famille",
        theme_l2_problemes_de_societe: "Problèmes de société",
        theme_l2_greves: "Grève",
        theme_l2_conditions_feminines: "Condition féminine",
        theme_l2_syndicats: "Syndicats",
        theme_l2_orphelinats: "Orphelinats",
        theme_l2_ascension_sociale_carriere: "Carrière/Ascension sociale",
        theme_l2_conditions_de_travail: "Conditions de travail",
        theme_l2_sports_aeriens_et_d_aviation: "Sports aériens et d'aviation",
        theme_l2_tir_a_l_arc: "Tir à l'arc",
        theme_l2_ski_acrobatique: "Ski acrobatique",
        theme_l2_rugby: "Rugby à XV",
        theme_l2_organisations_sportives: "Organisations sportives",
        theme_l2_desordres_civils: "Désordres civils",
        theme_l2_coup_d_etat: "Coup d'état",
        theme_l2_traites_et_accords_de_guerre: "Traités et acccords",
        theme_l2_sommets_et_conferences: "Conférences et sommets",
        theme_l2_enjeux_territoriaux: "Enjeux territoriaux",
        theme_l2_expositions_coloniales: "Expositions coloniales",
        theme_l2_colonialisme: "Colonialisme",       

        document_not_found: "document not found",
        save_in_progress: "Sauvegarde en cours",
        unable_to_save: "Impossible de sauver pour le moment",
        save_ok: "Sauvegarde réussie",
        something_wrong: "something goes wrong...",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        no_result: "No result found",
        search_in_progress: "Search in progress...",
        facebook_message: "Explorer, trouver, comprendre",
        confirm_delete_annotation: "Are you sure you want to delete this annotation?",
        text_is_missing: "Text, search and entities are not available for this document",
        copy_url_ok: "Vous pouvez coller l'URL pour accéder directement à cette page avec la zone surligée dans le lecteur",
        search_results: "search results",
        no_other_result: "No more result",
        time_ago: {
            prefix: "",
            suffix: " ago",
            seconds: "less than a minute",
            minute: "about a minute",
            minutes: "%d minutes",
            hour: "about an hour",
            hours: "about %d hours",
            day: "a day",
            days: "%d days",
            month: "about a month",
            months: "%d months",
            year: "about a year",
            years: "%d years"
        },
        comment_mini: "Veuillez saisir au minimum 20 caractères",
        no_main_articles: "Aucun article n'a été détecté dans cette page.",
        embed_activated:"Lecteur activé",
        date: function(date,day_name) {
            if (!date) return;
            var date_array = date.split("-"),
                date_en;
            if (date_array.length == 3) {
                date_en = date_array[2] + " " + STR["month_" + parseInt(date_array[1])] + " " + date_array[0];
                if(day_name){
                    var date_obj=new Date(Date.UTC(parseInt(date_array[0]),parseInt(date_array[1])-1,parseInt(date_array[2])));
                    date_en=STR["day_" +date_obj.getUTCDay()]+" "+date_en;
                }
            }
            return date_en;
        },
        number: function(n) {
            if (!n) return;
            return Number(n).toLocaleString(STR.locale, {
                useGrouping: true
            });
        },
        documentTitle:function(doc_title){
            if(!doc_title)return;
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(doc_title)) {
                doc_title = "N°" + doc_title;
            }
            return doc_title;
        }
    }
};
},{}],10:[function(require,module,exports){
module.exports = "<div class=\"pin\" title=\"<%=text%>\"></div>\n<div class=\"text\"><%=text%></div>";

},{}],11:[function(require,module,exports){
module.exports = "<a href=\"<%=reader%>\" class=\"page-crop\" style=\"background-image:url('<%=crop%>');\"></a>\n<a href=\"<%=reader%>\" class=\"page-infos\">\n    <div class=\"title\"><h3><%=publicationTitle%></h3></div>\n    <div><span class=\"date\"><%= STR.date(published)%><%=documentTitle?\" (\"+documentTitle+\")\":\"\"%></span><%if(pageNumber){%><span class=\"page\">, p.&nbsp;<%=pageNumber%></span><%}%></div>\n    <div class=\"article-title\"><%=title%></div>\n</a>";

},{}],12:[function(require,module,exports){
module.exports = "<div class=\"block-header <%=mode%>\">\r\n    <%if(mode==\"page\"){%>\r\n        La page\r\n    <%}else{%>\r\n        Les articles de la page\r\n    <%}%>\r\n    <%=page%>/<%=nbPages%>\r\n</div>\r\n<div class=\"block-body <%=mode%> <%=hasMainArticles?'has-main-articles':''%>\"><%=blocks%></div>\r\n<div class=\"block-footer <%=mode%> <%=hasMainArticles?'has-main-articles':''%>\">\r\n    <%if(mode==\"page\"){%>\r\n        Voir la liste des articles principaux\r\n    <%}else{%>\r\n        Voir le texte de la page entière\r\n    <%}%>\r\n</div>";

},{}],13:[function(require,module,exports){
module.exports = "<div class=\"calendar-header\">\r\n    <div class=\"calendar-title\"><span class=\"premium-badge\"></span>Calendrier</div>\r\n    <div class=\"flex-spacer\"></div>\r\n    <div class=\"previous-month\"></div>\r\n    <div class=\"month\"></div>\r\n    <div class=\"next-month\"></div>\r\n    <div class=\"previous-year\"></div>\r\n    <div class=\"year\"></div>\r\n    <div class=\"next-year\"></div>\r\n</div>\r\n<div class=\"calendar-body\">\r\n    <%if(isPremium){%>\r\n        <% _.each(results, function(result) { %>\r\n            <a href=\"<%=readerUrl(result)%>\" class=\"doc-line <%=result.id==documentId?'current':''%> <%=result.nbHits?'':'no-hits'%>\">\r\n                <div class=\"doc-title\"><%=STR.documentTitle(result.title)%></div>\r\n                <div class=\"doc-date\"><%=STR.date(result.published,true)%></div>\r\n                <div class=\"doc-hits\"><%=result.nbHits%></div>\r\n            </a>\r\n        <% }); %>\r\n    <%}else{%>\r\n        <p>Le calendrier vous permet de voir les résultats de la recherche en cours dans les documents de la même période et d’y accéder rapidement.</p>\r\n        <p>Cet outil est réservé aux abonnés.</p>\r\n        <div>\r\n            <div class=\"subscribe\">Abonnez-vous</div>\r\n        </div>\r\n    <%}%>\r\n</div>\r\n<div class=\"calendar-footer\">\r\n        <div class=\"search-all-issues\">Voir tous les numéros du titre</div>\r\n        <div class=\"search-current-date\">Voir tous les numéros publiés ce jour</div>\r\n</div>";

},{}],14:[function(require,module,exports){
module.exports = "<ul>\r\n<% _.each(events, function(event) { %>\r\n    <li class=\"event\" data-type=\"event\" data-value=\"<%=event%>\"><%=event%></li>\r\n<% }); %>\r\n<% _.each(themes, function(theme) { %>\r\n    <li class=\"theme\" data-type=\"theme\" data-l1=\"<%=theme.l1%>\" data-l2=\"<%=theme.l2%>\"><span class=\"color-<%=theme.l1%>\"></span> <%=STR[\"theme_\"+theme.l1]+\" / \"+STR[\"theme_l2_\"+theme.l2]%></li>\r\n<% }); %>\r\n<% _.each(persons, function(person) { %>\r\n    <li class=\"person\" data-type=\"person\" data-value=\"<%=person%>\"><%=person%></li>\r\n<% }); %>\r\n<% _.each(geolocs, function(geoloc) { %>\r\n    <li class=\"geoloc\"  data-type=\"geoloc\" data-value=\"<%=geoloc%>\"><%=geoloc%></li>\r\n<% }); %>\r\n<% _.each(organizations, function(organization) { %>\r\n    <li class=\"organization\" data-type=\"organization\" data-value=\"<%=organization%>\"><%=organization%></li>\r\n<% }); %>\r\n</ul>";

},{}],15:[function(require,module,exports){
module.exports = "<a href=\"<%=url%>\" title=\"Retour aux résultats de recherche (<%=total%>)\"></a>";

},{}],16:[function(require,module,exports){
module.exports = "<div class=\"knob\">\n    <div class=\"knob-inside\">\n    </div>\n</div>";

},{}],17:[function(require,module,exports){
module.exports = "<div class=\"thumb\">\n    <div class=\"cover\"></div>\n    <div class=\"info\"><span class=\"page\"></span> / <%=nbPages%></div>\n</div>";

},{}],18:[function(require,module,exports){
module.exports = "<div><%=id%></div>";

},{}],19:[function(require,module,exports){
module.exports = "<div class=\"container\">\n    <h1>— Résultats de recherche</h1>\n    <div class=\"top\">\n        <div class=\"search-filters\">\n            <% _.each(filters,function(filter) { %>\n            <div class=\"filter-value\"><%=filter%></div>\n            <% }); %>\n        </div>\n        <div class=\"total-results\"></div>\n    </div>\n    <div class=\"next-results\" id=\"next-results\"></div>\n    <div class=\"bottom\"><button class=\"see-all-result\">Voir tous les résultats</button></div>\n    <div class=\"notify\"><p></p></div>\n</div>";

},{}],20:[function(require,module,exports){
"use strict";

var Backbone                = require("backbone");
var $                       = require("jquery");
var _                       = require("underscore");
Backbone.$                  = $;

var template                = require("../templates/annotation-template.html");

var debug                   = require("debug")("views:AnnotationView");


// AnnotationView : affiche une annotation dans la page
module.exports = Backbone.View.extend({

    template:_.template(template), // compile template
    model:null,         // AnnotationModel
    className:"annotation",

    events:{
        "pointerdown":"onDragPinStart"   
    },
    
    /**
     */
    initialize:function(options){
        var T=this;
        
        T._pointers={};
        T._dragStartPoint={x:0,y:0};
        T._dragStartSelection={};
        T._abortDrag=false;

        _.extend(T, options);

        T.listenTo(T.model, "change", T.render);
        T.listenTo(T.model, "destroy", T.remove);
    },

    render: function(){
        
        var T=this,
            context=T.model.toJSON();

        T.$el.html(T.template(context));
        T.$el.css({
            top:T.model.get("top")+"%",
            left:T.model.get("left")+"%"
        });
        return T;
    },

    onDragPinStart:function(e){
        var T=this;

        e.preventDefault();
        e.stopPropagation();

        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);

        if(keys.length==1){
            T.dragStartDate=Date.now();
            T._dragStartPoint.x=e.pageX;
            T._dragStartPoint.y=e.pageY;
            $(window).on("pointermove.annotation",function(e){T.onDragPinMove(e);});
            $(window).on("pointerup.annotation",function(e){T.onDragPinEnd(e);});
            $(window).on("pointercancel.annotation",function(e){T.onDragPinEnd(e);});
        }
        else{
            T._abortDrag=true;
        }

    },

    onDragPinMove:function(e){ //jshint ignore: line
        var T=this;

        if(T._abortDrag)return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);
        if(keys.length==1){
            var container_width=T.$el.parent().parent().width();
            var container_height=T.$el.parent().parent().height();

            var dX=(e.pageX-T._dragStartPoint.x)*100/container_width, // %
                dY=(e.pageY-T._dragStartPoint.y)*100/container_height; // %

            //console.log("dx: "+dX);

            var new_x=T.model.get("left")+dX;
            var new_y=T.model.get("top")+dY;

            // clamp
            if(new_x<0){
                new_x=0;
            }
            else if(new_x>100){
                new_x=100;
            }
            if(new_y<0){
                new_y=0;
            }
            else if(new_y>100){
                new_y=100;
            }

            T.dragPinX=new_x;
            T.dragPinY=new_y;

            T.$el.css({
                top:new_y+"%",
                left:new_x+"%"
            });       
        }

    },

    onDragPinEnd:function(e){
        var T=this;
        var last_x=T._pointers[e.originalEvent.pointerId].pageX;
        var last_y=T._pointers[e.originalEvent.pointerId].pageY;
        
        delete T._pointers[e.originalEvent.pointerId];

        var keys=_.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if(!keys.length){
            $(window).off(".annotation");
            T._abortDrag=false;

            if(Date.now()-T.dragStartDate<400 && Math.abs(last_x-T._dragStartPoint.x)<3&& Math.abs(last_y-T._dragStartPoint.y)<3){
                // c'est un click
                debug("click");
                T.trigger("click",T.model);
            }
            else{
                // c'est un déplacement on affecte la valeur à l'annotation
                T.model.save({
                    top:T.dragPinY,
                    left:T.dragPinX
                },{
                    error: function(){ 
                        T.app.notify({
                            text:STR.unable_to_save,
                            type:"error",
                            timeout:4000
                        });
                    }
                });
            }
        }
    },

    close: function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }

});
},{"../templates/annotation-template.html":10,"backbone":55,"debug":56,"jquery":58,"underscore":61}],21:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:BlocksView");
var template = require("../templates/blocks-template.html");

/**
 * BlocksView: display all text blocks from semantic model
 * Trigger
 * - "click:block"
 * - "change:mode"
 * - "article:open"
 */
module.exports = Backbone.View.extend({

    model: null, // Retronews PageSemanticModel
    pageModel: null,
    documentModel: null,
    template: _.template(template), // compile template
    className: "blocks-view",
    mode: "page", // page ou article
    articleId: null, // article initialement affiché

    events: {
        "click p": "onClick",
        "click h2": "onClick",
        "click .block-footer": "onToggleMode",
        "click .block-article h2": "onClickArticle"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "sync", T.render);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    hasMainArticles: function () {
        var T = this;
        var articles = T.model.get("articles");
        var is_main_article;
        _.every(articles, function (article) {
            if (_.has(article, "main_article")) {
                is_main_article = article.main_article;
            }
            else {
                is_main_article = article.blocks.length > 2 ? true : false;
            }
            return !is_main_article;
        });
        return is_main_article;
    },

    render: function () {
        var T = this,
            context = {},
            str_html_blocks = "";

        if (T.model.fetched && T.pageModel.fetched) {
            debug("render");

            if (T.app.bot && T.pageModel.get("readability") < 0.8) {
                // on affiche pas le texte pour les bot si la readability est mauvaise
                return;
            }
            context.mode = T.mode;
            context.page = T.pageModel.get("label");
            context.nbPages = T.documentModel.get("nbPages");
            context.hasMainArticles = T.hasMainArticles();

            var blocks = T.model.get("blocks");

            if (T.mode == "page") {
                //search medium font size = font the most used in document
                if (blocks) {
                    var medium_font_size = 10;
                    var max_words_title = 20;
                    var all_font_sizes = 0;
                    var nb_words = 0;
                    _.each(blocks, function (block) {
                        all_font_sizes += block.font_size * block.word_count;
                        nb_words += block.word_count;
                    });

                    if (nb_words) {
                        medium_font_size = Math.round((all_font_sizes / nb_words) * 1.1);
                    }

                    _.each(blocks, function (block) {
                        var tag = block.font_size > medium_font_size && block.word_count < max_words_title ? "<h2>" : "<p>";
                        var $el = $(tag, {
                            id: block.id
                        });
                        // on fait cette manip pour éliminer le html que l'ocr aurait pu produire par hasard
                        $el.text(block.text);
                        str_html_blocks += $el[0].outerHTML;
                    });
                }

            }
            else {
                //affichage des artiles
                if (context.hasMainArticles) {
                    var articles = T.model.get("articles");
                    _.each(articles, function (article) {
                        // on affiche seulement les articles principaux
                        // si syllabs a rempli le flag main_article on l'utilise, sinon on compte le nombre de blocks (doit être supérieur à 2)
                        var is_main_article;
                        if (_.has(article, "main_article")) {
                            is_main_article = article.main_article;
                        }
                        else {
                            is_main_article = article.blocks.length > 2 ? true : false;
                        }
                        if (!is_main_article) return;
                        str_html_blocks += '<div class="block-article" id="' + article.id + '">';
                        // titre de l'article
                        var $el = $("<h2>");
                        var title = article.title;
                        if (!title || title.length === 0) {
                            // si pas de titre on prends les premiers mots du premier block
                            var first_block = T.model.block(article.blocks[0].blockid);
                            if (first_block) {
                                title = first_block.text.substr(0, 50);
                                title += "...";
                            }
                        }
                        $el.text(title);
                        str_html_blocks += $el[0].outerHTML;

                        //texte de l'article
                        _.each(article.blocks, function (block) {
                            $el = $("<p>", {
                                id: block.blockid
                            });
                            var block_model = T.model.block(block.blockid);
                            if (block_model) {
                                if (block_model.text == article.title) {
                                    $el.addClass("hidden-title"); // pour éviter la répétition du titre dans le texte
                                }
                                $el.text(block_model.text);
                                str_html_blocks += $el[0].outerHTML;

                            }
                        });

                        str_html_blocks += "</div>";
                    });
                }
                else {
                    str_html_blocks = "<p class='no-main-articles'>" + STR.no_main_articles + "</p>";
                }
            }

            context.blocks = str_html_blocks;
            T.$el.html(T.template(context));

            if (T.articleId) {
                T.gotoArticle(T.articleId);
                T.articleId = null; // pour ne plus faire de highlight au prochain affichage
            }
        }
    },

    gotoBlock: function (block_id) {
        var T = this,
            $body = T.$(".block-body"),
            $block = T.$("#" + block_id);
        if ($block.length) {
            if (T.mode == "article") {
                if (!$block.parent().hasClass("open")) {
                    $block.parent().addClass("open");
                    this.trigger("article:open", this, $block.parent().attr("id"), true);
                }
                if ($block.hasClass("hidden-title")) {
                    // on cache des données dans les styles ... pas terrible mais pas le temps de faire mieux
                    $block = $block.parent();
                }
            }
            $body.animate({
                scrollTop: $body.scrollTop() + $block.position().top
            },
                500
            );
        }
    },

    gotoArticle: function (article_id) {
        var T = this,
            $article = T.$("#" + article_id),
            $body = T.$(".block-body");

        if ($article.length) {
            // open article
            $article.addClass("open");
            this.trigger("article:open", this, article_id, true);

            // scroll to
            $body.animate({
                scrollTop: $body.scrollTop() + $article.position().top
            },
                500
            );

            // highlight article
            T.highlightArticle(article_id);
        }
    },

    highlightArticle: function (article_id) {
        var T = this,
            article = T.model.article(article_id);// recherche des blocs qui composent cet article
        if (article) {
            var block_ids = [];
            _.each(article.blocks, function (block) {
                block_ids.push(block.blockid);
            });
            this.trigger("click:block", this, block_ids);
        }
    },

    onToggleMode: function () {
        var T = this;
        T.mode = T.mode == "page" ? "article" : "page";
        T.render();
        this.trigger("change:mode", T, T.mode);
    },

    onClick: function (e) {
        if (e.target.id) {
            this.trigger("click:block", this, [e.target.id]);
        }
    },

    onClickArticle: function (e) {
        var T = this;
        // ouvre ou ferme l'article si on appuie sur le titre
        var $article = $(e.target).parent();
        $article.toggleClass("open");

        var article_id = $article.prop("id");
        if ($article.hasClass("open")) {
            T.highlightArticle(article_id);
            this.trigger("article:open", this, article_id, true);
        }
        else {
            this.trigger("article:open", this, article_id, false);
        }

    },

    close: function () {
        var T = this;
        T.model = null;
        T.pageModel = null;
        T.documentModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});

},{"../templates/blocks-template.html":12,"backbone":55,"debug":56,"jquery":58,"underscore":61}],22:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var DateUtil = require("@immanens-com/pv5js/common/utils/date-util");
var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var debug = require("debug")("views:CalendarView");
var template = require("../templates/calendar-template.html");

var ArticleQueryModel = require("../../search/models/article-query-model");

/**
 * CalendarView: affichaeg des numéros du mois courant
 * Trigger
 */
module.exports = Backbone.View.extend({

    documentModel: null,
    userModel: null,
    template: _.template(template), // compile template
    className: "calendar-view",
    searchAccess: "public",
    queryModel: null,
    documentQueryModel: null,
    articleQueryModel: null,
    from: null,
    index: null,
    fetching: false,
    baseRoute:"/journal",

    events: {
        "click .search-all-issues": "onSearchAllIssuesClicked",
        "click .search-current-date": "onSearchCurrentDateClicked",
        "click .previous-month": "onPreviousMonthClicked",
        "click .previous-year": "onPreviousYearClicked",
        "click .next-month": "onNextMonthClicked",
        "click .next-year": "onNextYearClicked",
        "click a.doc-line": "onDocClicked"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.listenToOnce(T.documentModel, "sync", T.render);

        // requête pour récupérer tous les document du mois
        T.documentQueryModel = new ArticleQueryModel({
            useAgg: false,
            highlight: false,
            access: T.searchAccess,
            publicationId: T.documentModel.get("publicationId"),
            sort: "date-asc",
            pageSize: 50,

        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });

        T.listenTo(T.documentQueryModel, "change:publishedStart", T.renderDate);

        // requête pour avoir le nombre de résultats pour chaque documents
        // todo : recopier la recherche depuis le from
        T.articleQueryModel = new ArticleQueryModel({
            useAgg: true,
            aggSizes: {
                persons: 0,
                organizations: 0,
                geolocs: 0,
                events: 0,
                types: 0,
                periodicities: 0,
                publications: 0,
                wikitags: 0,
                themes: 0,
                documents: 50
            },
            highlight: false,
            access: T.searchAccess,
            publicationId: T.documentModel.get("publicationId"),
            sort: "date-asc",
            pageSize: 0,
            allTerms: T.queryModel.get("allTerms"),
            phrase: T.queryModel.get("phrase"),
            someTerms: T.queryModel.get("someTerms"),
            exact: T.queryModel.get("exact")
        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });

        T.render();
    },

    render: function () {
        var T = this,
            context = {
                results: [],
                isPremium: T.userModel.isPremium()
            };

        if (T.documentModel.fetched) {
            debug("render");
            context.readerUrl = function (result) {
                return T.readerUrl(result);
            };
            context.documentId = T.documentModel.get("id");
            if (T.documentQueryModel.get("results").length) {
                // on combine les résultats de la requête first (sur les documents) et second (sur les articles)
                var agg = T.articleQueryModel.get("aggregations").findWhere({ name: "documents" });
                if (agg) {
                    _.each(agg.get("agg").buckets, function (bucket) {
                        var result = T.documentQueryModel.get("results").findWhere({ id: bucket.key });
                        if (result) {
                            result.set("nbHits", bucket.doc_count);
                        }
                    });
                }
                context.results = T.documentQueryModel.get("results").toJSON();
            }

            T.$el.html(T.template(context));
            T.gotoCurrent();
            T.renderDate();
        }
    },

    renderDate: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart") || T.documentModel.get("published"));
        if (date_obj) {
            T.$(".month").text(STR["month_" + (date_obj.getUTCMonth() + 1)]);
            T.$(".year").text(date_obj.getUTCFullYear());
        }
    },

    gotoCurrent: function () {
        var T = this,
            $body = T.$(".calendar-body"),
            $line = T.$(".current");
        if ($line.length) {
            $body.animate({
                scrollTop: $body.scrollTop() + $line.position().top - 50
            },
                500
            );
        }
    },

    onNextMonthClicked: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart"));

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        // on ajoute 1 pour passer au mois suivant
        date_obj.setUTCMonth(date_obj.getUTCMonth() + 1);
        var month = date_obj.getUTCMonth() + 1;
        var year = date_obj.getUTCFullYear();

        T.queryDocumentList(month, year);
    },

    onPreviousMonthClicked: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart"));

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        // on enlève 1 pour passer au mois précédent
        date_obj.setUTCMonth(date_obj.getUTCMonth() - 1);
        var month = date_obj.getUTCMonth() + 1;
        var year = date_obj.getUTCFullYear();

        T.queryDocumentList(month, year);
    },

    onNextYearClicked: function () {
        var T = this;

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        var date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart")),
            month = date_obj.getUTCMonth() + 1,
            year = date_obj.getUTCFullYear() + 1;

        T.queryDocumentList(month, year);
    },

    onPreviousYearClicked: function () {
        var T = this;

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        var date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart")),
            month = date_obj.getUTCMonth() + 1,
            year = date_obj.getUTCFullYear() - 1;

        T.queryDocumentList(month, year);
    },

    onSearchAllIssuesClicked: function () {
        var T = this,
            search_str = "/search/#sort=score&tfPublications[0]=" + encodeURIComponent(T.documentModel.get("publicationTitle"));

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }
    },

    onSearchCurrentDateClicked: function () {
        var T = this,
            search_str = "/search/#sort=score&publishedStart=" + T.documentModel.get("published");

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }
    },

    onDocClicked: function (e) {
        var T = this,
            $link = $(e.currentTarget),
            route = $link.attr('href');

        e.preventDefault();
        e.stopPropagation();
        
        // on passe par le router pour ne pas sortir du mode plein écran
        if(route){
            route = route.substr(T.baseRoute.length);
            debug(route);
            T.app.router.navigate(
                route, {
                    trigger: true
                }
            );
        }

        return false;
    },

    readerUrl: function (result) {
        var T = this,
            document_id = result.id,
            publication_id = result.publicationId,
            number = result.pageNumber || 1,
            publication_title = result.publicationTitle,
            published = STR.date(result.published);

        var url = T.baseRoute + "/" + UrlUtil.slugify(publication_title) + "/" + UrlUtil.slugify(published) + "/" + publication_id + "/" + document_id + "/" + number;

        if (T.from) {
            url += "?from=" + encodeURIComponent(T.from);
            if(T.index){
                url +="&index="+T.index;
            }
        }
        return url;
    },

    queryDocumentList: function (month, year) {
        var T = this;

        if (!T.userModel.isPremium()) {
            return;
        }

        if (T.fetching) return;
        if (!month) {
            // si rien de précisé on prend la date du document
            var published = T.documentModel.get("published");
            month = parseInt(published.substr(5, 2));
            year = parseInt(published.substr(0, 4));
        }

        var last_day = DateUtil.lastDay(year, month);

        var date_start = year + "-" + month + "-01";
        var date_end = year + "-" + month + "-" + last_day;

        T.documentQueryModel.set({
            publishedStart: date_start,
            publishedEnd: date_end
        });
        T.articleQueryModel.set({
            publishedStart: date_start,
            publishedEnd: date_end
        });

        T.fetching = true;
        T.listenToOnce(T.documentQueryModel, "sync", T.onFirstQuerySync);
        T.documentQueryModel.search();

    },

    onFirstQuerySync: function () {
        var T = this;
        if (T.articleQueryModel.hasTerms()) {
            T.listenToOnce(T.articleQueryModel, "sync", function () {
                T.fetching = false;
                T.render();
            });
            T.articleQueryModel.search();
        }
        else {
            T.fetching = false;
            T.render();
        }
    },

    close: function () {
        var T = this;
        T.documentModel = null;
        T.userModel = null;
        T.documentQueryModel = null;
        T.articleQueryModel = null;
        T.queryModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"../../search/models/article-query-model":32,"../templates/calendar-template.html":13,"@immanens-com/pv5js/common/utils/date-util":38,"@immanens-com/pv5js/common/utils/url-util":41,"backbone":55,"debug":56,"jquery":58,"underscore":61}],23:[function(require,module,exports){
"use strict";
var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var template = require("../templates/classification-template.html");

/**
 * Retronews ClassificationView: display classification datas
 * Triggers:
 */
module.exports = Backbone.View.extend({

    template: _.template(template),
    model: null, // DocumentModel
    pageModel: null, // page model of current page

    events: {
        "click li": "onTagClicked"
    },

    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "change:page", T.onPageChanged);
    },

    render: function() {
        var T = this;

        if (!T.pageModel) {
            return;
        }

        var context = T.pageModel.toJSON();

        //defaults
        context.themes = context.themes || [];
        context.events = context.events || [];
        context.persons = context.persons || [];
        context.organizations = context.organizations || [];
        context.geolocs = context.geolocs || [];

        T.$el.html(T.template(context));

        T.updateMetadatas(context);

        return T;
    },

    /**
     * mise à jour des meta relatives à la page
     * ça aurait plus sa place dans le reader, mais bon ...
     */
    updateMetadatas: function(context) {
        var T=this;
        var page_width = T.pageModel.get("width"),
            page_height = T.pageModel.get("height"),
            thumbnail_max_width = 300,
            thumbnail_max_height = 400,
            thumbnail_width, thumbnail_height;

        var k = thumbnail_max_height / page_height;
        thumbnail_width = Math.round(k * page_width);

        if (thumbnail_width > thumbnail_max_width) {
            k = thumbnail_max_width / page_width;
            thumbnail_width = thumbnail_max_width;
            thumbnail_height = Math.round(k * page_height);
        } else {
            thumbnail_height = thumbnail_max_height;
        }

        var description="Archives de presse BnF";

        if(context.events.length){
            description+=" "+context.events.join(" ");
        }
        if(context.persons.length){
            description+=" "+context.persons.join(" ");
        }
        if(context.organizations.length){
            description+=" "+context.organizations.join(" ");
        }
        if(context.geolocs.length){
            description+=" "+context.geolocs.join(" ");
        }

        UrlUtil.meta("name", "description", description);

        UrlUtil.meta("property", "og:image:width", thumbnail_width);
        UrlUtil.meta("property", "og:image:height", thumbnail_height);
        UrlUtil.meta("property", "og:description", description);

        UrlUtil.meta("name", "twitter:description", description);

    },


    onTagClicked: function(e) {
        var T = this,
            $target = $(e.target),
            type = $target.data("type"),
            search_str = "/search#advancedUi=false&documentType=page&sort=score",
            value = $target.data("value");

        if (type == "theme") {
            var l1 = $target.data("l1"),
                l2 = $target.data("l2");

            search_str += "&tfThemes[0][l1]=" + l1 + "&tfThemes[0][l2]=" + l2;
        } else if (type == "event") {
            search_str += "&tfEvents[0]=" + value;
        } else {
            // ici on précise le terme pour avoir un highlight, contrairement à theme et event qui n'ont pas de correspondance dans le texte
            search_str += "&allTerms=" + value;
            if (type == "person") {
                search_str += "&tfPersons[0]=" + value;
            } else if (type == "geoloc") {
                search_str += "&tfGeolocs[0]=" + value;
            } else if (type == "organization") {
                search_str += "&tfOrganizations[0]=" + value;
            }
        }

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }

    },

    onPageChanged: function() {
        var T = this;

        if (T.pageModel) {
            T.stopListening(T.pageModel);
            T.pageModel = null;
        }
        T.pageModel = T.model.getPageModel(T.model.get("page"));

        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    close: function() {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});
},{"../templates/classification-template.html":14,"@immanens-com/pv5js/common/utils/url-util":41,"backbone":55,"jquery":58,"underscore":61}],24:[function(require,module,exports){
"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayAnnotationsView");

var AnnotationView                      = require("../views/annotation-view");

/**
 * overlay pour la pose et l'affichage des annotations
 * Trigger:
 */
module.exports=Backbone.View.extend({

    className:"overlay overlay-annotations",
    annotationCollection:null,  // AnnotationCollection
    pageModel:null,             // PageModel
    page:0,

    events:{
       "pointerdown":"onDragStart"
    },

    initialize:function(options){
        var T=this;
        
        T._pointers={};
        T._dragStartPoint={x:0,y:0};
        T._dragStartSelection={};
        T._abortDrag=false;

        _.extend(T, options);

        if(T.active){
            T.$el.addClass("active");
        }

        T.listenTo(T.pageModel,"sync",T.render);
        
        T.listenTo(T.annotationCollection, "add", T.addOne);
        T.listenTo(T.annotationCollection, "reset", T.addAll);

        T.render();
    },

    render:function(){
        var T=this;
       
        T.$el.html("");

        if(T.pageModel.fetched){
           debug("render annotations page %d",T.page);

           T.addAll();
          
        }
    },

    addOne: function( annotation ) {
        var T=this;
        if(annotation.get("page")==T.page){
            var view=new AnnotationView({ 
                model: annotation,
                app:T.app
            });
            view.render();
            T.listenTo(view,"click",T.onAnnotationClicked);
            T.$el.append(view.el);
        }
    },
    
    addAll: function() {
        var T = this;
        T.$el.html("");
        T.annotationCollection.each(T.addOne,T);
    },

    onAnnotationClicked:function(annotation_model){
        this.trigger("click:annotation",annotation_model);
    },

    onDragStart:function(e){
        var T=this;
        
        if(!T.$el.hasClass("active")){
            return;
        }

        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);

        if(keys.length==1){
            T.dragStartDate=Date.now();
            T._dragStartPoint.x=e.pageX;
            T._dragStartPoint.y=e.pageY;
            $(window).on("pointerup.ov-annot",function(e){T.onDragEnd(e);});
            $(window).on("pointermove.ov-annot",function(e){T.onDragMove(e);});
            $(window).on("pointercancel.ov-annot",function(e){T.onDragEnd(e);});
        }
        else{
            T._abortDrag=true;
        }
    },

    onDragMove:function(e){ //jshint ignore: line
        var T=this;

        if(T._abortDrag)return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };
    },

    onDragEnd:function(e){
        var T=this;

        if(!T.$el.hasClass("active")){
            return;
        }

        var last_x=T._pointers[e.originalEvent.pointerId].pageX;
        var last_y=T._pointers[e.originalEvent.pointerId].pageY;

        delete T._pointers[e.originalEvent.pointerId];

        var keys=_.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if(!keys.length){
            $(window).off(".ov-annot");
            T._abortDrag=false;

            if(Date.now()-T.dragStartDate<400 && Math.abs(last_x-T._dragStartPoint.x)<3&& Math.abs(last_y-T._dragStartPoint.y)<3){
                // c'est un click
                var new_x=((T._dragStartPoint.x-T.$el.offset().left)*100)/T.$el.parent().width();
                var new_y=((T._dragStartPoint.y-T.$el.offset().top)*100)/T.$el.parent().height();

                var new_model=T.annotationCollection.create({
                    publicationId:T.pageModel.get("publicationId"),
                    documentId:T.pageModel.get("documentId"),
                    page:T.pageModel.get("id"),
                    left:new_x,
                    top:new_y
                },{
                    error: function(){ 
                        T.app.notify({
                            text:STR.unable_to_save,
                            type:"error",
                            timeout:4000
                        });
                    }
                });

                T.onAnnotationClicked(new_model);
            }
            else{
                //sinon c'est un drag de la page entière
            }
        }
    },
    

    close:function(){
        var T=this;
        T.annotationCollection=null;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"../views/annotation-view":20,"backbone":55,"debug":56,"jquery":58,"underscore":61}],25:[function(require,module,exports){
"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayBlocksView");

/**
 * Retronews PageSemanticView: overlay view displaying text blocks from ocr
 * Trigger:
 * - "click:block":
 */
module.exports=Backbone.View.extend({

    model:null,         // RetronewsPageSemanticModel
    className:"overlay overlay-blocks",
    events:{
        "pointerdown .block":"onPointerDown",
        "pointerup .block":"onPointerUp"
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        T._pageX=0;
        T._pageY=0;
        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.model,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this;

        T.$el.html("");
        if(T.model.fetched){
            debug("render blocks page "+T.page);
            var blocks=T.model.get("blocks"),
                width=T.model.get("width"),
                height=T.model.get("height");

            if(blocks){
                _.each(blocks,function(block){
                     var $div=$("<div/>",{
                        class:"block",
                        id:block.id
                    });
                    $div.css({
                        top:(block.vpos*100/height)+"%",
                        left:(block.hpos*100/width)+"%",
                        height:(block.height*100/height)+"%",
                        width:(block.width*100/width)+"%"
                    });
                    T.$el.append($div);
                });
            }
        }
    },

    onPointerDown:function(e){
        var T=this;
        T._pageX=e.pageX;
        T._pageY=e.pageY;
    },

    onPointerUp:function(e){
        var T=this,
            distance=Math.sqrt(Math.pow(T._pageX-e.pageX, 2) + Math.pow(T._pageY-e.pageY, 2));

        if(distance<4){
            T.trigger("click:block",T,e.target.id);
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"backbone":55,"debug":56,"jquery":58,"underscore":61}],26:[function(require,module,exports){
"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

/**
 * outil pour découpage d'une zone rectangulaire
 * Trigger:
 */
module.exports=Backbone.View.extend({

    className:"overlay overlay-crop",
    model:null, // PageModel
    minWidth:1,
    maxWidth:100,
    minHeight:1,
    maxHeight:100,
    events:{
        "pointerdown":"onDragStart"
    },

    initialize:function(options){
        var T=this;

        T.selection={
            x:30,
            y:40,
            width:40,
            height:20
        };

        _.extend(T, options);

        T._pointers={};
        T._dragStartPoint={x:0,y:0};
        T._dragStartSelection={};
        T._abortDrag=false;



        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.pageModel,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this,
            d="<div/>";

        T.$el.html("");

        if(T.pageModel.fetched){
            T.$cacheTop=$(d,{
                class:"cache top",
            });
            T.$el.append(T.$cacheTop);
            T.$cacheLeft=$(d,{
                class:"cache left",
            });
            T.$el.append(T.$cacheLeft);
            T.$cacheRight=$(d,{
                class:"cache right",
            });
            T.$el.append(T.$cacheRight);
            T.$cacheBottom=$(d,{
                class:"cache bottom",
            });
            T.$el.append(T.$cacheBottom);

            T.$handleCenter=$(d,{
                class:"handle center",
            });
            T.$handleCenter.data("handle","center");
            T.$el.append(T.$handleCenter);

            T.$handleLeft=$(d,{
                class:"handle left",
            });
            T.$handleLeft.data("handle","left");
            T.$el.append(T.$handleLeft);

            T.$handleTop=$(d,{
                class:"handle top",
            });
            T.$handleTop.data("handle","top");
            T.$el.append(T.$handleTop);

            T.$handleRight=$(d,{
                class:"handle right",
            });
            T.$handleRight.data("handle","right");
            T.$el.append(T.$handleRight);

            T.$handleBottom=$(d,{
                class:"handle bottom",
            });
            T.$handleBottom.data("handle","bottom");
            T.$el.append(T.$handleBottom);

            T.layout();
        }
    },

    _clampWidth:function(width){
        var T=this;
        if(width<T.minWidth){
            width=T.minWidth;
        }else if(width>T.maxWidth){
            width=T.maxWidth;
        }
        return width;
    },

    _clampHeight:function(height){
        var T=this;
        if(height<T.minHeight){
            height=T.minHeight;
        }else if(height>T.maxHeight){
            height=T.maxHeight;
        }
        return height;
    },

    setSelection:function(new_sel,clamp){
        var T=this,
            x=new_sel.x,
            y=new_sel.y,
            height=new_sel.height,
            width=new_sel.width;

        if(clamp){
            // clamp size
            width=T._clampWidth(width);
            height=T._clampWidth(height);

            // clamp position
            if(x<0){
                x=0;
            }
            if(y<0){
                y=0;
            }
            if(x+width>100){
                width=100-x;
            }
            if(y+height>100){
                height=100-y;
            }
        }

        T.selection.x=x;
        T.selection.y=y;
        T.selection.width=width;
        T.selection.height=height;
        T.layout();
    },

    layout:function(){
        var T=this;

        // place each cache and handles
        T.$cacheTop.css({
            height:T.selection.y+"%"
        });
        T.$cacheBottom.css({
            top:(T.selection.y+T.selection.height)+"%",
            height:(100-T.selection.height-T.selection.y)+"%"
        });
        T.$cacheLeft.css({
            top:T.selection.y+"%",
            height:T.selection.height+"%",
            width:T.selection.x+"%"
        });
        T.$cacheRight.css({
            top:T.selection.y+"%",
            height:T.selection.height+"%",
            width:(100-T.selection.x-T.selection.width)+"%"
        });
        T.$handleCenter.css({
            top:(T.selection.y+(T.selection.height/2))+"%",
            left:(T.selection.x+(T.selection.width/2))+"%"
        });
        T.$handleLeft.css({
            top:(T.selection.y+(T.selection.height/2))+"%",
            left:T.selection.x+"%"
        });
        T.$handleRight.css({
            top:(T.selection.y+(T.selection.height/2))+"%",
            left:T.selection.x+T.selection.width+"%"
        });
        T.$handleTop.css({
            top:T.selection.y+"%",
            left:T.selection.x+(T.selection.width/2)+"%"
        });
        T.$handleBottom.css({
            top:(T.selection.y+T.selection.height)+"%",
            left:T.selection.x+(T.selection.width/2)+"%"
        });

    },

    onDragStart:function(e){
        var T=this;

        if(T.$el.hasClass("inactive")){
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);

        if(keys.length==1){
            T._dragStartPoint.x=e.pageX;
            T._dragStartPoint.y=e.pageY;
            $(window).on("pointermove.ov-crop",function(e){T.onDragMove(e);});
            $(window).on("pointerup.ov-crop",function(e){T.onDragEnd(e);});
            $(window).on("pointercancel.ov-crop",function(e){T.onDragEnd(e);});

            T._dragHandle=$(e.target).data("handle");
            if(T._dragHandle){
                // handle drag
                T._dragStartSelection=_.clone(T.selection);
            }
            else{
                // new selection
                var offset=T.$el.offset(),
                    page_x=(e.pageX-offset.left)*100/T.$el.width(),
                    page_y=(e.pageY-offset.top)*100/T.$el.height();
                T._dragStartSelection.x=page_x; // todo : compute start point
                T._dragStartSelection.y=page_y;
                T._dragStartSelection.width=T.minWidth;
                T._dragStartSelection.height=T.minHeight;
            }
        }
        else{
            T._abortDrag=true;
        }

    },

    onDragMove:function(e){ //jshint ignore: line
        var T=this;

        if(T._abortDrag)return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);
        if(keys.length==1){
            var dX=(e.pageX-T._dragStartPoint.x)*100/T.$el.width(), // %
                dY=(e.pageY-T._dragStartPoint.y)*100/T.$el.height(), // %
                clamp=false;

            //console.log("dx: "+dX);

            var new_sel=_.clone(T._dragStartSelection);

            if(T._dragHandle){
                if(T._dragHandle=="center"){
                    new_sel.x=T._dragStartSelection.x+dX;
                    if(new_sel.x<0){
                        new_sel.x=0;
                    }
                    if(new_sel.x+new_sel.width>100){
                        new_sel.x=100-new_sel.width;
                    }
                    new_sel.y=T._dragStartSelection.y+dY;
                    if(new_sel.y<0){
                        new_sel.y=0;
                    }
                    if(new_sel.y+new_sel.height>100){
                        new_sel.y=100-new_sel.height;
                    }
                }
                else if(T._dragHandle=="left"){
                    new_sel.width=T._clampWidth(T._dragStartSelection.width-dX);
                    new_sel.x=T._dragStartSelection.x+T._dragStartSelection.width-new_sel.width;
                    if(new_sel.x<0){
                        new_sel.x=0;
                        new_sel.width=T._dragStartSelection.width+T._dragStartSelection.x;
                    }
                }
                else if(T._dragHandle=="right"){
                    new_sel.width=T._clampWidth(T._dragStartSelection.width+dX);
                    if(T._dragStartSelection.x+new_sel.width>100){
                        new_sel.width=100-T._dragStartSelection.x;
                    }
                }
                else if(T._dragHandle=="top"){
                    new_sel.height=T._clampHeight(T._dragStartSelection.height-dY);
                    new_sel.y=T._dragStartSelection.y+T._dragStartSelection.height-new_sel.height;
                    if(new_sel.y<0){
                        new_sel.y=0;
                        new_sel.height=T._dragStartSelection.height+T._dragStartSelection.y;
                    }
                }
                else if(T._dragHandle=="bottom"){
                    new_sel.height=T._clampHeight(T._dragStartSelection.height+dY);
                    if(T._dragStartSelection.y+new_sel.height>100){
                        new_sel.height=100-T._dragStartSelection.y;
                    }
                }
            }
            else{
                new_sel.width=dX;
                new_sel.height=dY;
                clamp=true;
            }
            T.setSelection(new_sel,clamp);
        }

    },

    onDragEnd:function(e){
        var T=this;

        delete T._pointers[e.originalEvent.pointerId];

        var keys=_.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if(!keys.length){
            $(window).off(".ov-crop");
            T._abortDrag=false;
            //T.$el.removeClass("grabbing");
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }
});

},{"backbone":55,"jquery":58,"underscore":61}],27:[function(require,module,exports){
"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayEntitiesView");    //https://github.com/visionmedia/debug


/**
 * OverlayEntitiesView : overlay view displaying semantic datas (entities)
 */
module.exports=Backbone.View.extend({

    model:null,         // RetronewsPageSemanticModel
    className:"overlay overlay-entities",

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.model,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this;

        T.$el.html("");
        if(T.model.fetched){
            debug("render, page "+T.page);
            var entities=T.model.get("entities"),
                width=T.model.get("width"),
                height=T.model.get("height");

            if(entities.blocks){
                _.mapObject(entities.blocks, function(block/*, key*/) {
                    _.each(block,function(entity){
                        if(entity.type=="Geo"||entity.type=="Person"||entity.type=="Organisation"){
                            _.each(entity.boxes,function(box){
                                 var $div=$("<div/>",{
                                    class:"entity entity-"+entity.type
                                });
                                $div.css({
                                    top:(box.top*100/height)+"%",
                                    left:(box.left*100/width)+"%",
                                    height:(box.height*100/height)+"%",
                                    width:(box.width*100/width)+"%"
                                });
                                T.$el.append($div);

                            });
                        }
                    });
                });
            }
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"backbone":55,"debug":56,"jquery":58,"underscore":61}],28:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:OverlayHighlightView");

/**
 * Retronews : positionne un rectangle coloré (css) en surimpression d'une page de document
 */
module.exports = Backbone.View.extend({

    pageModel: null, // pageModel
    highlight: null,
    className: "overlay overlay-highlight",
    events: {},

    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    render: function() {
        var T = this;

        T.$el.html("");
        if (T.pageModel.fetched && T.highlight) {
            debug("render " + T.page);
            var width = T.pageModel.get("width"),
                height = T.pageModel.get("height");

            var $div = $("<div/>", {
                class: "highlight"
            });
            $div.css({
                top: (T.highlight.y * 100 / height) + "%",
                left: (T.highlight.x * 100 / width) + "%",
                height: (T.highlight.height * 100 / height) + "%",
                width: (T.highlight.width * 100 / width) + "%"
            });
            T.$el.append($div);
        }
    },

    close: function() {
        var T = this;
        T.pageModel = null;
        T.highlight = null;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"backbone":55,"debug":56,"jquery":58,"underscore":61}],29:[function(require,module,exports){
"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlaySearchView");

/**
 * Retronews : overlay view displaying results from search
 */
module.exports=Backbone.View.extend({

    pageModel:null,             // PageModel
    queryModel:null,            // ArticleQueryModel
    className:"overlay overlay-search",
    events:{
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.pageModel,"sync",T.render);
        T.listenTo(T.queryModel,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this;

        T.$el.html("");
        if(T.queryModel.fetched && T.pageModel.fetched){
            debug("render search page "+T.page);

            if(T.queryModel.get("results").length){
                var width=T.pageModel.get("width"),
                    height=T.pageModel.get("height");

                T.queryModel.get("results").each(function(hit){
                    var hl=hit.get("highlight");

                    if(hl && hl.positions){

                        _.each(hl.positions,function(word_pos){
                            var $div=$("<div/>",{
                                class:"result"
                            });
                            $div.css({
                                top:(word_pos.p[1]*100/height)+"%",
                                left:(word_pos.p[0]*100/width)+"%",
                                height:((word_pos.p[3]-word_pos.p[1])*100/height)+"%",
                                width:((word_pos.p[2]-word_pos.p[0])*100/width)+"%"
                            });
                            T.$el.append($div);
                        });
                    }
                    
                });

            }
        }
    },

    close:function(){
        var T=this;
        T.pageModel=null;
        T.queryModel=null;
        T.stopListening();
        T.undelegateEvents();
    }
});
},{"backbone":55,"debug":56,"jquery":58,"underscore":61}],30:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:ReaderView"); //https://github.com/visionmedia/debug

// Models
var PageSemanticModel = require("../models/page-semantic-model");
var UserModel = require("../../common/models/user-model");
var SelectedDocumentModel = require("../../common/models/selected-document-model");
var ArticleQueryModel = require("../../search/models/article-query-model");
var SharedCropModel = require("../models/shared-crop-model");

// Collections
var AnnotationCollection = require("../collections/annotation-collection");

// Views
var ClassificationView = require("../views/classification-view");
var OverlayEntitiesView = require("../views/overlay-entities-view");
var OverlayBlocksView = require("../views/overlay-blocks-view");
var OverlaySearchView = require("../views/overlay-search-view");
var OverlayCropView = require("../views/overlay-crop-view");
var OverlayAnnotationsView = require("../views/overlay-annotations-view");
var OverlayHighlightView = require("../views/overlay-highlight-view");
var BlocksView = require("../views/blocks-view");
var CalendarView = require("../views/calendar-view");
var SearchNextResultsView = require('../views/search-next-results-view');

// From pv5js
var DocumentModel = require("@immanens-com/pv5js/reader/models/document-model");
var DocumentView = require("@immanens-com/pv5js/reader/views/document-view");
var PageSliderView = require("@immanens-com/pv5js/reader/views/page-slider-view");
var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");
var SearchInputView = require("@immanens-com/pv5js/search/views/search-input-view");
var DomUtil = require("@immanens-com/pv5js/common/utils/dom-util");


var templates = {
    page: require("../templates/page-template.html"),
    pageSliderKnob: require("../templates/page-slider-knob-template.html"),
    pageSliderThumb: require("../templates/page-slider-thumb-template.html"),
    navigation: require("../templates/navigation-template.html"),
    searchNextResults: require("../templates/search-next-results-template.html")
};

/**
 * Retronews ReaderView : Main view for retronews reader page.
 * It contains a document surface, some toolbars and many other view displaying page's related informations (classification)
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    documentId: 0, //
    publicationId: 0, //
    routePublicationTitle: null, // titre à utiliser dans l'url
    routeDocumentDate: null, // date à utiliser dans l'url
    page: 1, // starting page
    fit: null, // try to fit specified rectangle {page,x,y,w,h} at startup
    articleId: null, // ouvre sur un article particulier
    from: "",
    embedWidth: 560,
    embedHeight: 315,
    embed: false,
    sliderHeight: 12,
    blockMode: "page",
    index: false,

    subViews: null, // array of subviews
    overlayViews: null, // array of page overlay views

    el: "#app-reader",
    events: {
        "click .button-down": "onMoreInfoClicked",
        "click .scroll-top": "onScrollTopClicked",
        "click .full-screen": "onFullscreenClicked",
        "click .help": "onHelpClicked",
        "click .image-inverse": "onImageInverseClicked",
        "click .entities": "onEntitiesClicked",
        "click .zoom-in": "onZoomInClicked",
        "click .zoom-out": "onZoomOutClicked",
        "click .ocr": "onOcrClicked",
        "click .calendar": "onCalendarClicked",
        "click .tb-top .basket": "onBasketClicked",
        "click .action.add-to-selection": "onAddToSelectionClicked",
        "click .access-selection": "onAccessSelectionClicked",
        "click .action.add-to-crop": "onAddToCropClicked",
        "click .action.url-crop": "onUrlCropClicked",
        "click .action.embed-crop": "onEmbedCropClicked",
        "click .action.download-crop": "onDownloadCropClicked",
        "click .access-crop": "onAccessCropClicked",
        "click .annotation-delete": "onDeleteAnnotation",
        "click .action.annotation-save": "onSaveAnnotation",
        "click .download-document": "onDownloadDocumentClicked",
        "click .print-document": "onPrintDocumentClicked",
        "click .next-page": "onNextPage",
        "click .previous-page": "onPreviousPage",
        "click .subscribe": "onSubscribeClicked",
        "click .login": "onLoginClicked",
        "click .register": "onRegisterClicked",
        "click .facebook": "onShareFacebookClicked",
        "click .twitter": "onShareTwitterClicked",
        "click .action.email": "onShareEmailClicked",
        "click .result .next": "onNextResult",
        "click .result .previous": "onPreviousResult",
        "click .tb-top .button": "onDisplayPanel",
        "click .tb-top .close": "onClosePanel",
        "click .tb-top .minimize": "onMinimizePanel",
        "click .tb-right .basket": "onBasketClicked",
        "click .tb-bottom .retronews-go": "onDiscoverClicked",
        "click .embed-popup": "onEmbedPopupClicked",
        "change #embed-size-select": "onEmbedSizeChanged",
        "change #embed-custom-width": "onEmbedWidthChanged",
        "change #embed-custom-height": "onEmbedHeightChanged",
        "focus #print-text-some-pages": "onPrintTextFocused",
        "focus #download-text-some-pages": "onDownloadTextFocused",
        "focus #embed-code": "onEmbedCodeFocused",
        "keyup #embed-custom-width": "limitInputToNumbers",
        "keyup #embed-custom-height": "limitInputToNumbers",
        "keyup #print-text-some-pages": "limitInputToNumbers",
        "keyup #download-text-some-pages": "limitInputToNumbers",
        "pointerdown .overlay-embed": "onOverlayEmbedTouchStart",
        "touchstart .overlay-embed": "onOverlayEmbedTouchStart",
        "mousewheel .overlay-embed":"onOverlayEmbedMouseWheel",
        "DOMMouseScroll .overlay-embed":"onOverlayEmbedMouseWheel",
        "click .activate-embed":"onActivateEmbed"
    },

    /**
     * @param  {Object} options must contains the "app" object
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.subViews = [];
        T.overlayViews = []; // page overlays
        T._semanticModels = []; // page semantic models

        // user
        T.userModel = new UserModel(T.app.user);

        // en admin on veut voir tous les documents, les utilisateurs eux ne doivent voir que ce qui à été validé (access=public)
        T.searchAccess = T.userModel.isAdmin() ? null : "public";

        // search query for entire document
        T.documentQueryModel = new ArticleQueryModel({
            useAgg: false,
            documentId: T.documentId,
            publicationId: T.publicationId,
            highlight: false,
            sort: "page-number",
            access: T.searchAccess
        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });
        T.listenTo(T.documentQueryModel, "sync", T.onDocumentSearchEnd);
        T._pageQueryModels = []; // search queries for each page

        T.pageTermsView = new SearchInputView({
            model: T.documentQueryModel,
            el: "#search-input-phrase",
            fieldName: "phrase"
        });
        T.listenTo(T.pageTermsView, "submit", T.onSubmitSearch);
        T.subViews.push(T.pageTermsView);

        // le mode embed est passé en paramètre
        if (T.app.embed) {
            T.embed = true;
            T.$el.addClass("embed");
        }

        // settings
        T._entitiesShown = false;
        T._blocksShown = false;
        T._calendarShown = false;
        T._sidePanel = false;
        T._imageInverted = false;
        T._cropShown = false;
        T._annotateActive = false;

        T.readSettings();

        if (T.app.bot) {
            // on affiche le texte pour les robots
            T._sidePanel = true;
            T._blocksShown = true;
            T.$el.addClass("bot");
        }

        if (T.articleId) {
            T._blocksShown = true; // on affiche un article au chargement du document
            T.blockMode = "article";
        }

        $(window).on("unload.rn", function () {
            T.writeSettings();
        });

        //console.log("from: "+T.from);

        if (T.userModel.isPremium()) {
            T.$el.addClass("premium");
        }
        if (T.userModel.isBnf()) {
            T.$el.addClass("bnf");
        }
        if (T.userModel.isAdmin()) {
            T.$el.addClass("admin");
        }
        if (T.userModel.isLoggedIn()) {
            T.$el.addClass("logged");
        }

        // gère l'affichage de panneaux selon le niveaux de l'utilisateur
        if (T.userModel.isPremium()){
            if(T.userModel.isLoggedIn()){
                //
                T.$(".dropdown .content.premium .verified").show();
                T.$(".dropdown .content.premium .lambda").hide();
                T.$(".dropdown .content.premium .anonymous").hide();
             }
            else{
                //
                T.$(".dropdown .content.premium.need-login .verified").hide();
                T.$(".dropdown .content.premium.need-login .lambda").hide();
                T.$(".dropdown .content.premium.need-login .anonymous").show();
                T.$(".dropdown .content.premium:not(.need-login) .verified").show();
                T.$(".dropdown .content.premium:not(.need-login) .lambda").hide();
                T.$(".dropdown .content.premium:not(.need-login) .anonymous").hide();
            }
        }
        else{
            T.$(".dropdown .content.premium .verified").hide();
            T.$(".dropdown .content.premium .lambda").show();
            T.$(".dropdown .content.premium .anonymous").hide();
        }
        

        if (T.from && T.from.substr(0, 7) == "/search") {
            T.$el.addClass("from-search");

            var from_split = T.from.split("#", 2);
            if (from_split.length == 2 && T.index !== false) {
                var query_string = decodeURIComponent(from_split[1]);
                T.searchNextResultsView = new SearchNextResultsView({
                    app: T.app,
                    searchQuery: query_string,
                    index: T.index,    
                    el: ".search-next-results",
                    template: templates.searchNextResults
                });
                T.subViews.push(T.searchNextResultsView);
            }            
        }

        // fullscreen
        $(document).on("webkitfullscreenchange.rn mozfullscreenchange.rn fullscreenchange.rn MSFullscreenChange.rn", function (e) {
            T.onFullscreenChanged(e);
        });

        T.documentModel = new DocumentModel({
            id: T.documentId,
            publicationId: T.publicationId
        }, {
                pv5api: T.app.pv5api
            });

        // annotation pour tout le document
        T.annotationCollection = new AnnotationCollection(null, {
            rnapi: T.app.rnapi,
            documentId: T.documentId,
            publicationId: T.publicationId
        });

        // page thumbnail slider view
        T.pageSliderView = new PageSliderView({
            model: T.documentModel,
            el: ".page-slider",
            templateKnob: templates.pageSliderKnob,
            templateThumb: templates.pageSliderThumb,
            embed: T.embed
        });
        T.subViews.push(T.pageSliderView);

        // main document view
        T.documentView = new DocumentView({
            model: T.documentModel,
            el: ".document-view",
            pageTemplate: templates.page,
            zoomMax: 2,
            embed: T.embed
        });
        T.listenTo(T.documentView, "add:page-view", T.onPageViewAdded);
        T.listenTo(T.documentView, "render:page-view", T.onPageViewRendered);
        T.listenTo(T.documentView, "remove:page-view", T.onPageViewRemoved);
        T.subViews.push(T.documentView);


        if (!T.embed) {
            // view nécessaires pour le lecteur complet seulement
            // classification datas
            T.classificationView = new ClassificationView({
                model: T.documentModel,
                el: ".classification article",
                userModel: T.userModel,
                app: T.app
            });
            T.subViews.push(T.classificationView);

            // add link to see all issues of this publication
            T.$(".see-all-issues a").attr("href", "/search"); // todo : update url
        }
        else {
            // if embedded and in retronews.fr, don't display the subscribe button
            try {
                var url = (window.location != window.parent.location) ? document.referrer : document.location.href;

                if(url.indexOf('retronews.fr') !== -1) {
                    T.$el.addClass("bnf-embed");
                }
            }
            catch (err) {
                debug('cannot access parent url');
            }
            T.$overlayEmbed=T.$(".overlay-embed");
        }

        // render each sub views
        T.subViews.forEach(function (view) {
            view.render();
        });

        T.echoVersion();
        T.updateNavigation();

        $(document).on("keydown.rn", function (e) {
            T.onKeyDown(e);
        });
        $(document).on("keyup.rn", function (e) {
            T.onKeyUp(e);
        });

        T.listenTo(T.app, "app:notify", T.notify);

        T.listenTo(T.documentModel, "sync", T.onDocumentLoaded);
        T.listenTo(T.documentModel, "change:page", T.onPageChanged);

        T.documentModel.fetch({
            error: function () {
                T.notify({
                    text: STR.document_not_found,
                    type: "error",
                    timeout: 4000
                });
            }
        });



        $(window).on("resize.rn", function () {
            T.onResize();
        });

    },

    onResize: function () {
        var T = this;
        T.pageSliderView.resize();
        T.documentView.resize();
        // on limite la hauteur des panneau
        var height = T.$(".document-view").height() - 36; // hauteur du header
        T.$(".dropdown > .content").css("max-height", height);
    },

    writeSettings: function () {
        var T = this;

        // si mode embed on ne sauve pas les settings
        if (T.embed) return;

        var settings = {
            sidePanel: T._sidePanel,
            entitiesShown: T._entitiesShown,
            blocksShown: T._blocksShown,
            calendarShown: T._calendarShown,
            imageInverted: T._imageInverted,
            blockMode: T.blockMode
        };

        localStorage.setItem("reader-settings", JSON.stringify(settings));
    },

    readSettings: function () {
        var T = this;

        // si mode embed on ne tient pas compte des settings
        if (T.embed) return;

        var settings = JSON.parse(localStorage.getItem("reader-settings"));
        if (settings) {
            T._entitiesShown = settings.entitiesShown || T._entitiesShown;
            T._blocksShown = settings.blocksShown || T._blocksShown;
            T._calendarShown = settings.calendarShown || T._calendarShown;
            T._sidePanel = settings.sidePanel || T._sidePanel;
            T._imageInverted = settings.imageInverted || T._imageInverted;
            T.blockMode = settings.blockMode || T.blockMode;
        }
    },

    onDocumentLoaded: function () {
        var T = this;

        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }

        T.updateDocumentTitle();

        T.documentQueryModel.set("pageSize", T.documentModel.get("nbPages") * 20); // on multiplie par 20 car on ne peut pas avoir plus de 20 articles par page

        if (T.from && T.from.substr(0, 7) == "/search") {

            // on vient de la recherche, on relance la même recherche en spécifiant le document actuel
            var from_split = T.from.split("#", 2);
            if (from_split.length == 2) {
                var query_string = decodeURIComponent(from_split[1]);
                var temp_query = new ArticleQueryModel({}, {
                    pv5api: T.app.pv5api
                });
                temp_query.setQueryString(query_string);
                // on vérifie que ce n'est pas une recherche sans mots, avec juste des filtres par exemple auquel cas on aurait rien à highlighter
                if (temp_query.hasTerms()) {
                    // on recopie les champs utiles dans la recherche document
                    T.copyQueryTerms(temp_query, T.documentQueryModel);
                    T.documentQueryModel.search();
                }
            }
        }

        if (T._blocksShown) {
            T.displayBlocks(T._blocksShown);
        } else if (T._calendarShown) {
            T.displayCalendar(T._calendarShown);
        }
        T.imageInverse(T._imageInverted);
        T.displayEntities(T._entitiesShown);
        T.documentView.gotoPage(T.page, false, T.fit);

        if (T.userModel.isLoggedIn()) {
            T.annotationCollection.fetch();
        }
    },

    onPageChanged: function () {
        var T = this;

        if (!T.articleId) {
            // détection changement de page au fil de l'eau ou changement de page initial ?
            T.currentArticleId = null;
        }

        T.updateRoute();
        T.updatePageTitle();

        if (T._blocksShown) {
            T.updateBlocksView();
        }

        T.trackPage();
    },

    trackPage: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        if (_.isFunction(T.app.trackPage)) {
            var doc_obj = _.clone(T.documentModel.toJSON());
            delete (doc_obj.pages);
            T.app.trackPage(doc_obj);
        }

        // tracking google analytics par défaut
        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {

            var pubtitle = T.documentModel.get("publicationTitle");
            var pubid = T.documentModel.get("publicationId");
            var doctitle = T.documentModel.get("title");
            var docid = T.documentModel.get("id");
            var docdate = T.documentModel.get("published");
            var page = T.documentModel.get("page");
            var year = docdate.split("-")[0];

            var path = T.app.googleAnalytics.path;
            path += "/" + pubtitle + "_" + pubid + "/" + year + "/" + doctitle + "_" + docid + "/" + page;
            debug("ga tracking page %s", path);
            window.ga("send", "pageview", path);
        }

    },

    trackEventReader: function (label) {
        this.trackEvent("lecteur", (this.embed ? 'embedded' : 'normal'), label);
    },

    trackEvent: function (category, action, label) {
        var T = this;

        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {
            debug("ga tracking event %s %s %s", category, action, label);
            window.ga("send", "event", category, action, label);
        }
    },


    getSemanticModel: function (page) {
        var T = this,
            semantic_model = _.findWhere(T._semanticModels, {
                id: page
            });

        if (!semantic_model) {
            semantic_model = new PageSemanticModel({
                publicationId: T.publicationId,
                documentId: T.documentId,
                id: page
            }, {
                    pv5api: T.app.pv5api
                });
            T._semanticModels.push(semantic_model);

            if (!T.documentModel.get("isTextMissing")) {
                semantic_model.fetch();
            }
        }
        return semantic_model;
    },

    updateRoute: function () {
        var T = this,
            route = T.documentModel.get("publicationId") + "/" + T.documentModel.get("id") + "/" + T.documentModel.get("page");

        if (T.routePublicationTitle && T.routeDocumentDate) {
            route = T.routePublicationTitle + "/" + T.routeDocumentDate + "/" + route;
        }

        if (T.embed) {
            // en mode embed, on met à jour le lien vers la page également
            T.$(".goto-document").attr("href", T.canonicalReaderUrl());

            // on ne met pas à jour la route en mode embed pour avoir une référence constante avec le paramètre fit
            return;
        }

        if (T.currentArticleId) {
            route += "/" + T.currentArticleId;
        }

        if (T.from && T.page == T.documentModel.get("page")) {
            route += "?from=" + encodeURIComponent(T.from) + (T.index !== false && T.index !== undefined ? '&index='+T.index : '');
        }

        T.app.router.navigate(
            route, {
                trigger: false,
                replace: true
            }
        );
    },

    /**
     * mise à jour du titre du journal et de la référence du document
     * fait une fois lors du chargement du modèle de document
     */
    updateDocumentTitle: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var pub_title = T.documentModel.get("publicationTitle"),
            doc_title = STR.date(T.documentModel.get("published"));
        T.$(".tb-top .ref .ref-publication").text(pub_title + ", ");
        T.$(".tb-top .ref .ref-title").text(doc_title + ", ");

    },

    updatePageTitle: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        // update title and metadatas
        var page_title = "p. " + T.documentModel.get("page") + "/" + T.documentModel.get("nbPages");
        T.$(".tb-top .ref .ref-page").text(page_title);
    },

    /**
     * [updateEmbedCode description]
     * @param  {[type]} type   [description]
     * @param  {[type]} width  [description]
     * @param  {[type]} height [description]
     * @return {[type]}        [description]
     */
    updateEmbedCode: function (src, width, height) {
        var T = this;

        if (!src) return;

        T.currentEmbedSrc = src;

        var code = "<iframe width=\"" + width + "\" height=\"" + height + "\" src=\"" + src + "\" frameborder=\"0\"></iframe>";

        T.$("#embed-code").val(code);

        if (T.openPanel == "embed") {
            T.displayEmbedPreview(true);
        }
    },

    /**
     * mise à jour du code de la textarea du code embed avec la page courante
     */
    updateEmbedCodePage: function () {
        var T = this;
        var url = T.canonicalReaderUrl(false, false, true);

        var current_page = T.documentModel.get("page"),
            page_model = T.documentModel.getPageModel(current_page);

        if (page_model.fetched) {
            T.embedRatio = page_model.get("width") / page_model.get("height");
        } else {
            T.embedRatio = 1;
        }

        var size = T.getEmbedSize();
        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "ratio") {
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(url, size.width, new_height);
        } else {
            T.updateEmbedCode(url, size.width, size.height);
        }
    },

    /**
     * Ecrit le code pour l'embed du crop dans le textarea du panneau embed
     */
    onEmbedCropClicked: function () {
        var T = this;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var src = T.canonicalReaderUrl(false, crop, true);
        T.embedRatio = crop.width / crop.height;

        var size = T.getEmbedSize();

        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "ratio") {
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(src, size.width, new_height);
        } else {
            T.updateEmbedCode(src, size.width, size.height);
        }

        T.closePanel();
        T.displayPanel("embed");
        T.$("#embed-code").focus();

        T.trackEventReader("integrer");

    },

    getEmbedSize: function () {
        var T = this,
            width, height;
        var size = T.$("#embed-size-select").val();
        if (size == "custom" || size == "ratio") {
            width = T.$("#embed-custom-width").val();
            height = T.$("#embed-custom-height").val();
        } else {
            var size_split = size.split("x");
            width = size_split[0];
            height = size_split[1];
        }
        return {
            width: parseInt(width),
            height: parseInt(height)
        };
    },

    onEmbedSizeChanged: function () {
        var T = this;

        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "custom" || size_choice == "ratio") {
            T.$(".embed-size .custom-size").show();
            if (size_choice == "ratio") {
                T.$("#embed-custom-width").val(T.embedWidth);
                T.$("#embed-custom-height").val(Math.round(T.embedWidth / T.embedRatio) + T.sliderHeight);
            } else {
                T.$("#embed-custom-width").val(T.embedWidth);
                T.$("#embed-custom-height").val(T.embedHeight);
            }
        } else {
            T.$(".embed-size .custom-size").hide();
        }
        var size = T.getEmbedSize();
        T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
    },

    onEmbedWidthChanged: function () {
        var T = this,
            size = T.getEmbedSize(),
            size_choice = T.$("#embed-size-select").val();

        if (size_choice == "ratio") {
            size = T.getEmbedSize();
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(T.currentEmbedSrc, size.width, new_height);
        } else if (size_choice == "custom") {
            size = T.getEmbedSize();
            T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
        }
    },

    onEmbedHeightChanged: function () {
        var T = this,
            size = T.getEmbedSize(),
            size_choice = T.$("#embed-size-select").val();

        if (size_choice == "ratio") {
            var new_width = Math.round((size.height - T.sliderHeight) * T.embedRatio);
            T.$("#embed-custom-width").val(new_width);
            T.updateEmbedCode(T.currentEmbedSrc, new_width, size.height);
        } else if (size_choice == "custom") {
            T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
        }
    },

    onEmbedPopupClicked: function () {
        var T = this,
            size = T.getEmbedSize();

        if (T.currentEmbedSrc) {
            window.open(T.currentEmbedSrc, '', 'height=' + size.height + ',width=' + size.width + ',resizable=no,menubar=no,scrollbars=no,status=no');
        }
    },

    /**
     * Update navigation bar (fil d'arianne).
     * If we came from a search page, output number of results and a back link.
     */
    updateNavigation: function () {
        // search /search/?xxx=yyy&total=1234 in query string
        var T = this,
            url,
            total;

        if (T.from && T.from.substr(0, 7) == "/search") {
            var q = UrlUtil.parseQueryString(T.from, ["total"]);
            url = T.from;
            total = q.total;
        }

        if (url && total) {
            var template = _.template(templates.navigation);
            T.$(".back-to-search").html(template({
                url: url,
                total: total
            }));
        }
    },

    /**
     * [onKeyDown description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    onKeyDown: function (e) {
        var T = this,
            prevent = false,
            isEditing = DomUtil.isEditing(e);

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 39) {
                //"right" : next page
                T.documentView.gotoPage("next", true);
                prevent = true;
            } else if (e.keyCode == 37) {
                //"left" : previous page
                T.documentView.gotoPage("previous", true);
                prevent = true;
            } else if (e.keyCode == 32) {
                //"space" : goto classification
                if ($(document).scrollTop()) {
                    T.onScrollTopClicked();
                } else {
                    T.onMoreInfoClicked();
                }
                prevent = true;
            } else if (e.keyCode == 70) {
                // f : find
                T.closePanel();
                T.displayPanel("search");
                prevent = true;
            } else if (e.keyCode == 68) {
                // d : découpage
                T.closePanel();
                T.displayPanel("crop");
                prevent = true;
            } else if (e.keyCode == 17) {
                // ctrl : temporarily disable tool
                T.$(".overlay-crop").addClass("inactive");
            }
        }

        if (e.keyCode == 27) {
            // ESC : close pannel = stop tool
            T.closePanel();
            prevent = true;
        }

        if (prevent) {
            e.preventDefault();
        }

    },

    onKeyUp: function (e) {
        var T = this,
            prevent = false,
            isEditing = DomUtil.isEditing(e);

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 17) {
                T.$(".overlay-crop").removeClass("inactive");
            }
        }

        if (prevent) {
            e.preventDefault();
        }
    },


    /**
     * scroll page to classify data block
     * @return {[type]} [description]
     */
    onMoreInfoClicked: function () {
        $("html, body").animate({
            scrollTop: $("section.classification").offset().top
        }, 500);
    },

    onAddToSelectionClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        var pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            documentId = T.documentModel.get("id"),
            publicationId = T.documentModel.get("publicationId"),
            page = T.documentModel.get("page");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        T.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        T.closePanel();

        var se = new SelectedDocumentModel({
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published,
            page: page
        }, {
                rnapi: T.app.rnapi
            });
        se.save(null, {
            success: function () {
                T.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function () {
                T.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
        T.trackEventReader("mes-selections");
    },

    onAccessSelectionClicked: function () {
        window.location = "/utilisateur/" + this.userModel.get("id") + "/selections";
    },

    /**
     * Compute current cropped area
     * @return {[type]} [description]
     */
    currentCrop: function () {
        var T = this,
            current_page = T.documentModel.get("page"),
            page_model = T.documentModel.getPageModel(current_page),
            page_width = page_model.get("width"),
            page_height = page_model.get("height"),
            crop = null;

        // recherche de l'overlay de la page courante
        var overlay_views = _.where(T.overlayViews, {
            page: current_page
        });
        overlay_views.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlayCropView) {
                crop = {
                    x: Math.round(overlay_view.selection.x * page_width / 100),
                    y: Math.round(overlay_view.selection.y * page_height / 100),
                    width: Math.round(overlay_view.selection.width * page_width / 100),
                    height: Math.round(overlay_view.selection.height * page_height / 100)
                };
            }
        });

        return crop;
    },

    /**
     * Enregistrer dans mes découpages
     */
    onAddToCropClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        var pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            documentId = T.documentModel.get("id"),
            publicationId = T.documentModel.get("publicationId"),
            page = T.documentModel.get("page");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        // recherche du crop courant

        T.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        T.closePanel();

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        //console.log(crop);

        var options = {
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published,
            page: page
        };
        _.extend(options, crop);

        var sc = new SharedCropModel(
            options, {
                rnapi: T.app.rnapi
            }
        );
        sc.save(null, {
            success: function () {
                T.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function () {
                T.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
        T.trackEventReader("extraire");
    },

    onDownloadCropClicked: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var picture = T.documentModel.pageUrl(T.documentModel.get("page")) + "/crop-rect/" + crop.x + "/" + crop.y + "/" + crop.width + "/" + crop.height;

        //console.log(picture);
        window.open(picture, "_blank");
    },

    onUrlCropClicked: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var url = window.location.href.split('?')[0]; // url sans la query string
        /*if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }*/
        url += "?highlight=" + crop.x + "." + crop.y + "." + crop.width + "." + crop.height;

        T.copyTextToClipboard(url);
        T.notify(
            {
                text: STR.copy_url_ok,
                type: "info",
                timeout: 10000
            });
        //window.prompt("Copier/Coller cette URL pour accéder directement à cette page avec la zone surligée dans le lecteur", url);
    },

    /**
     * Accéder à mes découpages
     */
    onAccessCropClicked: function () {
        var T = this;
        window.location = "/utilisateur/" + T.userModel.get("id") + "/extraits";
    },

    onSubscribeClicked: function () {
        window.location = "/abonnement";
        this.trackEventReader("abonnez-vous");
    },

    onDiscoverClicked: function () {
        this.trackEventReader("testez-retronews");
    },

    onLoginClicked: function () {
        window.location = "/user/login";
    },

    onRegisterClicked: function () {
        window.location = "/user/register";
    },

    copyTextToClipboard: function (text) {
        var textArea = document.createElement("textarea");

        //
        // *** This styling is an extra step which is likely not required. ***
        //
        // Why is it here? To ensure:
        // 1. the element is able to have focus and selection.
        // 2. if element was to flash render it has minimal visual impact.
        // 3. less flakyness with selection and copying which **might** occur if
        //    the textarea element is not visible.
        //
        // The likelihood is the element won't even render, not even a flash,
        // so some of these are just precautions. However in IE the element
        // is visible whilst the popup box asking the user for permission for
        // the web page to copy to the clipboard.
        //

        // Place in top-left corner of screen regardless of scroll position.
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;

        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        textArea.style.width = '2em';
        textArea.style.height = '2em';

        // We don't need padding, reducing the size if it does flash render.
        textArea.style.padding = 0;

        // Clean up any borders.
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';

        // Avoid flash of white box if rendered for any reason.
        textArea.style.background = 'transparent';


        textArea.value = text;

        document.body.appendChild(textArea);

        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }

        document.body.removeChild(textArea);
    },

    onShareFacebookClicked: function () {
        //https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4
        var T = this,
            url,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            message = STR.facebook_message,
            app_id = T.app.facebookAppId,
            caption = pubTitle + ", " + STR.date(published),
            picture = T.documentModel.thumbnailUrl(T.documentModel.get("page"));

        T.closePanel();

        if (T.embed) {
            url = T.canonicalReaderUrl(true, T.fit); // en mode embed on veut partager l'url originale
        } else {
            url = T.canonicalReaderUrl();
        }

        window.open(UrlUtil.shareFacebook(
            app_id, {
                display: "page",
                caption: caption,
                description: message,
                link: url,
                picture: picture
            }), "_blank");

    },

    onShareTwitterClicked: function () {
        var T = this,
            url,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            message = pubTitle + ", " + STR.date(published); // use template ?

        

        if (T.embed) {
            url = T.canonicalReaderUrl(true, T.fit); // en mode embed on veut partager l'url originale
        } else {
            url = T.canonicalReaderUrl();
        }

        T.closePanel();
        window.open(UrlUtil.shareTwitter(message, url, "RetroNewsFR"), "_blank");
        T.trackEvent('lecteur', 'partager', 'twitter');
    },

    onShareEmailClicked: function () {
        var T = this,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            subject = "Lu sur retronews.fr",
            url = T.canonicalReaderUrl(),
            message = pubTitle + ", " + STR.date(published) + "\r\n\r\nConsultez cette page sur RetroNews :\r\n" + url + "\r\n\r\nRetroNews, le site de presse de la Bibliothèque nationale de France";

        var link = "mailto:?subject=" + window.encodeURIComponent(subject) + "&body=" + window.encodeURIComponent(message);
        T.closePanel();
        window.location.href = link;

        T.trackEvent('lecteur', 'partager', 'email');
    },


    onEmbedCodeFocused: function (e) {
        e.target.select();
    },

    onDownloadTextFocused: function () {
        this.$("#download-pdf-some-page").prop("checked", true);
    },

    onDownloadDocumentClicked: function () {
        var T = this,
            filename = (T.documentModel.get("published") +" "+ T.documentModel.get("publicationTitle") + " " + "Retronews").replace(/[^A-Za-z0-9]/g, "_"),
            page = 1,
            service = "pdf",
            error_str = null;

        var type = T.$("input[name='download-group']:checked").val();
        if (type == "active-page") {
            page = T.documentModel.get("page");
        } else if (type == "some-pages") {
            page = T.$("#download-text-some-pages").val().trim();

            if (!T.checkPrintRangeSyntax(page, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }
        } else if (type == "all-pages") {
            page = "1-" + T.documentModel.get("nbPages");
        } else if (type == "text-active-page") {
            page = T.documentModel.get("page");
            service = "text";
            filename += "_" + page;
        } else {
            error_str = STR.something_wrong;
        }

        if (!error_str) {
            T.closePanel();
            T.trackEventReader('telecharger');
            //var url=T.documentModel.pageUrl(page)+"/"+service+"?filename="+filename;
            var url = T.app.rnapi + "/documents/" + T.publicationId + "/" + T.documentId + "/" + page + "/" + service + "?filename=" + filename;
            window.location = url;
        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 4000
            });
        }
    },

    limitInputToNumbers: function (e) {
        var val = $(e.target).val();
        var new_val = val.replace(/[^0-9,-]/g, "");
        if (new_val != val) {
            $(e.target).val(new_val);
        }
    },

    checkPrintRangeSyntax: function (page_str, max_page) {
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (isNaN(page) || page < 1 || page > max_page) {
                        return false;
                    }
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (isNaN(page_min) || page_min < 1 || page_min > max_page) {
                        return false;
                    }
                    if (isNaN(page_max) || page_max < 1 || page_max > max_page) {
                        return false;
                    }
                    if (page_min > page_max) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    },

    onPrintTextFocused: function () {
        this.$("#print-pdf-some-page").prop("checked", true);
    },

    onPrintDocumentClicked: function () {
        var T = this,
            page = 1,
            error_str = null;

        var type = T.$("input[name='print-group']:checked").val();
        if (type == "active-page") {
            page = T.documentModel.get("page");
        } else if (type == "some-pages") {
            page = T.$("#print-text-some-pages").val().trim();

            if (!T.checkPrintRangeSyntax(page, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }
        } else if (type == "all-pages") {
            page = "1-" + T.documentModel.get("nbPages");
        }

        if (!error_str) {
            //var url=T.documentModel.pageUrl(page)+"/pdf";
            var url = T.app.rnapi + "/documents/" + T.publicationId + "/" + T.documentId + "/" + page + "/pdf";

            T.closePanel();
            T.trackEventReader('imprimer');
            var w = window.open(url);
            if (w) {
                w.onload = function () {
                    w.print();
                };
            }
        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 4000
            });
        }
    },

    /**
     * scroll to top
     */
    onScrollTopClicked: function () {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    },

    /**
     * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
     * @param  {[type]}  el [description]
     * @return {Boolean}    [description]
     */
    isElementInViewport: function (el) {
        var rect = el.getBoundingClientRect();
        return !(
            rect.bottom <= 0 ||
            rect.top >= $(window).height()
        );
    },

    /**
     * go full screen
     */
    onFullscreenClicked: function () {
        var T = this,
            el = T.$(".reader")[0];

        if (T.isFullscreen()) {
            T.exitFullscreen();
        } else {
            T.enterFullscreen(el);
        }
    },

    onHelpClicked: function () {
        this.app.help();
        this.trackEventReader('aide');
    },

    onImageInverseClicked: function () {
        var T = this;
        T.imageInverse(!T._imageInverted);
        if(T._imageInverted){
            T.trackEventReader('negatif');
        }
    },

    imageInverse: function (invert) {
        var T = this;
        T._imageInverted = invert;
        T.$(".reader").toggleClass("inverted", invert);
        T.$(".image-inverse").toggleClass("on", invert);
    },

    onEntitiesClicked: function () {
        var T = this;

        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }
        T.displayEntities(!T._entitiesShown);
        if(T._entitiesShown){
            T.trackEventReader('afficher-tags');
        }
    },

    displayEntities: function (show) {
        var T = this;
        T._entitiesShown = show;
        T.$(".overlay-entities").toggleClass("hide", !show);
        T.$(".entities").toggleClass("on", show);
    },

    displayCrop: function (show) {
        var T = this;
        T._cropShown = show;
        T.$(".overlay-crop").toggleClass("hide", !show);
    },

    onPageAnnotationClicked: function (annotation_model) {
        var T = this;

        T.currentAnnotationModel = annotation_model;
        T.displayPanel("annotate");
    },

    displayAnnotation: function (show) {
        var T = this;
        T._annotateActive = show;

        T.$(".overlay-annotations").toggleClass("active", show);
    },

    onDeleteAnnotation: function () {
        var T = this;
        if (T.currentAnnotationModel) {
            //if(window.confirm(STR.confirm_delete_annotation)){
            T.currentAnnotationModel.destroy({
                error: function () {
                    T.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
            T.currentAnnotationModel = null;
            T.closePanel();
            //}
        }
    },

    onSaveAnnotation: function () {
        var T = this;

        if (T.currentAnnotationModel) {
            T.currentAnnotationModel.save({
                text: T.$("#annotation-text").val()
            }, {
                    error: function () {
                        T.notify({
                            text: STR.unable_to_save,
                            type: "error",
                            timeout: 4000
                        });
                    }
                });
            T.currentAnnotationModel = null;
            T.closePanel();
            T.trackEventReader('annoter');
        }
    },

    onNextPage: function () {
        this.documentView.gotoPage("next", true);
    },

    onPreviousPage: function () {
        this.documentView.gotoPage("previous", true);
    },

    onZoomInClicked: function () {
        this.documentView.zoom("in", true);
        this.trackEventReader('zoom-plus');
    },

    onZoomOutClicked: function () {
        this.documentView.zoom("out", true);
        this.trackEventReader('zoom-moins');
    },

    onCalendarClicked: function () {
        var T = this;
        T.displayCalendar(!T._calendarShown);
        if(T._calendarShown){
            T.trackEventReader('calendrier');
        }
    },

    displayCalendar: function (show) {
        var T = this;

        if (T.embed) {
            return;
        }

        if (T._blocksShown && show) {
            T._blocksShown = false;
            T.$(".ocr").removeClass("on"); // button
            T.$(".overlay-blocks").addClass("hide");
        }
        T._calendarShown = show;
        if (T.blockView) {
            T.blockView.$el.hide(); // cache le panel et l'overlay
        }
        T.displaySidePanel(show);

        if (!T.calendarView) {
            T.calendarView = new CalendarView({
                documentModel: T.documentModel,
                app: T.app,
                userModel: T.userModel,
                searchAccess: T.searchAccess,
                queryModel: T.documentQueryModel,
                from: T.from,
                index: T.index
            });
            T.$(".side-panel").append(T.calendarView.el);
            T.calendarView.queryDocumentList();
        }
        else {
            T.calendarView.queryDocumentList();
            T.calendarView.$el.show();
        }
        T.$(".calendar").toggleClass("on", show); // button

        T.calendarView.gotoCurrent();
    },

    onOcrClicked: function () {
        var T = this;
        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }
        else{
            T.displayBlocks(!T._blocksShown);
            if(T._blocksShown){
                T.trackEventReader('mode-texte');
            }
        }
    },

    /**
     * display blocks in ocr text overlay
     * @param  {Bool} show
     */
    displayBlocks: function (show) {
        var T = this;

        if (T.embed) {
            return;
        }

        if (T._calendarShown && show) {
            T._calendarShown = false;
            T.$(".calendar").removeClass("on"); // button
        }
        T._blocksShown = show;
        if (T.calendarView) {
            T.calendarView.$el.hide(); // cache le panel
        }
        T.$(".overlay-blocks").toggleClass("hide", !show);
        T.$(".ocr").toggleClass("on", show); // button
        T.displaySidePanel(show);
        T.updateBlocksView();
    },

    /**
     * update text from ocr view
     */
    updateBlocksView: function () {
        var T = this,
            page = T.documentModel.get("page");

        if (!page) {
            return;
        }

        var semantic_model = T.getSemanticModel(page);
        var page_model = T.documentModel.getPageModel(page);

        if (T.blockView) {
            T.stopListening(T.blockView);
            T.blockView.close();
            T.blockView.$el.remove();
        }
        T.blockView = new BlocksView({
            model: semantic_model,
            pageModel: page_model,
            documentModel: T.documentModel,
            app: T.app,
            mode: T.blockMode,
            articleId: T.articleId
        });

        if (T.articleId) {
            T.articleId = null; // article initialement highlighté
        }

        T.$(".side-panel").append(T.blockView.el);

        T.listenTo(T.blockView, "click:block", T.onViewBlockClicked);
        T.listenTo(T.blockView, "change:mode", T.onViewBlockModeChanged);
        T.listenTo(T.blockView, "article:open", T.onViewBlockArticleOpen);
    },



    /**
     * synchronize ocr text position with clicked block into overlay view
     * @param  {[type]} overlay_view [description]
     * @param  {[type]} block_id     [description]
     */
    onPageBlockClicked: function (overlay_view, block_id) {
        var T = this;
        if (T.blockView) {
            T.blockView.gotoBlock(block_id);
        }
    },

    /**
     * highlight text block into overlay view
     * @param  {[type]} block_view [description]
     * @param  {array} block_ids   tableau de blocks ids qui ont été touchés
     * en mode page 1 seul bloc, en mode article l'ensemble des blocks correspondant à l'article
     */
    onViewBlockClicked: function (block_view, block_ids) {
        var T = this;
        T.$(".overlay-blocks .block").removeClass("hl");
        var selector = "";

        _.each(block_ids, function (block_id) {
            if (selector) {
                selector += ",";
            }
            selector += ".overlay-blocks #" + block_id;
        });

        T.$(selector).addClass("hl");
        setTimeout(function () {
            T.$(selector).removeClass("hl");
        }, 4000);
    },

    onViewBlockModeChanged: function (block_view, mode) {
        this.blockMode = mode;
    },

    onViewBlockArticleOpen: function (block_view, article_id) {
        var T = this;

        // update url avec cet article
        T.currentArticleId = article_id;
        T.updateRoute();
    },

    onBasketClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        T.trackEventReader('acheter');

        if (T.embed) {
            // en mode embed, on va vers le lecteur complet
            window.open(T.canonicalReaderUrl(true, T.fit));
        }
        else {
            // dans le lecteur complet   
            if (T.userModel.isPro()) {
                // les utilisateurs pro peuvent acheter des droits
                T.app.addToBasket(T.documentModel);
            } else {
                // sinon ils doivent s'abonner à un abonnement pro
                T.app.proScreen();
            }
        }
    },

    onPageViewAdded: function (page_view) {
        var T = this,
            page = page_view.page,
            page_model = T.documentModel.getPageModel(page);

        if (!T.embed) {
            var semantic_model = T.getSemanticModel(page);

            // overlay entities
            var entities_view = new OverlayEntitiesView({
                pv5api: T.app.pv5api,
                page: page,
                hide: !T._entitiesShown,
                model: semantic_model
            });
            T.overlayViews.push(entities_view);

            // overlay search
            var page_query_model = new ArticleQueryModel({
                useAgg: false,
                documentId: T.documentId,
                publicationId: T.publicationId,
                highlight: true,
                highlightPosition: true,
                pageNumber: page,
                pageSize: 20, // on ne peut pas avoir plus de 20 articles par page
                highlightFragments: 1000,
                exact: true,
                access: T.searchAccess
            }, {
                    pv5api: T.app.pv5api,
                    minPublishedDate: T.app.minPublishedDate,
                    maxPublishedDate: T.app.maxPublishedDate,
                    page: page // pour la retrouver plus facilement par la suite
                });
            T._pageQueryModels.push(page_query_model);
            var search_view = new OverlaySearchView({
                page: page,
                pageModel: page_model,
                queryModel: page_query_model
            });
            T.overlayViews.push(search_view);

            // lancer la recherche que si il le faut
            if (T.isResultInPage(page)) {
                if (T.documentQueryModel.hasTerms()) {
                    T.copyQueryTerms(T.documentQueryModel, page_query_model);
                    page_query_model.search();
                }
            }

            // overlay blocks
            var blocks_view = new OverlayBlocksView({
                pv5api: T.app.pv5api,
                page: page,
                hide: !T._blocksShown,
                model: semantic_model
            });
            T.listenTo(blocks_view, "click:block", T.onPageBlockClicked);
            T.overlayViews.push(blocks_view);

            //annotations
            if (T.userModel.isLoggedIn()) {
                var annotations_view = new OverlayAnnotationsView({
                    page: page,
                    pageModel: page_model,
                    annotationCollection: T.annotationCollection,
                    active: T._annotateActive,
                    app: T.app
                });
                T.listenTo(annotations_view, "click:annotation", T.onPageAnnotationClicked);
                T.overlayViews.push(annotations_view);
            }

            //crop
            var crop_view = new OverlayCropView({
                pv5api: T.app.pv5api,
                page: page,
                pageModel: page_model,
                hide: !T._cropShown
            });
            T.overlayViews.push(crop_view);

        }

        // highlight : on ne l'ajoute que pour la page initiale
        if (page == T.page) {
            var highlight_view = new OverlayHighlightView({
                page: page,
                pageModel: page_model,
                highlight: T.highlight
            });
            T.overlayViews.push(highlight_view);
        }
    },

    onPageViewRendered: function (page_view) {
        var T = this;
        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });

            overlay_views.forEach(function (overlay_view) {
                page_view.$tileContainer.append(overlay_view.el);
            });
        }
    },

    onPageViewRefreshed: function ( /*page_view*/) {
        //if you need to refresh positions in overlay_view
    },

    onPageViewRemoved: function (page_view) {
        var T = this;

        T._pageQueryModels = _.difference(T._pageQueryModels, _.where(T._pageQueryModels, {
            page: page_view.page
        }));

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });
            overlay_views.forEach(function (overlay_view) {
                overlay_view.remove();
                T.stopListening(overlay_view);
                overlay_view.close();
            });
            T.overlayViews = _.difference(T.overlayViews, overlay_views);
        }
    },

    /**
     * change button appearance when fullscreen change
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    onFullscreenChanged: function () {
        var T = this,
            fs = T.isFullscreen();

        $("body").toggleClass("full-screen", fs);
        T.$(".full-screen").toggleClass("on", fs); // mettre une class semble le plus stable, les pseudo class ne sont pas comprises par tous les navigateurs en 2015

        T.onResize();
    },

    isFullscreen: function () {
        return (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.pv5FullScreen);
    },

    enterFullscreen: function (el) {
        var T = this;

        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen();
        } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen();
        } else {
            //simulate fullscreen
            document.pv5FullScreen = true;
            T.onFullscreenChanged();
        }
        T.trackEventReader('plein-ecran');
    },

    exitFullscreen: function () {
        var T = this;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else {
            document.pv5FullScreen = false;
            T.onFullscreenChanged();
        }
    },

    echoVersion: function () {
        var T = this;
        T.$(".version").html(T.app.version);
    },

    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    /**
     * Appelé quand on clique sur un des boutons de la barre d'outils du haut qui affiche un panel la plupart du temps
     * @param  {Event} e
     */
    onDisplayPanel: function (e) {
        var T = this;
        var name = $(e.target).data("panel");
        if (name) {
            e.stopPropagation();
            T.closePanel();

            if (name == "embed") {
                T.updateEmbedCodePage();
            } else if (name == "annotate") {
                T.currentAnnotationModel = null;
                //tmp start
                /*if (!T.userModel.isAdmin()) {
                    T.app.comingSoonScreen();
                    return;
                }*/
                // tmp end
            } else if (name == "search") {
                if (T.documentModel.get("isTextMissing")) {
                    T.notify({
                        text: STR.text_is_missing,
                        type: "warning",
                        timeout: 5000
                    });
                }
            }

            T.displayPanel(name);
        }
    },

    /**
     * Appelé quand on clique sur la croix d'un des panels d'outils du haut
     * @param  {Event} e
     */
    onClosePanel: function (e) {
        var T = this;
        e.stopPropagation();
        T.closePanel();
    },

    /**
     * Ouvre un panel d'outils du haut
     * @param  {String} name nom du panel à ouvrir
     */
    displayPanel: function (name) {
        var T = this;
        T.openPanel = name;
        T.$(".tb-top .button." + name).addClass("on");
        if (name == "search") {
            T.$("#search-input-phrase").focus();
        } else if (name == "crop") {
            T.displayCrop(true);
        } else if (name == "annotate") {
            if (T.currentAnnotationModel) {
                T.$(".annotation-edit").show();
                T.$("#annotation-text")
                    .val(T.currentAnnotationModel.get("text"))
                    .focus();
            } else {
                T.$("#annotation-text").val("");
                T.$(".annotation-edit").hide();
            }
            T.displayAnnotation(true);
        } else if (name == "embed") {
            T.displayEmbedPreview(true);
        }
    },

    /**
     * Ferme le panel actuellement ouvert
     */
    closePanel: function () {
        var T = this;
        if (T.openPanel == "crop") {
            T.displayCrop(false);
        } else if (T.openPanel == "annotate") {
            T.displayAnnotation(false); // le click dans la page ne produit plus d'annotations
        } else if (T.openPanel == "embed") {
            T.displayEmbedPreview(false); // on vide la preview quand on en a plus besoin car elle est couteuse
        }

        T.$(".tb-top .button." + T.openPanel).removeClass("on");
    },

    displayEmbedPreview: function (show) {
        var T = this;
        T.$("#embed-preview-iframe").empty();
        if (show) {
            var $iframe = $(T.$("#embed-code").val());
            $iframe.attr({
                width: T.embedWidth,
                height: T.embedHeight
            }); // on écrase les dimensions sinon ça ne tiendrait jamais dans la popup
            T.$("#embed-preview-iframe").append($iframe);
        }
    },

    onMinimizePanel: function (e) {
        var T = this;
        var name = $(e.target).data("panel");
        if (name) {
            T.$(".tb-top .button." + name).toggleClass("minimized");
        }
    },

    /**
     * retourne l'url canonique officielle vers le reader dans le site retronews
     * @return {String} [description]
     */
    canonicalReaderUrl: function (use_start_page, fit, embed) {
        var T = this,
            url,
            pubtitle = T.documentModel.get("publicationTitle"),
            pubid = T.documentModel.get("publicationId"),
            docid = T.documentModel.get("id"),
            docdate = T.documentModel.get("published"),
            page = use_start_page ? T.page : T.documentModel.get("page"),
            base_url = embed ? T.app.canonicalEmbedUrl : T.app.canonicalUrl;

        url = base_url + "/" + UrlUtil.slugify(pubtitle) + "/" + UrlUtil.slugify(STR.date(docdate)) + "/" + pubid + "/" + docid + "/" + page;

        if (fit) {
            var fit_array = [fit.x, fit.y, fit.width, fit.height];
            url += "?fit=" + fit_array.join(".");
        }

        return url;
    },

    onBackToSearchClicked: function () {
        window.location = this.from;
    },

    /**
     * Initiate a search in document from panel
     */
    onSubmitSearch: function () {
        var T = this;


        // reset all search query and overlays
        T.resetPageQuery();

        // disable next / prev button
        T.enableResultButtons(false);

        // initiate a new search in document if request is not empty
        if (T.documentQueryModel.get("phrase")) {
            T.documentQueryModel.set({
                allTerms: null,
                someTerms: null,
                exact: true // forcé a true pour la recherche dans la page
            });
            T.notify({
                text: STR.search_in_progress,
                type: "info",
                timeout: 30000
            });
            T.documentQueryModel.search();
            T.trackEventReader('rechercher-dans-page');
        }

    },

    /**
     * Disable/enable prev/next result  button
     * @param  {Bool} enable
     */
    enableResultButtons: function (enable) {
        var T = this;
        T.$(".result .action").toggleClass("enable", enable);
    },


    onDocumentSearchEnd: function () {
        var T = this,
            results = T.documentQueryModel.get("results");

        if (results.length) {
            T.notifyClose();
            _.each(T._pageQueryModels, function (page_query_model) {
                if (T.isResultInPage(page_query_model.get("pageNumber"))) {
                    T.copyQueryTerms(T.documentQueryModel, page_query_model);
                    page_query_model.search();
                }
            });

            T.enableResultButtons(true);

            //go to the first result
            T.gotoResult("nearest");
        } else {
            T.notify({
                text: STR.no_result,
                type: "warning",
                timeout: 3000
            });
        }
    },

    /**
     * Reset page search queries and overlays
     */
    resetPageQuery: function () {
        var T = this;

        T.documentQueryModel.fetched = false;

        _.each(T._pageQueryModels, function (page_query_model) {
            page_query_model.fetched = false;
        });

        _.each(T.overlayViews, function (overlay_view) {
            if (overlay_view instanceof OverlaySearchView) {
                overlay_view.render();
            }
        });
    },

    /**
     * Determine if page is in result collection
     * @param  {Number}  p [description]
     * @return {Boolean}   [description]
     */
    isResultInPage: function (p) {
        var T = this,
            results = T.documentQueryModel.get("results"),
            found = false;

        if (T.documentQueryModel.fetched && results.length) {
            results.all(function (result) {
                var page = result.get("pageNumber")[0];
                if (page == p) {
                    found = true;
                    return false;
                }
                return true;
            });
        }

        return found;
    },

    copyQueryTerms: function (model_src, model_dest) {
        model_dest.set({
            allTerms: model_src.get("allTerms"),
            phrase: model_src.get("phrase"),
            someTerms: model_src.get("someTerms"),
            exact: model_src.get("exact")
        });
    },

    /**
     * Goto result, change page if needed
     * @param  {String} mode nearest, previous, next
     */
    gotoResult: function (mode) {
        var T = this,
            current_page = T.documentModel.get("page"),
            nearest_page = 0,
            results = T.documentQueryModel.get("results");

        if (T.documentQueryModel.fetched && results.length) {
            if (mode == "nearest") {
                results.all(function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page >= current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });

                if (!nearest_page) {
                    nearest_page = results.first().get("pageNumber")[0];
                }
            } else if (mode == "next") {
                results.all(function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page > current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    nearest_page = results.first().get("pageNumber")[0];
                }
            } else if (mode == "previous") {
                var results_reversed = results.first(results.length).reverse();
                _.all(results_reversed, function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page < current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    nearest_page = results.last().get("pageNumber")[0];
                }
            }

            if (nearest_page && nearest_page != current_page) {
                // on va à la page
                T.documentView.gotoPage(nearest_page, true);
            }
        }
    },

    onNextResult: function () {
        var T = this;
        T.gotoResult("next");
    },

    onPreviousResult: function () {
        var T = this;
        T.gotoResult("previous");
    },

    /**
     * show/hide side panel
     * @return {[type]} [description]
     */
    displaySidePanel: function (show) {
        var T = this;
        T._sidePanel = show;

        var tb_h = T.$(".tb-top").height(),
            title_w = 380,
            is_phone = $(window).width() < 767 ? true : false;

        if (is_phone) {
            // en mode smartphone on affiche soit la version texte soit la version image
            T.$(".side-panel").css({
                width: "100%",
                top: tb_h,
                height: "calc( 100% - " + tb_h + "px)",
                display: show ? "block" : "none"
            });
            T.pageSliderView.$el.css({
                left: 0,
                width: show ? "100%" : ""
            });
            T.documentView.$el.css({
                left: 0,
                width: "100%",
                display: show ? "none" : "block"
            });
        }
        else {
            // autrement on affiche le texte + l'image
            T.documentView.$el.css({
                left: show ? title_w : "",
                width: show ? "calc( 100% - " + title_w + "px)" : "",
                display: "block"
            });
            T.pageSliderView.$el.css({
                left: show ? title_w : "",
                width: show ? "calc( 100% - " + title_w + "px)" : ""
            });
            T.$(".side-panel").css({
                width: title_w,
                top: tb_h,
                height: "calc( 100% - " + tb_h + "px)",
                display: show ? "block" : "none"
            });
        }

        T.onResize();
    },


    onActivateEmbed:function(){
        var T=this;
        if(T.overlayEmbedTimer){
            clearTimeout(T.overlayEmbedTimer);
            T.overlayEmbedTimer=null;
        }
        $(window).off(".overlay-embed");
        T.$overlayEmbed.remove();
        
        T.notify({
            text: STR.embed_activated,
            type: "info",
            timeout: 3000
        });
    },

    onOverlayEmbedMouseWheel:function(){
        var T=this;
        if(T.overlayEmbedTimer) return;
        T.$overlayEmbed.addClass("over");
        T.overlayEmbedTimer=setTimeout(function(){
            T.$overlayEmbed.removeClass("over");
            T.overlayEmbedTimer=null;
        },3000); // 3 secondes pour activer le lecteur
    },

    onOverlayEmbedTouchStart:function(){
        var T=this;
        debug("touchstart");

        $(window).on("pointerup.overlay-embed pointercancel.overlay-embed touchcancel.overlay-embed touchend.overlay-embed", function (e) {
            T.onOverlayEmbedTouchEnd(e);
        });
        
        T.$overlayEmbed.addClass("over");
    },

    onOverlayEmbedTouchEnd:function(){
        var T=this;
        debug("touchend");
        $(window).off(".overlay-embed");
        if(T.overlayEmbedTimer) return;
        T.overlayEmbedTimer=setTimeout(function(){
            T.$overlayEmbed.removeClass("over");
            T.overlayEmbedTimer=null;
        },3000); // 3 secondes pour activer le lecteur
    },


    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.writeSettings();

        T.subViews.forEach(function (view) {
            view.close();
        });
        T.subViews = null;

        if (T.blockView) {
            T.blockView.close();
            T.blockView.$el.remove();
            T.blockView = null;
        }
        if (T.calendarView) {
            T.calendarView.close();
            T.calendarView.$el.remove();
            T.calendarView = null;
        }

        $(document).off(".rn");
        $(window).off(".rn");

        T.stopListening();
        T.undelegateEvents();
    }

});
},{"../../common/models/selected-document-model":1,"../../common/models/user-model":2,"../../search/models/article-query-model":32,"../collections/annotation-collection":3,"../models/page-semantic-model":5,"../models/shared-crop-model":6,"../templates/navigation-template.html":15,"../templates/page-slider-knob-template.html":16,"../templates/page-slider-thumb-template.html":17,"../templates/page-template.html":18,"../templates/search-next-results-template.html":19,"../views/blocks-view":21,"../views/calendar-view":22,"../views/classification-view":23,"../views/overlay-annotations-view":24,"../views/overlay-blocks-view":25,"../views/overlay-crop-view":26,"../views/overlay-entities-view":27,"../views/overlay-highlight-view":28,"../views/overlay-search-view":29,"../views/search-next-results-view":31,"@immanens-com/pv5js/common/utils/dom-util":39,"@immanens-com/pv5js/common/utils/url-util":41,"@immanens-com/pv5js/reader/models/document-model":47,"@immanens-com/pv5js/reader/views/document-view":49,"@immanens-com/pv5js/reader/views/page-slider-view":50,"@immanens-com/pv5js/search/views/search-input-view":54,"backbone":55,"debug":56,"jquery":58,"underscore":61}],31:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:SearchNextResultsView"); //https://github.com/visionmedia/debug

// Models
var ArticleQueryModel = require("../../search/models/article-query-model");
var UserModel = require("../../common/models/user-model");
var HistoPeriodList = require("../../search/models/histo-period-list");

// Views
var ArticleResultView = require("../../search/views/article-result-view");

var templates = {
    articleNextResult: require("../templates/article-next-result-template.html")
};

/**
 * Retronews SearchNextResultsView : view for the 5 next search results.
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    template: null, // external template
    searchQuery: null, // query de la recherche lancée
    index: false, // index du résultats dans l'ensemble des résultats de la recherche

    searchLaunched: false,
    events: {
        "click .see-all-result": "onSeeAllClicked"
    },

    /**
     * @param  {Object} options must contains the "app" object
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);
        T.template = _.template(T.template);

        T.resultViews = [];
        T.isPhone = $(window).width() < 767 ? true : false;

        // user
        T.userModel = new UserModel(T.app.user);
        var search_access = T.userModel.isAdmin() ? null : "public";
        T.searchQueryModel = new ArticleQueryModel({
            pageSize: (T.isPhone ? 3 : 5),
            access: search_access
        }, {
            pv5api: T.app.pv5api,
            minPublishedDate: T.app.minPublishedDate,
            maxPublishedDate: T.app.maxPublishedDate
        });
        T.searchQueryModel.setQueryString(T.searchQuery);

        // on vérifie que la zone est visible pour lancer la recherche
        T.checkSearchNextResultsVisibility();

        T.listenTo(T.app, "app:notify", T.notify);

        $(window).on("resize.rn", function () {
            T.checkSearchNextResultsVisibility();
        });

        $(window).on("scroll.rn", function () {
            T.checkSearchNextResultsVisibility();
        });

    },

    checkSearchNextResultsVisibility: function () {
        var T = this;
        if (T.isInViewport($(".search-next-results"))) {
            // show panel and launch search
            $(".search-next-results").addClass("show");

            if (!T.searchLaunched) {
                T.searchFromIndex();
            }
        }
        else {
            // hide panel
            $(".search-next-results").removeClass("show");
        }
    },

    searchFromIndex: function () {
        var T = this;

        T.searchLaunched = true;

        // listen query start loading
        T.listenTo(T.searchQueryModel, "request", T.onSearchStart);
        T.listenTo(T.searchQueryModel, "sync", T.onSearchEnd);
        T.listenTo(T.searchQueryModel, "error", T.onSearchError);

        // waiting for results
        T.listenTo(T.searchQueryModel.get("results"), "add", T.addOneArticleResult);
        T.listenTo(T.searchQueryModel.get("results"), "reset", T.addAllArticleResults);

        T.searchQueryModel.fetchFrom(parseInt(T.index) + 1); // on veut les suivants
    },

    isInViewport: function ($el) {
        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    },


    trackEvent: function (category, action, label) {
        var T = this;

        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {
            debug("ga tracking event %s %s %s", category, action, label);
            window.ga("send", "event", category, action, label);
        }
    },

    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    onSeeAllClicked: function () {
        window.location = '/search#' + this.searchQuery;
    },

    onSearchStart: function () {
        var T = this;
        // on affiche la notification de recherche
        T.notify({
            text: STR.search_in_progress,
            type: "info",
            timeout: 30000
        });
    },

    onSearchEnd: function () {
        var T = this,
            results = T.searchQueryModel.get("results");

        if (results.length) {
            T.notifyClose();
            T.$('.total-results').html(STR.number(T.searchQueryModel.get('total')) + ' ' + STR.search_results);
        } else {
            T.notify({
                text: STR.no_result,
                type: "warning",
                timeout: 3000
            });
        }
    },

    onSearchError: function (model, xhr) {
        var T = this;
        var message = STR.search_error;
        try {
            var error_js = JSON.parse(xhr.responseText);
            if (error_js.message) {
                message += " (" + error_js.message + ")";
            } else {
                message += " (" + xhr.status + ")";
            }
        } catch (e) {
            //
        }

        T.notify({
            text: message,
            type: "error",
            timeout: 5000
        });
    },

    addOneArticleResult: function (result, index) {
        var T = this,
            view = new ArticleResultView({
                model: result,
                template: templates.articleNextResult,
                pv5api: T.app.pv5api,
                rnapi: T.app.rnapi,
                userModel: T.userModel,
                queryModel: T.searchQueryModel,
                cropWidth: 200,
                cropHeight: 200,
                cropFontSize: 11,
                app: T.app,
                index: ((index !== false && index !== undefined) ? index : false),
                from: '/search#' + T.searchQuery
            });

        T.resultViews.push(view);
        T.$("#next-results").append(view.render().el);
    },

    /**
     * on ajoute des cases vides pour que l'alignement de la flexbox soit centré aussi sur la ddernière ligne
     */
    addEmptyCells: function ($el, classname) {
        for (var i = 0; i < 5; i++) {
            $el.append($("<div class=\"" + classname + " empty\"></div>"));
        }
    },

    addAllArticleResults: function () {
        var T = this;

        T.$("#next-results").css("visibility", "visible");

        T.$("#next-results").html("");

        T.resultViews.forEach(function (view) {
            T.stopListening(view);
            view.close();
            view.remove();
        });
        T.resultViews = [];

        if (T.searchQueryModel.get("results").length) {
            T.$("#next-results").removeClass("no-result");
            T.searchQueryModel.get("results").each(function (result, index) { T.addOneArticleResult(result, T.index + index + 1); });
            T.addEmptyCells(T.$("#next-results"), "page-result");
        }
        else {
            T.$("#next-results")
                .addClass("no-result")
                .html(STR.no_other_result);
        }
    },

    render: function () {
        debug("render");
        var T = this,
            context = T.searchQueryModel.toJSON();

        // &#10003; or &#10060;
        var charFromFilter = function (filter_name) {
            var name = filter_name.substr(2, filter_name.length - 4);
            return T.searchQueryModel.get("exclude" + name) ? "<span style='color:#f33'>&#10005;</span> " : "&#10003; ";
        };

        context.filters = [];
        var searchFilters = T.searchQueryModel.appliedFilters();
        $.each(searchFilters, function (key, value) {
            if (key == 'tfPublishedRanges') {
                if (value.start) {
                    context.filters.push(charFromFilter(key) + STR.date(value.start));
                }
                if (value.end) {
                    context.filters.push(charFromFilter(key) + STR.date(value.end));
                }
            }
            else {
                if (value.length) {
                    $.each(value, function (subkey, subvalue) {
                        if (key == 'tfPublicationGeolocsOr') {
                            context.filters.push(subvalue.city);
                        }
                        else if (key == 'tfThemes' || key == 'tfThemesOr') {
                            if (subvalue.l2) {
                                context.filters.push(charFromFilter(key) + STR["theme_l2_" + subvalue.l2]);
                            }
                            else {
                                context.filters.push(charFromFilter(key) + STR["theme_" + subvalue.l1]);
                            }
                        }
                        else if (key == 'tfHistoPeriods') {
                            var ref_period = _.findWhere(HistoPeriodList, { key: subvalue });
                            if (ref_period) {
                                context.filters.push(ref_period.label);
                            }
                            else {
                                context.filters.push(subvalue);
                            }
                        }
                        else if (key == 'tfPublicationGeotagsOr') {
                            var geotag = subvalue.split("_", 2)[1];
                            context.filters.push(charFromFilter("tfGeotagsOr") + geotag); // on renomme pour corriger un melimelo dans le paramètre choisi pour geotag
                        }
                        else {
                            context.filters.push(charFromFilter(key) + subvalue);
                        }
                    });
                }
            }
        });

        T.$el.html(T.template(context));
        return T;
    },

    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.resultViews.forEach(function (view) {
            T.stopListening(view);
            view.close();
            view.remove();
        });
        T.resultViews = null;

        $(document).off(".rn");
        $(window).off(".rn");

        T.stopListening();
        T.undelegateEvents();
    }

});
},{"../../common/models/user-model":2,"../../search/models/article-query-model":32,"../../search/models/histo-period-list":35,"../../search/views/article-result-view":36,"../templates/article-next-result-template.html":11,"backbone":55,"debug":56,"jquery":58,"underscore":61}],32:[function(require,module,exports){
"use strict";

var _ = require("underscore");

var QueryModel = require("@immanens-com/pv5js/search/models/query-model");
var StringUtil = require("@immanens-com/pv5js/common/utils/string-util");
var DateUtil = require("@immanens-com/pv5js/common/utils/date-util");

var debug = require("debug")("models:ArticleQueryModel");    //https://github.com/visionmedia/debug

/**
 * ArticleQueryModel : recherche dans les articles retronews si du texte est rempli
 * ou dans l'index document sinon
 */
module.exports = QueryModel.extend({

    defaults: _.defaults({
        someTerms: null,
        allTerms: null,
        noneTerms: null,
        phrase: null,
        exact: false,
        highlight: true,
        highlightPosition: false,
        highlightFragments: 4,
        highlightFragmentsSize: 30,
        cover: false,
        query: "article-cc",
        sort: "score",
        documentId: 0,
        publicationId: 0,
        publication: null,
        publishedStart: null,
        publishedEnd: null,
        publishedBounds: "from",
        publishedDay: 0,
        publishedMonth: 0,
        indexedStart: null,
        indexedEnd: null,
        indexedBounds: "from",
        pageNumber: 0,               // page number
        label: null,                 // page label
        tfThemes: [],                // filtre page themes
        tfThemesOr: [],              // filtre page themes
        excludeThemes:false,
        tfPublications: [],          // filtre publication title (and)
        tfPublicationsOr: [],        // filter publication title (or)
        excludePublications:false,
        tfPersons: [],               // filtre page persons
        tfOrganizations: [],         // filtre page organizations
        tfGeolocs: [],               // filtre page location
        tfEvents: [],                // filtre page events
        tfWikitags: [],              // filtre page events
        tfHistoPeriods: [],
        tfTypes: [],                 // filtre publication type
        tfTypesOr: [],               // filtre publication type
        excludeTypes: false,
        tfPeriodicities: [],         // filtre publication periodicity
        tfPeriodicitiesOr: [],       // filtre publication periodicity
        excludePeriodicities:false,
        tfPublicationGeotagsOr: [],  // filtre publication location
        excludeGeotags:false,
        tfLangsOr: [],
        excludeLangs:false,
        superPublishedRange: null,
        useAgg: true,
        useAggPublishedRanges: true,
        access: "public",
        slop: 0,
        aggSizes: {
            histoPeriods: 20,
            persons: 5,
            organizations: 5,
            geolocs: 5,
            events: 5,
            types: 5,
            periodicities: 5,
            publications: 5,
            wikitags: 5,
            themes: 20,
            documents: 0
        },
        aggPublishedHistogram: null,
        aggNbDocuments: false,
        aggNbPublications: false
    }, QueryModel.prototype.defaults),

    whiteList: [
        "someTerms",
        "allTerms",
        "noneTerms",
        "phrase",
        "exact",
        "cover",
        "sort",
        "pageNumber",
        "publishedStart",
        "publishedEnd",
        "publishedBounds",
        "indexedStart",
        "indexedEnd",
        "indexedBounds",
        "publishedDay",
        "publishedMonth",
        "tfThemesOr",
        "tfThemes",
        "excludeThemes",
        "tfPersons",
        "tfOrganizations",
        "tfGeolocs",
        "tfEvents",
        "tfWikitags",
        "tfHistoPeriods",
        "tfTypes",
        "tfTypesOr",
        "excludeTypes",
        "tfPeriodicities",
        "tfPeriodicitiesOr",
        "excludePeriodicities",
        "tfPublications",
        "tfPublicationsOr",
        "excludePublications",
        "tfPublicationGeotagsOr",
        "excludeGeotags",
        "tfLangsOr",
        "excludeLangs",
        "slop"
    ],

    minPublishedDate: null,
    maxPublishedDate: null,

    initialize: function (/*attributes, options*/) {
        QueryModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
    },

    // called by super class
    buildQuery: function () {
        var T = this;

        var agg_sizes = T.get("aggSizes");

        var q = {
            access: T.get("access"),
            someTerms: T.get("someTerms"),
            allTerms: T.get("allTerms"),
            noneTerms: T.get("noneTerms"),
            phrase: T.get("phrase"),
            exact: T.get("exact"),
            cover: T.get("cover"),
            highlight: T.get("highlight"),
            highlightPosition: T.get("highlightPosition"),
            highlightFragments: T.get("highlightFragments"),
            highlightFragmentsSize: T.get("highlightFragmentsSize"),
            sort: T.get("sort"),
            useAgg: T.get("useAgg"),
            aggSizes: agg_sizes,
            pageNumber: T.get("pageNumber"),
            publicationId: T.get("publicationId"),
            documentId: T.get("documentId"),
            publishedStart: T.get("publishedStart"),
            publishedEnd: T.get("publishedEnd"),
            indexedStart: T.get("indexedStart"),
            indexedEnd: T.get("indexedEnd"),
            publishedMonth: T.get("publishedMonth"),
            publishedDay: T.get("publishedDay"),
            tfThemes: T.get("tfThemes"),
            tfThemesOr: T.get("tfThemesOr"),
            tfEvents: T.get("tfEvents"),
            tfWikitags: T.get("tfWikitags"),
            tfHistoPeriods: T.get("tfHistoPeriods"),
            tfPersons: T.get("tfPersons"),
            tfOrganizations: T.get("tfOrganizations"),
            tfTypes: T.get("tfTypes"),
            tfTypesOr: T.get("tfTypesOr"),
            tfPeriodicities: T.get("tfPeriodicities"),
            tfPeriodicitiesOr: T.get("tfPeriodicitiesOr"),
            tfGeolocs: T.get("tfGeolocs"),
            tfPublications: T.get("tfPublications"),
            tfPublicationsOr: T.get("tfPublicationsOr"),
            tfPublicationGeotagsOr: T.get("tfPublicationGeotagsOr"),
            tfLangsOr: T.get("tfLangsOr"),
            aggPublishedHistogram: T.get("aggPublishedHistogram"),
            aggNbDocuments: T.get("aggNbDocuments"),
            aggNbPublications: T.get("aggNbPublications"),
            slop:T.get("slop")
        };

        var published_bounds = T.get("publishedBounds");
        if (q.publishedStart && !q.publishedEnd) {
            q.publishedEnd = q.publishedStart;
        }
        if (!q.publishedStart && q.publishedEnd) {
            q.publishedStart = q.publishedEnd;
        }
        if (q.publishedStart) {
            if (published_bounds == "on") {
                q.publishedEnd = q.publishedStart;
            }
            else if (published_bounds == "before") {
                q.publishedEnd = q.publishedStart;
                q.publishedStart = T.minPublishedDate;
            }
            else if (published_bounds == "after") {
                q.publishedEnd = T.maxPublishedDate;
            }
        }

        var indexed_bounds = T.get("indexedBounds");
        if (q.indexedStart && !q.indexedEnd) {
            q.indexedEnd = q.indexedStart;
        }
        if (!q.indexedStart && q.indexedEnd) {
            q.indexedStart = q.indexedEnd;
        }
        if (q.indexedStart) {
            if (indexed_bounds == "on") {
                q.indexedEnd = q.indexedStart;
            }
            else if (indexed_bounds == "before") {
                q.indexedEnd = q.indexedStart;
                q.indexedStart = "2015-01-01";
            }
            else if (indexed_bounds == "after") {
                q.indexedEnd = new Date().toISOString().substr(0, 10);
            }
        }

        if(T.get("excludeTypes")){
            q.tfTypesNot=q.tfTypesOr;
            delete(q.tfTypesOr);
        }

        if(T.get("excludePeriodicities")){
            q.tfPeriodicitiesNot=q.tfPeriodicitiesOr;
            delete(q.tfPeriodicitiesOr);
        }

        if(T.get("excludePublications")){
            q.tfPublicationsNot=q.tfPublicationsOr;
            delete(q.tfPublicationsOr);
        }

        if(T.get("excludeLangs")){
            q.tfLangsNot=q.tfLangsOr;
            delete(q.tfLangsOr);
        }

        if(T.get("excludeThemes")){
            q.tfThemesNot=q.tfThemesOr;
            delete(q.tfThemesOr);
        }

        if (q.tfPublicationGeotagsOr) {
            // transformation en city/department/region/contry
            var countries = [];
            var cities = [];
            var departments = [];
            var regions = [];

            _.each(q.tfPublicationGeotagsOr, function (geotag) {
                var prefix = geotag.substr(0, 2);
                var value = geotag.substr(3);

                if (prefix == "co") {
                    countries.push(value);
                } else if (prefix == "ci") {
                    cities.push(value);
                }
                else if (prefix == "de") {
                    departments.push(value);
                }
                else if (prefix == "re") {
                    regions.push(value);
                }
            });

            var exclude = T.get("excludeGeotags");
            if (cities.length) {
                if(exclude){
                    q.tfPublicationCitiesNot = cities;
                }
                else{
                    q.tfPublicationCitiesOr = cities;
                }
            }
            if (countries.length) {
                if(exclude){
                    q.tfPublicationCountriesNot = countries;
                }
                else{
                    q.tfPublicationCountriesOr = countries;
                }
            }
            if (departments.length) {
                if(exclude){
                    q.tfPublicationDepartmentsNot = departments;
                }
                else{
                    q.tfPublicationDepartmentsOr = departments;
                }
            }
            if (regions.length) {
                if(exclude){
                    q.tfPublicationRegionsNot = regions;
                }
                else{
                    q.tfPublicationRegionsOr = regions;
                }
            }

            delete (q.tfPublicationGeotagsOr);

            q.useGeotag = true;
        }

        if (!q.someTerms && !q.allTerms && !q.noneTerms && !q.phrase) {
            // il n'y a pas de termes de spécifiés, on recherche dans les documents pour afficher des couvertures
            T.set("query", "document-cc");
            if (q.sort == "score") {
                q.sort = "date-asc";
            }
            q.highlight = false;
        }
        else {
            T.set("query", "article-cc");
        }

        if (q.cover) {
            q.isFirstPage = true;
        }

        // rechercher si un des tableaux en tf contient quelque chose, si oui on doit filtrer
        _.every(_.keys(q), function (key) {
            if (key.substr(0, 2) == "tf") {
                if (q[key].length) {
                    q.useFilter = true;
                    return false;
                }
            }
            return true;
        });

        if (q.tfThemes.length) {
            q.aggThemesNested = true;
        }

        if (T.get("useAggPublishedRanges")) {
            if (!q.publishedStart && !q.publishedEnd) {
                q.aggPublishedRanges = T._computeRanges(T.minPublishedDate, T.maxPublishedDate);
                T.set("superPublishedRange", null);
            }
            else {
                q.aggPublishedRanges = T._computeRanges(q.publishedStart, q.publishedEnd);
                T.set("superPublishedRange", T._computeSuperDateRange(q.publishedStart, q.publishedEnd));
            }
        }

        return q;
    },

    _computeRanges: function (date_start_str, date_end_str) {
        // 50y, 10y, 1y, 1M, 1w, 1d, (behaviour taken from : http://www.britishnewspaperarchive.co.uk/search/results?basicsearch=%2bparis)
        // attention avec les aggregations date range le "from" est compris mais pas le "to",
        // donc tous les ranges ont un jour de plus qu'il faudra retrancher au moment de faire
        // la recherche car dans la recherche le "start" et le "end" sont inclus
        var T = this,
            ret = [],
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str),
            year_diff = date_end.getUTCFullYear() - date_start.getUTCFullYear();

        T._formatPublishedRangeUnit = "year";
        T._formatPublishedRangeValue = 1;

        if (year_diff > 50) {
            // more than 50 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 50);
            T._formatPublishedRangeValue = 50;
        }
        else if (year_diff > 10) {
            // between 49 and 10 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 10);
            T._formatPublishedRangeValue = 10;
        }
        else if (year_diff > 0) {
            // between 2 and 10 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 1);
        }
        else {
            //same year
            var month_diff = date_end.getUTCMonth() - date_start.getUTCMonth();
            if (month_diff > 0) {
                ret = DateUtil.splitMonths(date_start_str, date_end_str, 1);
                T._formatPublishedRangeUnit = "month";
            }
            else {
                // same year and same month
                var day_diff = date_end.getUTCDate() - date_start.getUTCDate();
                if (day_diff > 7) {
                    ret = DateUtil.splitWeeks(date_start_str, date_end_str, 1);
                    T._formatPublishedRangeUnit = "week";
                }
                else {
                    ret = DateUtil.splitDays(date_start_str, date_end_str, 1);
                    T._formatPublishedRangeUnit = "day";
                }
            }
        }

        return ret;
    },

    _computeSuperDateRange: function (date_start_str, date_end_str) {
        var T = this,
            ret = {
                from: null,
                to: null,
                label: null
            },
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str);

        switch (T._formatPublishedRangeUnit) {
            case "year":
                // algo : on recherche si les dates sont comprises dans une cinquantaine ?
                // sinon on utilise toutes les dates (si ce sont des dates à cheval par exemple)
                if (T._formatPublishedRangeValue == 1) {
                    var y_50_1 = Math.floor(date_start.getUTCFullYear() / 50) * 50;
                    var y_50_2 = Math.ceil(date_end.getUTCFullYear() / 50) * 50;
                    if (y_50_2 - y_50_1 <= 50) {
                        ret.from = y_50_1 + "-1-1";
                        ret.to = (y_50_2 - 1) + "-12-31";
                    }
                }
                if (T._formatPublishedRangeValue != 50) {
                    ret.label = date_start.getUTCFullYear() + "-" + date_end.getUTCFullYear();
                }
                break;
            case "month":
                ret.label = date_start.getUTCFullYear();
                var ym1 = Math.floor(date_start.getUTCFullYear() / 10) * 10;
                ret.from = ym1 + "-1-1";
                ret.to = (ym1 + 10 - 1) + "-12-31"; // 10 years
                break;
            case "week":
                ret.label = STR["month_" + (date_start.getUTCMonth() + 1)] + " " + date_start.getUTCFullYear();
                var yw1 = Math.floor(date_start.getUTCFullYear());
                ret.from = yw1 + "-1-1";
                ret.to = yw1 + "-12-31"; // 1 year
                break;
            case "day":
                ret.label = STR["month_" + (date_start.getUTCMonth() + 1)] + " " + date_start.getUTCFullYear();
                var yd1 = date_start.getUTCFullYear();
                ret.from = yd1 + "-" + (date_start.getUTCMonth() + 1) + "-1";
                var lastDay = new Date(date_start);
                lastDay.setUTCMonth(lastDay.getUTCMonth() + 1);
                lastDay.setUTCDate(0);
                ret.to = yd1 + "-" + (lastDay.getUTCMonth() + 1) + "-" + lastDay.getUTCDate(); // month
                break;
        }

        return ret;
    },

    fetchFrom: function (index, options) {
        var T = this;
        if (T.fetching) {
            return;
        }
        var final_options = options || {};
        return T.fetch({
            "from": index,
            "size": T.get("pageSize")
        }, final_options);
    },

    parse: function (response/*, xhr*/) {
        var T = this;
        // correct aggregation labels in date range
        if (response.aggregations && response.aggregations.publishedRanges && response.aggregations.publishedRanges.buckets) {
            response.aggregations.publishedRanges.buckets.forEach(function (bucket) {
                // on enlève 1 jour à la date "to" pour respecter le formalisme de recherche (to et from inclus)
                var to = DateUtil.dateFactory(bucket.to_as_string);
                to.setUTCDate(to.getUTCDate() - 1);
                bucket.to_as_string = to.getUTCFullYear() + "-" + StringUtil.pad(to.getUTCMonth() + 1, 2) + "-" + StringUtil.pad(to.getUTCDate(), 2);
                bucket.from_to_as_string = T._labelPublishedDateRange(bucket.from_as_string, bucket.to_as_string);
            });

        }
        return T.constructor.__super__.parse.apply(T, arguments);
    },

    _labelPublishedDateRange: function (date_start_str, date_end_str) {
        var T = this,
            ret,
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str);
        switch (T._formatPublishedRangeUnit) {
            case "year":
                if (date_start.getUTCFullYear() == date_end.getUTCFullYear()) {
                    ret = date_start.getUTCFullYear();
                }
                else {
                    ret = date_start.getUTCFullYear() + "-" + date_end.getUTCFullYear();
                }
                break;
            case "month":
                ret = STR["month_" + (date_start.getUTCMonth() + 1)];
                break;
            case "week":
                ret = date_start.getUTCDate() + "-" + date_end.getUTCDate();
                break;
            case "day":
                ret = date_start.getUTCDate();
                break;
        }
        return ret;
    },

    /**
     * Check if query contain highlitable terms
     * @return {Boolean}
     */
    hasTerms: function () {
        var T = this,
            ret = false;
        if (T.get("allTerms") || T.get("someTerms") || T.get("phrase")) {
            ret = true;
        }
        return ret;
    },

    /**
     * Returns applied filters
     * @return {Object}
     */
    appliedFilters: function () {
        var T = this,
            filters = {};

        _.each(T.keys(), function (key) {
            if (key.substr(0, 2) == "tf") {
                filters[key] = T.get(key);
            }
        });

        filters.tfPublishedRanges = {
            start: T.get("publishedStart"),
            end: T.get("publishedEnd")
        };

        return filters;
    },

    reset: function () {
        this.set(_.pick(this.defaults, this.whiteList));
    },

    resetFilters: function () {
        this.set({
            tfThemes: [],                // filtre page themes
            tfPublications: [],          // filtre publication title (and)
            tfPersons: [],               // filtre page persons
            tfOrganizations: [],         // filtre page organizations
            tfGeolocs: [],               // filtre page location
            tfEvents: [],                // filtre page events
            tfWikitags: [],              // filtre page events
            tfHistoPeriods: [],              // filtre page events
            tfTypes: [],                 // filtre publication type
            tfPeriodicities: [],         // filtre publication periodicity
            publishedStart: null,
            publishedEnd: null,
        });
    }

});

},{"@immanens-com/pv5js/common/utils/date-util":38,"@immanens-com/pv5js/common/utils/string-util":40,"@immanens-com/pv5js/search/models/query-model":53,"debug":56,"underscore":61}],33:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * DocumentOfTheDayModel represent the retronews "Document du jour" concept
 */
module.exports=Backbone.Model.extend({
  
    rnapi:null,

    defaults: {
        publicationId:0,
        documentId:0,
        publicationTitle:null,
        publicationDate:null
    },

    urlRoot:function(){
        return this.rnapi+"/document-of-the-day";
    },

    /**
     * @param  {object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    }

});
},{"backbone":55,"underscore":61}],34:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * HiglightedDocument represent the retronews "Une emblématique" concept
 */
module.exports = Backbone.Model.extend({
  
    rnapi:null,

    defaults: {
        publicationId:0,
        documentId:0,
        publicationTitle:null,
        publicationDate:null
    },

    urlRoot:function(){
        return this.rnapi+"/hldoc";
    },

    /**
     * @param  {object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    }

});
},{"backbone":55,"underscore":61}],35:[function(require,module,exports){
/**
 Les libellés des périodes historiques ayant servis à la réindexation du fonds en sept 2018 sont erronés suite à une mauvaise communication de BnF.
Afin d'éviter une réindexation du fonds, il a été décidé d'hardcoder les libellés en front dans l'app RetroNews.
key : valeur indexées en 2018
label : label affichée dans l'app
 */
module.exports = [
    {
        key: "Grand siècle de Louis XIV",
        label: "Grand siècle (-1715)"
    },
    {
        key: "Siècle des Lumières",
        label: "Siècle des Lumières (1715-1789)"
    },
    {
        key: "La Révolution (1789 - 1799)",
        label: "Révolution française (1789-1799)"
    },
    {
        key: "Consulat et Empire (1799-1814)",
        label: "Consulat et Empire (1799-1814)"
    },
    {
        key: "La Restauration (1814-1830)",
        label: "Restauration (1814-1830)"
    },
    {
        key: "Monarchie de Juillet (1830-1848)",
        label: "Monarchie de Juillet (1830-1848)"
    },
    {
        key: "La IIe République (1848-1852)",
        label: "IIᵉ République (1848-1852)"
    },
    {
        key: "Le Second Empire (1852-1870)",
        label: "Second Empire (1852-1870)"
    },
    {
        key: "La Commune",
        label: "Commune (1870-1871)"
    },
    {
        key: "Les Débuts de la IIIème République (1871-1898)",
        label: "Débuts de la IIIᵉ Rép. (1871-1898)"
    },
    {
        key: "La République radicale (1898-1914)",
        label: "République radicale (1898-1914)"
    },
    {
        key: "Première guerre mondiale (1914-1918)",
        label: "Première guerre mondiale (1914-1918)"
    },
    {
        key: "Entre deux guerres",
        label: "Entre-deux-guerres (1918-1939)"
    },
    {
        key: "Seconde guerre mondiale (1939-1945)",
        label: "Seconde guerre mondiale (1939-1945)"
    },
    {
        key: "GPRF (1944-1946)",
        label: "GPRF (1944-1946)"
    },
    {
        key: "IVè république",
        label: "IVᵉ République (1946-1958)"
    },
    {
        key: "Vè république",
        label: "Vᵉ République (1958-)"
    }
];
},{}],36:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;
var debug = require("debug")("views:ArticleResultView");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var SelectedDocumentModel = require("../../common/models/selected-document-model.js");
var HiglightedDocumentModel = require("../models/highlighted-document-model.js");
var DocumentOfTheDayModel = require("../models/document-of-the-day-model.js");

// ArticleResultView : affiche un résultat de recherche sur l'index article (recherhe avec texte) ou document (affichage couverture)
module.exports = Backbone.View.extend({

    tagName: "div",
    className: "page-result",
    events: {
        "click .select-document": "onSelectDocumentClicked",
        "click .selection": "onSelectDocumentClicked",
        "click .hl-document": "onHlDocumentClicked",
        "click .document-otd": "onDocumentOTDClicked",
        "click .share-facebook": "onShareFacebookClicked",
        "click .share-twitter": "onShareTwitterClicked"
    },

    template: null, // external template
    model: null, // PageResultModel
    pv5api: null, // pressview5 api url
    rnapi: null, // retronews api url
    cropWidth: 360, // crop width
    cropHeight: 200, // crop height
    cropFontSize: 13, // font size
    userModel: null, // user model
    app: null,
    queryModel:null,
    index:false, // index du résultat dans l'ensemble des résultats de la recherche
    from:'', // si indiqué, renseigne l'url appelante

    /**
     * @param  {[type]} options option must contain a query model and a template
     * @return {[type]}         [description]
     */
    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.template = _.template(T.template);
    },

    /**
     * [render description]
     * @return {[type]} [description]
     */
    render: function() {
        debug("render");
        var T = this,
            context = T.model.toJSON();

        // defaults
        context.dateFR = "";
        context.publicationTitle = context.publicationTitle || "";
        context.documentTitle = context.documentTitle || "";

        context.reader = T.readerUrl();
        context.crop = T.cropUrl();

        context.cropWidth = T.cropWidth;
        context.cropHeight = T.cropHeight;

        context.published = context.published|| "1900-01-01";
        context.access = context.access || "public";
        context.query=T.queryModel.get("query");

        //todo : ajouter les paramètres de recherche alltems et someterms pour que le lecteur rejoue la recherche dans la page
        context.search = "";

        if(context.query=="document"||context.query=="document-cc"){
            context.documentTitle=context.title;
            context.pageNumber=null; // on n'affiche pas la page si on recherche des documents
            context.title=null;
            context.main=false;
        }
        else{
            if(context.title && context.title.length > 200){
                context.title=context.title.substr(0,200)+"...";
            }
        }

        // TODO à mettre en commun quelque part ?
        if(context.documentTitle){
            context.documentTitle=context.documentTitle.trim();
        }
        var regNumber = new RegExp("^[0-9]+$"); // 123
        var regNumberWithN = new RegExp("^N[0-9]+$"); // N123
        var regYearNumber = new RegExp("^A[0-9]+,N[0-9]+$"); // A5,N4523
        if (regNumber.test(context.documentTitle)) {
            context.documentTitle = "n°&nbsp;" + context.documentTitle;
        } else if(regNumberWithN.test(context.documentTitle)) {
            context.documentTitle = "n°&nbsp;" + context.documentTitle.substr(1);
        } else if(regYearNumber.test(context.documentTitle)) {
            var doc_title_split=context.documentTitle.split(",");
            context.documentTitle = "a.&nbsp;"+doc_title_split[0].substr(1)+", n°&nbsp;" + doc_title_split[1].substr(1);
        }

        T.$el.html(T.template(context));

        if (T.userModel.isAdmin() || T.userModel.isBnf()) {
            T.$(".menu").addClass("show");
        }

        T.$el.addClass("access-"+context.access);

        return T;
    },



    onSelectDocumentClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        T.app.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        var se = new SelectedDocumentModel({
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published
        }, {
            rnapi: T.rnapi
        });
        se.save(null, {
            success: function() {
                T.app.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function() {
                T.app.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
    },

    readerUrl: function() {
        var T = this,
            document_id = T.model.get("documentId")||T.model.get("id"),
            publication_id = T.model.get("publicationId"),
            number = T.model.get("pageNumber")||T.model.get("firstPage"),
            publication_title = T.model.get("publicationTitle"),
            published = STR.date(T.model.get("published")),
            path = window.location.pathname + window.location.hash + "&total=" + T.queryModel.get("total"),
            article_id=T.model.get("articleId");

         var url= "/journal/" + UrlUtil.slugify(publication_title) + "/" + UrlUtil.slugify(published) + "/" + publication_id + "/" + document_id + "/" + number;
         if(article_id && article_id!="combined"){
             url+="/"+article_id;
         }
         if(T.from) {
            url+="?from=" + encodeURIComponent(T.from);
         }
         else {
            url+="?from=" + encodeURIComponent(path);
         }
       
         if(T.index !== false && T.index !== undefined) {
             url+="&index="+T.index;
         }

         return url;
    },

    cropUrl: function() {
        var T = this,
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId"),
            page_number = T.model.get("pageNumber")||T.model.get("firstPage"), // résultat article / résultat document
            highlight = T.model.get("highlight"),
            crop;

        var pageUrl = T.pv5api + "/document/" + publicationId + "/" + documentId + "/page/" + page_number;

        if (highlight && highlight.words && highlight.words.length) {
            crop = pageUrl + "/crop/" + T.cropWidth + "/" + T.cropHeight + "/" + T.cropFontSize;
            crop += "/words/" + highlight.words.join(",");
        } else {
            crop = pageUrl + "/thumbnail";
        }

        return crop;
    },

    onShareTwitterClicked: function() {
        var T = this,
            root = window.location.protocol + "//" + window.location.hostname,
            url = root + T.readerUrl(),
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            message = pubTitle + ", " + STR.date(published); // use template ?

        if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }

        window.open(UrlUtil.shareTwitter(message, url, "RetroNewsFR"), "_blank");
    },

    onShareFacebookClicked: function() {
        //https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4
        var T = this,
            root = window.location.protocol + "//" + window.location.hostname,
            url = root + T.readerUrl(),
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            message = STR.facebook_message,
            app_id = T.app.facebookAppId,
            caption = pubTitle + ", " + STR.date(published),
            picture = T.cropUrl();

        if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }

        window.open(UrlUtil.shareFacebook(
            app_id, {
                display: "page",
                caption: caption,
                description: message,
                link: url,
                picture: picture
            }), "_blank");
    },

    onHlDocumentClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            docTitle = T.model.get("documentTitle")||T.model.get("title"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        var r = window.confirm("Etes-vous sûr de vouloir définir " + pubTitle + " " + docTitle + " du " + STR.date(published) + " comme \"Une emblématique\" ?");
        if (r) {

            var hl = new HiglightedDocumentModel({
                documentId: documentId,
                publicationId: publicationId,
                publicationTitle: pubTitle,
                publicationDate: published
            }, {
                rnapi: T.rnapi
            });
            T.app.notify({
                text: STR.save_in_progress + "...",
                type: "info",
                timeout: 3000
            });
            hl.save(null, {
                success: function() {
                    T.app.notify({
                        text: STR.save_ok,
                        type: "info",
                        timeout: 1000
                    });
                },
                error: function() {
                    T.app.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
        }
    },

    onDocumentOTDClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            docTitle = T.model.get("documentTitle")||T.model.get("title"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        var r = window.confirm("Etes-vous sûr de vouloir définir " + pubTitle + " " + docTitle + " du " + STR.date(published) + " comme \"Une du jour\" ?");
        if (r) {

            var doc_otd = new DocumentOfTheDayModel({
                documentId: documentId,
                publicationId: publicationId,
                publicationTitle: pubTitle,
                publicationDate: published
            }, {
                rnapi: T.rnapi
            });
            T.app.notify({
                text: STR.save_in_progress + "...",
                type: "info",
                timeout: 3000
            });
            doc_otd.save(null, {
                success: function() {
                    T.app.notify({
                        text: STR.save_ok,
                        type: "info",
                        timeout: 1000
                    });
                },
                error: function() {
                    T.app.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
        }
    },

    close: function() {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});
},{"../../common/models/selected-document-model.js":1,"../models/document-of-the-day-model.js":33,"../models/highlighted-document-model.js":34,"@immanens-com/pv5js/common/utils/url-util":41,"backbone":55,"debug":56,"jquery":58,"underscore":61}],37:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");

/**
 * BaseModel : add a flag when model is fetching/fetched
 */

module.exports = Backbone.Model.extend({

    hasChangedSinceLastSync: false,

    fetched: false,
    fetching: false,
    token: null,
    cookie: null,
    mtime: 0,
    withCredentials: false,

    initialize: function (attributes, options) {
        Backbone.Model.prototype.initialize.apply(this, arguments);

        // on autorise l'injection de ajax et jquery pour que la classe puisse être utilisée aussi côté server
        if (options) {
            if (options.jQuery) {
                Backbone.$ = options.jQuery;
            }
            if (options.ajax) {
                Backbone.ajax = options.ajax;
            }
        }
    },

    fetch: function (options) {
        var T = this,
            new_options = options ? _.clone(options) : {},
            success_cb = new_options.success,
            error_cb = new_options.error;

        if (T.withCredentials) {
            new_options.xhrFields = new_options.xhrFields || {};
            new_options.xhrFields.withCredentials = true; // pour autoriser les cookies avec les requêtes ajax
        }

        T.fetching = true;
        new_options.success = function (model, response, options) {
            T.fetched = true;
            T.fetching = false;
            if (success_cb) {
                success_cb(model, response, options);
            }
        };
        new_options.error = function (model, response, options) {
            T.fetching = false;
            if (error_cb) {
                error_cb(model, response, options);
            }
        };

        return Backbone.Model.prototype.fetch.call(T, new_options);
    },

    sync: function (method, model, options) {
        var T = this,
            new_options = options ? _.clone(options) : {};

        if (!new_options.headers) {
            new_options.headers = {};
        }

        if (T.token) {
            new_options.headers["x-access-token"] = T.token;
        }

        if (T.cookie) {
            new_options.headers.cookie = T.cookie;
        }

        var success = new_options.success;
        new_options.success = function (resp) {
            if (success) {
                success(resp);
            }
            model.hasChangedSinceLastSync = false;
        };

        return Backbone.Model.prototype.sync.call(T, method, model, new_options);
    },

    addQueryStringArrayToUrl:function(base_url,query_string){
        if(query_string.length){
            base_url+="?"+query_string.join("&");
        }
        return base_url;
    }
});
},{"backbone":55,"underscore":46}],38:[function(require,module,exports){
"use strict";

/**
 * DateUtil
 */
module.exports = {

	/**
	 * @param  {String} date_str waiting format :yyyy-MM-dd
	 * @return {Date}
	 */
	dateFactory: function (date_str) {
		if (!date_str) return null;
		var date_array = date_str.split("-");

		if (date_array.length == 3) {
			// ie n'a l'air d'accepter que le format 1900-01-01
			// contrairement à chrome et ff où on peut passer l'heure en plus avec T00:00:01+0000
			return new Date(Date.UTC(parseInt(date_array[0]), parseInt(date_array[1]) - 1, parseInt(date_array[2])));
		} else {
			return null;
		}
	},

	/**
	 * return last day of month
	 * @param  {Number} year  [description]
	 * @param  {Number} month 1-12
	 * @return {Number}       [description]
	 */
	lastDay: function (year, month) {
		var d = new Date(Date.UTC(year, month, 0)); // month - one day
		return d.getUTCDate();
	},

	/**
	 * Make dates ranges between a min and max date, using N years interval.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval   number of years
	 * @return {Array}            "from" included, "to" not included.
	 */
	splitYears: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str),
			year_start = date_start.getUTCFullYear(),
			year_end = date_end.getUTCFullYear() + 1;

		year_start = Math.floor(year_start / interval) * interval;
		year_end = Math.ceil(year_end / interval) * interval;

		while (year_start < year_end) {
			ret.push({
				from: year_start + "-01-01",
				to: (year_start + interval) + "-01-01"
			});
			year_start += interval;
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using N months intervals.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of months
	 * @return {[type]}                [description]
	 */
	splitMonths: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);

		date_start.setUTCDate(1); // first day of month
		date_end.setUTCMonth(date_end.getUTCMonth() + 1, 1); // first day of next month

		while (date_start < date_end) {
			var next_month = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth() + interval, 1));
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_month.getUTCFullYear() + "-" + (next_month.getUTCMonth() + 1) + "-" + next_month.getUTCDate()
			});
			date_start.setUTCMonth(date_start.getUTCMonth() + interval);
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using 7 days interval, grouped by month.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of weeks
	 * @return {[type]}                [description]
	 */
	splitWeeks: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);

		date_start.setUTCDate(1); // first day of month
		date_end.setUTCMonth(date_end.getUTCMonth() + 1, 1); // first day of next month next

		while (date_start < date_end) {
			var next_week = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth(), date_start.getUTCDate() + (interval * 7)));
			if (date_start.getUTCMonth() != next_week.getUTCMonth()) {
				next_week = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth() + 1, 1));
			}
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_week.getUTCFullYear() + "-" + (next_week.getUTCMonth() + 1) + "-" + next_week.getUTCDate()
			});
			date_start = new Date(next_week);
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using 1 days interval
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of days
	 * @return {[type]}                [description]
	 */
	splitDays: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);
		date_end.setUTCDate(date_end.getUTCDate() + 1);

		while (date_start < date_end) {
			var next_day = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth(), date_start.getUTCDate() + interval));
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_day.getUTCFullYear() + "-" + (next_day.getUTCMonth() + 1) + "-" + next_day.getUTCDate()
			});
			date_start.setUTCDate(date_start.getUTCDate() + interval);
		}

		return ret;
	}

};
},{}],39:[function(require,module,exports){
"use strict";

var $         = require("jquery");            

/**
 * DOM utility class
 */
var DomUtil = {

    /**
     * Determine vendor specific css properties. 
     * This function create a div element, so it uses a lot of resources, result must be cached
     * @param  {String} prop "borderRadius" for exemple
     * @return {String}      return appropriate css property name
     */
    styleSupport:function ( prop ) {
        var vendorProp, supportedProp,

        // Capitalize first character of the prop to test vendor prefix
        capProp = prop.charAt( 0 ).toUpperCase() + prop.slice( 1 ),
        prefixes = [ "Moz", "Webkit", "O", "ms" ],
        div = document.createElement( "div" );

        if ( prop in div.style ) {
            // Browser supports standard CSS property name
            supportedProp = prop;
        }
        else {
            // Otherwise test support for vendor-prefixed property names
            for ( var i = 0; i < prefixes.length; i++ ) {
                vendorProp = prefixes[ i ] + capProp;
                if ( vendorProp in div.style ) {
                    supportedProp = vendorProp;
                    break;
                }
            }
        }

        // Avoid memory leak in IE
        div = null;

        return supportedProp;
    },

    /**
     * Determine which input events must be supported
     * @return {String} touch, pointer, or mouse
     */
    inputSupport:function () {
        var input;
        if("ontouchstart" in window){
            input="touch";
        }
        else if(window.navigator.pointerEnabled){
            input="pointer";            
        }
        else{
            input="mouse";
        }
        return input;
    },

    /**
     * Check if an element is partially visible in viewport
     * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
     * @param  {HTMLElement}  el 
     * @return {Boolean}    
     */
    isElementInViewport:function(el) {
        var rect = el.getBoundingClientRect();
        return !(
            rect.bottom <= 0 ||
            rect.top >= $(window).height()
        );
    },

    /**
     * check if current key down/up event occurs in an edit box like
     * @param  {Event}  e event fom keydow or keyup event
     * @return {Boolean}        [description]
     */
    isEditing:function(e){
        return (/input|textarea|select/i.test(e.target.nodeName) || e.target.contentEditable=="true");
    },

    /**
     * scroll to a position smoothly
     * @param  {Number} pos 
     */
    scrollTo:function(pos){
        $("html, body").animate({
            scrollTop: pos
        }, 500);
    },

    /**
     * Transforme duplique les events click en touchstart. C'est necessaire sur ipad car le système attends 400 ms 
     * avant de déclencher un click pour le différencier d'un drag ce qui donne une impression de lenteur
     * Attention a mettre un preventDefault dans la fonction pour ne pas avoir 2 events dans le cas où le device est à la fois tactile et souris
     * @param  {Object} events [description]
     * @return {Object}        [description]
     */
    clickToTouch:function(events){
        if(this.inputSupport()=="touch"){
            // transform click to touch events
            for (var key in events) {  
                if(key.indexOf("click")===0){  
                    var method=events[key];
                    var new_key=key.replace("click","touchstart");
                    events[new_key]=method;
                }
            }
        }
        return events;
    }

    
};

module.exports = DomUtil;
},{"jquery":58}],40:[function(require,module,exports){
"use strict";

/**
 * utility class working with strings
 */
var StringUtil = {

    dashToCamel:function(str){
        return str.toLowerCase().replace(/-(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToDash:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    },

    underscoreToCamel:function(str){
        return str.toLowerCase().replace(/_(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToUnderscore:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    },

    pad:function(number,length,c){
        var str = String(number);
        c = c || "0";
        while (str.length < length)
            str = c + str;
        return str;
    }
    
};

module.exports = StringUtil;
},{}],41:[function(require,module,exports){
"use strict";

var QueryString = require("qs"); // https://github.com/hapijs/qs
var _ = require("underscore");


var UrlUtil = {

    /**
     * parse query string and return only fields specified in whitelist array
     * @param  {String} queryString
     * @param  {Array of Strings} whiteList
     * @return {Object}
     */
    parseQueryString: function(query_string, white_list) {
        var qs_obj = QueryString.parse(query_string);
        var qs_obj_filtered = _.pick(qs_obj, white_list);
        return qs_obj_filtered;
    },

    /**
     * generate query string based on fields specified in whithelist array
     * @param  {Object} obj
     * @param  {Array of Strings} whiteList
     * @return {String}          an url query string
     */
    generateQueryString: function(obj, white_list) {
        var qs = QueryString.stringify(obj, {
            filter: function(prefix, value) {
                prefix = prefix.split("[")[0];
                if (prefix === "") {
                    return value;
                } else {
                    if (white_list.indexOf(prefix) != -1) {
                        if (value) // ignore 0, null and ""
                            return value;
                        else
                            return;
                    } else {
                        return;
                    }
                }
            }
        });
        return qs;
    },

    /**
     * Generate a facebook share link
     * @param  {String} app_id  see https://developers.facebook.com/
     * @param  {Object} options display + caption + description + link + redirect_uri + picture (see https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4)
     * @return {String}         can be used in a new page with window.open(url_share, "_blank");
     */
    shareFacebook: function(app_id, options) {
        var url_share = "https://www.facebook.com/dialog/feed?app_id=" + app_id;

        _.each(
            options,
            function(value, key) {
                url_share += "&" + key + "=" + encodeURIComponent(value);
            }
        );

        return url_share;
    },

    /**
     * Generate a twitter share link : https://dev.twitter.com/web/tweet-button/web-intent
     * @param  {String} message
     * @param  {String} link
     * @return {String}             can be used in a new page with window.open(url_share, "_blank");
     */
    shareTwitter: function(message, link, via) {
        return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(link) + "&text=" + encodeURIComponent(message) + "&via=" + encodeURIComponent(via);
    },

    /**
     * transforme une string en une url lisible en ascii
     * @param  {String} str [description]
     * @return {String}     [description]
     */
    slugify: function(str) {

        if (!str) {
            return "";
        }

        var i, ch, pos, new_str = "";

        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        // on met les caractères les plus courants au début

        var fr = "'èéêôçîûàïáäâëìíòóöùúüñ,";
        var to = "-eeeociuaiaaaeiiooouuun-";

        for (i = 0; i < str.length; i++) {
            ch = str.charAt(i);
            pos = fr.indexOf(ch);
            new_str += (pos == -1) ? ch : to.charAt(pos);
        }

        new_str = new_str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return new_str;
    },

    /**
     * update or create meta tag in head.
     * @param {String} attr
     * @param {String} value
     * @param {String} content
     */
    meta: function(attr, value, content) {
        var meta = document.head.querySelector("[" + attr + "='" + value + "']");
        if (meta) {
            meta.content = content;
        } else {
            meta = document.createElement("meta");
            meta.setAttribute(attr,value);
            meta.content = content;
            document.head.appendChild(meta);
        }
    }



};

module.exports = UrlUtil;

},{"qs":42,"underscore":46}],42:[function(require,module,exports){
// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};

},{"./parse":43,"./stringify":44}],43:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = Utils.decode(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = Utils.decode(part.slice(0, pos));
            val = Utils.decode(part.slice(pos + 1));
        }
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};

},{"./utils":45}],44:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};

},{"./utils":45}],45:[function(require,module,exports){
// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};

},{}],46:[function(require,module,exports){
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define === 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}.call(this));

},{}],47:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");
var PageModel = require("./page-model");

var debug = require("debug")("models:DocumentModel");    //https://github.com/visionmedia/debug


/**
 * DocumentModel
 */

module.exports = BaseModel.extend({

    pv5api: null,
    useTokenCookie: false, // utilisation du token passé par cookie pour les appels aux pages et images
    
    defaults: {
        nbPages: 0,          // nombre de pages du pdf
        publicationId: 0,    // identifiant de publication dans pv5
        publicationTitle: null,
        published: null,     // release date
        title: null,         // document title
        isDouble: false,     // double or simple page production
        pages: null,         // page models collection
        page: 0,             // current page number (left page if double)
        isTextMissing: false,// text of document available
        isXml: false,        // xml description available
        toc: 0,              // toc pdf page
        logisticId: null,           // identifiant du logisticien
        documentLogisticId: 0,      // identifiant du document chez le logisticien ci-dessus
        publicationLogisticId: 0,   // identifiant de la publication chez le logisticien ci-dessus
        mtime: 0,            // timestamp de modification du zpa (ajouté à la volée par le serveur)
        reversed: false,     // sens de lecture inversé
        hasToc:false,        // toc.json disponible dans le xml
        hasLayout:false,      // layout.json disponible dans xml
        hasPDF: false,        // pdf available
        lang:null,    
        pdfDocument: null, // document pdf chargé par la lib pdfjs https://mozilla.github.io/pdf.js/api/draft/module-pdfjsLib-PDFDocumentProxy.html
        serverPdfMaxPages: 100, // nombre de pages limite par pdf généré pour l'impression
    },

    urlRoot: function () {
        return this.pv5api + "/document/" + this.get("publicationId");
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);

        var T = this;
        debug("initialize");
        _.extend(T, options);

        if (T.useTokenCookie) {
            T.withCredentials = true;
        }

        this.set({
            "pages": new Backbone.Collection()
        });
    },

    /**
     * get page model from collection, fetch it if not already done
     * @param  {Number} page
     * @return {PageModel}
     */
    getPageModel: function (page) {
        // get page from collection and fetch if necessary
        var T = this;

        if (!page || page < 1 || page > T.get("nbPages")) {
            return;
        }

        var page_model = T.get("pages").get(page);

        if (!page_model) {
            var page_options = {
                pv5api: T.pv5api,
                isDocumentDouble: T.get("isDouble"),
                mtime: T.get("mtime")
            };
            if (T.token) {
                if (T.useTokenCookie) {
                    page_options.withCredentials = true; // pour que ça soit le token du cookie qui soit utilisé
                }
                else {
                    page_options.token = T.token; // pour que le token se retrouve dans l'url
                }
            }
            page_model = new PageModel(
                {
                    id: page,
                    publicationId: T.get("publicationId"),
                    documentId: T.get("id")
                },
                page_options
            );
            T.get("pages").add(page_model);
            page_model.fetch();
        }

        return page_model;
    },

    thumbnailUrl: function (page) {
        var T = this;
        return T.pageUrl(page) + "/thumbnail";
    },

    pageUrl: function (page) {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/page/" + page;
    },

    pdfUrl: function () {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/vecto" ;
    }

});

},{"../../common/models/base-model":37,"./page-model":48,"backbone":55,"debug":56,"underscore":46}],48:[function(require,module,exports){
"use strict";

var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");

var debug = require("debug")("models:PageModel");    //https://github.com/visionmedia/debug

/**
 * PageModel
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        documentId: 0,
        documentTitle: null,
        publicationId: 0,
        publicationTitle: null,
        published: null,
        width: 0,
        height: 0,
        tileSize: 512,     // widelook tile size parameter
        divider: 2,        // widelook divider parameter
        label: [],
        number: [],
        links: [],
        nbLevels: 0,
        isDouble: false
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id page number
     * @param  {Object} attributes.documentId document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId(),
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    serverId: function () {
        var T = this,
            id = T.get("id");
        if (T.isDocumentDouble) {
            if (id != 1 && id % 2) {
                id = id - 1; // si le document est produit en double page, il n'y a des données que pour les pages paires
            }
        }
        return id;
    },

    _computeNbLevels: function (imageWidth, imageHeight, divider, tileSize) {
        var nbLevels = 1,
            val = Math.max(imageWidth, imageHeight);

        while (val > tileSize) {
            val = val / divider;
            nbLevels++;
        }

        //console.log("Nb levels: "+nbLevels);
        return nbLevels;
    },

    tileUrl: function (row, column, level) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/tile/" + row + "/" + column + "/" + level,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    thumbnailUrl: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/thumbnail",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    svgUrl: function (sub) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/svg/" + sub,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    textUrl: function (rectangle) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/text",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        if (rectangle) {
            query_string.push("rectangle=" + rectangle.top + "," + rectangle.left + "," + rectangle.bottom + "," + rectangle.right);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    parse: function (data) {
        data.nbLevels = this._computeNbLevels(data.width, data.height, data.divider || 2, data.tileSize || 512);
        data.isDouble = data.number.length == 2 ? true : false;
        return data;
    }

});
},{"../../common/models/base-model":37,"debug":56,"underscore":46}],49:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;

var DomUtil = require("../../common/utils/dom-util");
var PageView = require("./page-view");

var debug = require("debug")("views:DocumentView");

/**
 * DocumentView : display a pv5 document
 * Triggers
 * - "change:page-position" :
 * - "add:page-view"        :
 * - "render:page-view"
 * - "refresh:page-view"    : todo
 * - "remove:page-view"     : todo
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    elWidth: 0, // width of main el
    elHeight: 0, // height of main el
    isPortrait: false, // interface orientation
    pageViews: null, // array of pageViews
    zoomMax: 1,
    zoomFav: 1,
    enable: true,
    startFit: null, // fit initial demandé
    tileHd: false,
    authorizedPages: null,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)

    events: {
        "contextmenu": "preventDefault", // Disables context menu
        "MSHoldVisual": "preventDefault", // Disables visual
        "touchmove": "preventDefault", // Stop page from panning on iPhone OS.
        "dragstart": "preventDefault", // disable Firefox's default drag and drop behavior
        "pointerdown": "onDragStart", // use event unification
        "webkitTransitionEnd": "onTransitionEnd",
        "transitionend": "onTransitionEnd"
    },

    /**
     * @param  {Object}         options
     * @param  {DocumentModel}  options.documentModel
     * @param  {Element}        options.el element to attach this view
     * @param  {String}         options.pageTemplate page placeholder underscore template (optional)
     * @param  {String}         options.pageAuthorizationTemplate page authorization template, underscore template (optional)
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.pageViews = [];
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;
        T._pendingPage = 0;
        T._pointers = {};


        T.listenTo(T.model, "sync", T.onDocumentLoaded);
        T.listenTo(T.model, "change:page", T.onPageChanged);

        T.$documentContainer = $("<div/>", {
            class: "container"
        });

        if (!T.embed) {
            T.$documentContainer.css("touch-action", "none");
        }

        debug(navigator.userAgent.toLowerCase());

        T.transitionStyle = DomUtil.styleSupport("transition");
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },

    onDocumentLoaded: function () {
        var T = this;
        T.render();
    },

    onTransitionEnd: function (e) {
        var T = this;
        if (e.target == T.$documentContainer[0] && e.originalEvent.propertyName == "left" && T._pendingPage) {
            T.model.set("page", T._pendingPage);
            T.preloadNextPage(T._pendingPage);
            T.preloadPreviousPage(T._pendingPage);
            T.removeUnusedPages();
            T._pendingPage = 0;
        }
    },

    preventDefault: function (e) {
        e.preventDefault();
    },

    render: function () {
        var T = this;

        if (!T.model.fetched) {
            return;
        }

        T.$documentContainer.appendTo(T.el);

        debug("render");
        T.resize();
    },

    onPagePositionChanged: function (page_view) {
        this.trigger("change:page-position", page_view);
    },

    onPageZoomFavChanged: function (page_view) {
        this.zoomFav = page_view.zoomFav;
    },

    onPageRendered: function (page_view) {
        this.trigger("render:page-view", page_view);
    },

    /**
     * update elements sizes when a size or
     * @return {[type]} [description]
     */
    resize: function () {
        var T = this;
        if (!T.model.fetched) return;
        if (!T.enable) return;

        T.elHeight = T.$el.height();
        T.elWidth = T.$el.width();

        var prev_orientation = T.isPortrait;
        T.isPortrait = (T.elWidth < T.elHeight) ? true : false;

        var nbScreens = T.model.get("nbPages");

        if (T.pageViews.length && prev_orientation != T.isPortrait) {
            //
            T.pageViews.forEach(function (view) {
                T.unloadPage(view.page);
            });
            T.loadPage(T.model.get("page"));
        }

        T.$documentContainer.css({
            width: T.elWidth * nbScreens
        });

        T.refresh();
        T.scrollTo(T.pagePosition(T.model.get("page")), false);
    },

    onDragStart: function (e) {
        var T = this;
        //console.log("drag start doc "+e.type);

        if (T._pendingPage) return;

        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = e.pageX;
            T._dragStartPoint.y = e.pageY;
            $(window).on("pointermove.pv5-doc", function (e) {
                T.onDragMove(e);
            });
            $(window).on("pointerup.pv5-doc", function (e) {
                T.onDragEnd(e);
            });
            $(window).on("pointercancel.pv5-doc", function (e) {
                T.onDragEnd(e);
            });
            T._dragStartLeft = -T.pagePosition(T.model.get("page"));
        } else {
            T._abortDrag = true;
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);
    },

    onDragMove: function (e) {
        var T = this;

        if (T._abortDrag) return;

        var page_view = T.currentPageView();

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            T.$el.addClass("grabbing");
            if (page_view) {
                if (!page_view.isZoomed()) {
                    T.scrollTo(-T._dragStartLeft + (T._dragStartPoint.x - e.pageX), false);
                }
            }
        }
    },

    onDragEnd: function (e) {
        var T = this;

        delete T._pointers[e.originalEvent.pointerId];

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);


        var left = T.$documentContainer[0].offsetLeft,
            delta = T._dragStartLeft - left,
            tolerance = 40,
            page = T.model.get("page"),
            last_page = T.model.get("nbPages"),
            abort = false;

        if (T._abortDrag) {
            abort = true;
        } else {
            //console.log("drag end doc");
            if (Math.abs(delta) < tolerance) {
                abort = true;
            } else {
                if (delta > 0) {
                    if (page == last_page) {
                        abort = true;
                    } else {
                        T.gotoPage("next", true);
                    }
                } else if (delta < 0) {
                    if (page == 1) {
                        abort = true;
                    } else {
                        T.gotoPage("previous", true);
                    }
                }
            }
        }
        if (abort) {
            T.scrollTo(-T._dragStartLeft, true);
        }
        if (!keys.length) {
            $(window).off(".pv5-doc");
            T._abortDrag = false;
            T.$el.removeClass("grabbing");
        }
    },

    /**
     * zoom current page
     * @param  {String|Number} zoom  command ("in"|"out"|"fit") or value (0->1)
     * @param  {Bool} animated
     */
    zoom: function (zoom, animated) {
        var T = this,
            page_view = T.currentPageView();
        page_view.zoom(zoom, animated);
    },


    isZoomed: function () {
        var T = this;
        return T.currentPageView().isZoomed();
    },

    /**
     * Return current page view from pageviews array
     * @return {PageView}
     */
    currentPageView: function () {
        var T = this;
        var p = T.model.get("page");
        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }
        return _.findWhere(T.pageViews, {
            page: p
        });
    },

    /**
     * move to a page
     * @param  {String|Number} page  a page
     * @param  {Bool} animated
     * @param  {Object} fitted_rectangle rectangle to fit in view {"x":"200","y":"200","w":"300","h":"400"}
     *
     */
    gotoPage: function (page, animated, fitted_rectangle) {

        var T = this,
            page_dest = 0,
            current = T.model.get("page"),
            nbPages = T.model.get("nbPages");

        if (T._pendingPage) return;

        if (_.isString(page)) {
            if (page == "previous") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current - 3 : current - 2;
                } else {
                    page_dest = current - 1;
                }
            } else if (page == "next") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current + 1 : current + 2;
                } else {
                    page_dest = current + 1;
                }
            } else {
                page_dest = parseInt(page, 10);
            }
        } else {
            page_dest = page;
        }

        // clamp
        if (page_dest > nbPages) {
            page_dest = nbPages;
        } else if (page_dest < 1) {
            page_dest = 1;
        }

        T.loadPage(page_dest, fitted_rectangle);

        // make destination the official current page at the end of animation
        T._pendingPage = page_dest;

        // now scroll
        T.scrollTo(T.pagePosition(page_dest), animated);
    },

    /**
     * load or preload a page and construct the view
     */
    loadPage: function (p, startFit) {
        var T = this;

        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }

        var page_view = _.findWhere(T.pageViews, {
            page: p
        });

        if (!page_view) {
            // create page view and append it to document container
            page_view = new PageView({
                page: p,
                startFit: startFit,
                documentModel: T.model,
                template: T.pageTemplate,
                authorizationTemplate: T.pageAuthorizationTemplate,
                authorizationMessage: T.pageAuthorizationMessage,
                zoomMax: T.zoomMax,
                zoomFav: T.zoomFav,
                isPortrait: T.isPortrait,
                tileHd: T.tileHd,
                authorizedPage: T.isPageAuthorized(p)
            });

            T.listenTo(page_view, "change:position", T.onPagePositionChanged);
            T.listenTo(page_view, "change:zoom-fav", T.onPageZoomFavChanged);
            T.listenTo(page_view, "render", T.onPageRendered);
            T.pageViews.push(page_view);

            page_view.$el.css({
                left: T.pagePosition(p),
                width: T.elWidth,
                height: T.elHeight
            });

            T.$documentContainer.append(page_view.el);
            T.trigger("add:page-view", page_view);
            page_view.render();
        } else {
            page_view.zoomFav = T.zoomFav;
            T.onPagePositionChanged(page_view); //generate a position changed
        }
    },

    unloadPage: function (p) {
        var T = this;
        var page_view = _.findWhere(T.pageViews, {
            page: p
        });
        if (page_view) {
            T.stopListening(page_view);
            page_view.remove();
            page_view.close();
            T.pageViews = _.without(T.pageViews, page_view);
            debug("unload page " + p);
            T.trigger("remove:page-view", page_view);
        }
    },

    /**
     * construct next page view. A appeler dans les temps mort, en dehors d'une animation
     * @param  {Number} p the current page
     */
    preloadNextPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p + 2;
        } else {
            page_preload = p + 1;
        }
        if (page_preload <= T.model.get("nbPages")) {
            T.loadPage(page_preload);
        }
    },

    preloadPreviousPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p - 2;
        } else {
            page_preload = p - 1;
        }
        if (page_preload > 0) {
            T.loadPage(page_preload);
        }
    },

    removeUnusedPages: function () {
        var T = this,
            page = T.model.get("page"),
            page_max, page_min;


        //compute page min / max
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_max = page + 2;
            page_min = page - 2;
        } else {
            page_max = page + 1;
            page_min = page - 1;
        }

        T.pageViews.forEach(function (view) {
            if (view.page < page_min || view.page > page_max) {
                T.unloadPage(view.page);
            }
        });
    },

    /**
     * Called when page was changed in document model
     */
    onPageChanged: function () {
        var T = this;
        if (!T.enable) return;
        if (!T._pendingPage) {
            T.gotoPage(T.model.get("page"), false);
        }
    },

    /**
     * Update page view positions and size
     */
    refresh: function () {
        var T = this;
        T.pageViews.forEach(function (view) {
            view.$el.css({
                left: T.pagePosition(view.page),
                width: T.elWidth,
                height: T.elHeight,
                isPortrait: T.isPortrait
            });
            view.resize();
        });
    },

    /**
     * retrieve page position from page number and view configuration
     * @return {Number} page left position
     */
    pagePosition: function (page) {
        var T = this,
            pos = 0;

        if (T.model.get("isDouble")) {
            if (T.isPortrait) {
                pos = (page - 1) * T.elWidth;
            } else {
                var page_left = (page % 2) ? page - 1 : page; // left page
                pos = T.elWidth * (page_left / 2);
            }
        } else {
            pos = (page - 1) * T.elWidth;
        }

        return pos;
    },

    /**
     * scroll document container horizontally
     * @param  {[type]} position_x [description]
     * @param  {[type]} animated   [description]
     */
    scrollTo: function (position_x, animated) {
        var T = this,
            previous_left = T.$documentContainer.css("left"),
            the_css = {
                left: -position_x
            };

        the_css[T.transitionStyle] = animated ? "left 0.5s ease-out" : "none";
        //console.log("scroll to:"+position_x);
        T.$documentContainer.css(the_css);

        if (parseInt(previous_left) == parseInt(the_css.left) || !animated) {
            // generate a transition a fake event
            T.onTransitionEnd({
                target: T.$documentContainer[0],
                originalEvent: {
                    propertyName: "left"
                }
            });
        }

    },

    close: function () {
        var T = this;

        T.$documentContainer.remove();

        T.pageViews.forEach(function (view) {
            T.unloadPage(view.page);
        });

        $(window).off(".pv5-doc");

        T.stopListening();
        T.undelegateEvents();
    }

});

},{"../../common/utils/dom-util":39,"./page-view":51,"backbone":55,"debug":56,"jquery":58,"underscore":46}],50:[function(require,module,exports){
"use strict";
var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:PageSliderView"); //https://github.com/visionmedia/debug

/**
 * RetronewsPageSliderView: Display a page thumbnail slider like ibooks
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    knobMinWidth: 40,
    knobMaxWidth: 100,
    templateKnob: null,
    templateThumb: null,
    fixedWidth: 0,
    authorizedPages: null,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)

    events: {
        "pointerdown .knob": "onDragStart",
        "click": "onClick"
    },

    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        if (T.fixedWidth) {
            T.knobMinWidth = T.fixedWidth;
            T.knobMaxWidth = T.fixedWidth;
        }

        T._knobWidth = 0;
        T._step = 0;
        T._pointers = {};
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;


        if (T.templateKnob) {
            T.templateKnob = _.template(T.templateKnob); // compile template
        }

        if (T.templateThumb) {
            T.templateThumb = _.template(T.templateThumb); // compile template
        }

        T.listenTo(T.model, "sync", T.render);
        T.listenTo(T.model, "change:page", T.update);
    },

    render: function () {
        var T = this;

        if (T.model.fetched) {
            var context = T.model.toJSON();
            if (T.templateKnob) {
                T.$el.html("");
                T.$knob = $(T.templateKnob(context));
                T.$el.append(T.$knob);

                T.$thumb = $(T.templateThumb(context));
                T.$el.append(T.$thumb);
                T.$thumb.hide();

                if (!T.embed) {
                    T.$el.css("touch-action", "none");
                }
            }
            T.resize();
        }
        return T;
    },

    /**
     * adjust slider size from nb pages and container width
     */
    resize: function () {
        var T = this;

        if (!T.model.fetched) return;

        T._elWidth = T.$el.width();
        T._elHeight = T.$el.height();

        T._knobWidth = T._elWidth / (T.model.get("nbPages") - 1);

        if (T._knobWidth < T.knobMinWidth) {
            T._knobWidth = T.knobMinWidth;
        } else if (T._knobWidth > T.knobMaxWidth) {
            T._knobWidth = T.knobMaxWidth;
        }

        T._step = (T._elWidth - T._knobWidth) / (T.model.get("nbPages") - 1);


        T.$knob.css({
            width: T._knobWidth
        });

        T.update();

    },

    update: function () {
        var T = this;
        if (!T.model.fetched) return;
        var page = T.model.get("page") || 1;
        var knob_left = T._step * (page - 1);

        // console.log("page "+ page+" el width: "+T._elWidth +" left:"+ knob_left +" knob:"+ T._knobWidth );

        // move slider to current page
        T.$knob.css({
            left: knob_left
        });
    },

    onDragStart: function (e) {
        var T = this;

        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = e.pageX;
            T._dragStartPoint.y = e.pageY;
            $(window).on("pointermove.pv5-slider", function (e) {
                T.onDragMove(e);
            });
            $(window).on("pointerup.pv5-slider", function (e) {
                T.onDragEnd(e);
            });
            $(window).on("pointercancel.pv5-slider", function (e) {
                T.onDragEnd(e);
            });
            T._dragStartLeft = T.knobPosition();
            //T._gotoPage=T.pageFromKnobPosition(T.knobPosition());
            var page = T.pageFromKnobPosition(T.knobPosition());
            T.updateThumb(page);
            T.$thumb.show();
        } else {
            T._abortDrag = true;
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);*/
    },

    onDragMove: function (e) {
        var T = this;

        if (T._abortDrag) return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            var knob_left = T._dragStartLeft - (T._dragStartPoint.x - e.pageX);
            T.knobPosition(knob_left);
            T.$el.addClass("grabbing");
            var page = T.pageFromKnobPosition(T.knobPosition());
            if (T._previousPageThumb != page) {
                T.updateThumb(page);
                T._previousPageThumb = page;
            }
        }

    },

    onDragEnd: function (e) {
        var T = this;

        delete T._pointers[e.originalEvent.pointerId];

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if (!keys.length) {
            $(window).off(".pv5-slider");
            T._abortDrag = false;
            var page = T.pageFromKnobPosition(T.knobPosition());
            debug("gotopage " + page);
            T.trigger("drag:end");
            T.model.set({
                "page": page
            });
            T.$el.removeClass("grabbing");
            T.$thumb.hide();
        }
    },

    onClick: function (e) {
        var T = this;
        if (e.target == T.el) {
            var x = e.pageX - T.$el.offset().left - (T._knobWidth / 2);
            if (x < 0) {
                x = 0;
            }
            var page = T.pageFromKnobPosition(x);
            debug("click slider position : " + x + " page : " + page);
            T.trigger("click");
            T.model.set({
                "page": page
            });
        }
    },

    updateThumb: function (page) {
        var T = this, str_page;

        if (T.model.get("reversed")) {
            str_page = String(T.model.get("nbPages") - page + 1);
        }
        else {
            str_page = String(page);
        }
        T.$(".page").html(str_page);
        if (T.model.get("isDouble")) {
            if (page > 1) {
                page = (page % 2) ? page - 1 : page;
            }
            T.$(".cover").toggleClass("double-page", !(page == 1 || page == T.model.get("nbPages")));
        }

        if (T.bgTimer) {
            clearTimeout(T.bgTimer);
            T.bgTimer = 0;
        }
        if (page != T.bgPage) {
            T.$(".cover").css({
                backgroundImage: "none"
            });
        }

        T.bgPage = page;

        //  on attend un peu avant d'affecter l'image ça évite de charger toutes les images lors d'un long drag
        T.bgTimer = setTimeout(function () {
            T.$thumb.toggleClass("page-not-authorized", !T.isPageAuthorized(page));
            T.$(".cover").css({
                backgroundImage: "url(" + T.model.thumbnailUrl(page) + ")"
            });
        }, 100);

    },

    pageFromKnobPosition: function (p) {
        var T = this,
            page;
        page = Math.round(p / T._step);
        return page + 1;
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },


    knobPosition: function (p) {
        var T = this;
        if (p) {
            //console.log(p);
            // clamp poision
            if (p < 0) {
                p = 0;
            } else if (p > T._elWidth - T._knobWidth) {
                p = T._elWidth - T._knobWidth;
            }

            var knob_left = p;

            T.$knob.css({
                left: knob_left
            });
        } else {
            return parseInt(T.$knob.css("left"));
        }

    },

    close: function () {
        var T = this;
        T.$knob = null;
        T.stopListening();
        T.undelegateEvents();
    }

});
},{"backbone":55,"debug":56,"jquery":58,"underscore":46}],51:[function(require,module,exports){
"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;

var DomUtil = require("../../common/utils/dom-util");

var debug = require("debug")("views:PageView"); //https://github.com/visionmedia/debug


/**
 * PageView: a domument page view
 * Triggers:
 * - "render"
 */
module.exports = Backbone.View.extend({

	documentModel: null, // DocumentModel
	model: null, // PageModel
	template: null, // external template for place holder
	className: "page-view",
	zoomMax: 1, // maximum zoom value : 1 = full image resolution
	page: 0,
	startFit: null, // rectangle qui doit apparaitre initialement, en coordonnées image
	isPortrait: false,
	usePDF: false,
	zoomFav: 1,
	reversed: false,
	tileHd: false, // utilise le niveau de tuile supérieur
	authorizedPage: true,
	authorizationTemplate: null,
	authorizationMessage: null,

	// private
	_x: 0, // x image position
	_y: 0, // y image position
	_zoom: -1, // current zoom
	_zoomFit: 1, // zoom value fiting entire image into viewport, computed when size change
	_animating: false, // animation in progress
	_dragEvents: null, //
	_dragStartPoint: null,
	_dragStartPagePoint: null,
	_lastTap: 0,

	events: {
		"DOMMouseScroll": "onMouseWheel",
		"mousewheel": "onMouseWheel",
		"wheel": "onMouseWheel",
		"pointerdown": "onDragStart",
		"webkitTransitionEnd": "onTransitionEnd",
		"transitionend": "onTransitionEnd"
	},

	/**
	 * @param  {Object}         options
	 * @param  {DocumentModel}  options.documentModel we use this model to gain some production properties and to get a reference to the pageModel
	 * @param  {Number}         options.page left page number
	 * @param  {String}         options.template page placeholder underscore template (optional)
	 */
	initialize: function (options) {
		var T = this;
		_.extend(T, options);

		T._dragStartPoint = {
			x: 0,
			y: 0
		};
		T._dragStartPagePoint = {
			x: 0,
			y: 0
		};
		T._dragEvents = [];
		T._pointers = {};
		T._computeCache = {}; // cache some computing values
		T._tiles = {}; // contains all tiles
		T._visible = []; // ids of visible tiles

		T._lockX = false;

		T.model = T.documentModel.getPageModel(T.page);
		if (T.documentModel.get("pdfDocument")) {
			T.usePDF = true;
		}

		T.listenTo(T.model, "sync", T.render);

		if (T.template) {
			T.template = _.template(T.template); // compile template
		}

		if (T.authorizationTemplate) {
			T.authorizationTemplate = _.template(T.authorizationTemplate); // compile template
		}

		T.transitionStyle = DomUtil.styleSupport("transition");

		// load this low res image before any tile
		if (!T.usePDF && T.authorizedPage) {
			$("<img/>").attr("src", T.model.thumbnailUrl());
		}

	},

	render: function () {
		var T = this,
			context = T.model.toJSON();

		debug("render " + T.model.get("id") + ", fetched: " + T.model.fetched);

		if (T.template) {
			if (T.documentModel.get("reversed")) {
				context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
			}
			T.$el.html(T.template(context));
		}

		if (T.model.fetched) {
			T.$tileContainer = $("<div/>", {
				class: "tile-container",
			}).appendTo(T.el);

			if (!T.usePDF && T.authorizedPage) {
				T.$tileContainer.css({
					backgroundImage: "url(" + T.model.thumbnailUrl() + ")"
				});
			}

			if (!T.authorizedPage) {
				T.renderPageAuthorization();
			}

			var fit_values = T._computeFit();
			T._zoomFit = fit_values.z;

			if (T.startFit) {
				T.fitRectangle(T.startFit);
			} else {
				T.fit(false);
			}

		}

		T.trigger("render", T);
	},

	/**
	 * fit tileContainer into main element
	 * @param  {Bool} animated
	 */
	fit: function (animated) {
		var T = this,
			fit_values = T._computeFit();

		if (!fit_values) return;

		T.setPosition(fit_values.x, fit_values.y, fit_values.z, true, animated);
	},

	_computeFit: function () {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height(),
			imW = T.model.get("width"),
			imH = T.model.get("height");

		if (T.isPortrait && T.model.get("isDouble")) {
			imW /= 2;
		}

		z = elW / imW;
		if (z * imH > elH) {
			z = elH / imH;
			x = ((elW / z) - imW) / 2;
		} else {
			y = ((elH / z) - imH) / 2;
		}
		return {
			x: x,
			y: y,
			z: z
		};
	},

	/**
	 * zoome la page pour que la view affiche le rectangle passé en paramètre
	 * @param  {Object} rect rectangle en coordonnées image {"x":"200","y":"200","width":"300","height":"400"}
	 * @param  {Bool} animated
	 */
	fitRectangle: function (rect, animated) {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height();

		z = elW / rect.width;
		if (z * rect.height > elH) {
			z = elH / rect.height;
			x = -(rect.x + (rect.width / 2) - ((elW / z) / 2));
			y = -rect.y;
		} else {
			x = -rect.x;
			y = -(rect.y + (rect.height / 2) - ((elH / z) / 2)); //((elH / z) - imH) / 2;
		}

		T.setPosition(x, y, z, true, animated);
	},

	/**
	 * set tileContainer position
	 * @param {Int} x        x position in image coordinates
	 * @param {Int} y        y position in image coordinates
	 * @param {Float} zoom
	 * @param {Bool} animated
	 */
	setPosition: function (x, y, zoom, clamp, animated) { // jshint ignore:line
		var T = this;
		if (!T.model.fetched) return;
		if (!T.$tileContainer) return;

		if (clamp) {
			var pt = T._clampPosition(x, y, zoom);
			x = pt.x;
			y = pt.y;
		}

		if (T._x == x && T._y == y && T._zoom == zoom) {
			return;
		}

		// on arrondit à l'entier car le css des browsers fonctionnent en entier
		// donc si il y a juste une variation de la partie après la virgule, ça ne déclenchera pas d'animation
		var new_vpx = Math.round(x * zoom),
			new_vpy = Math.round(y * zoom),
			old_vpx = Math.round(T.$tileContainer[0].offsetLeft),
			old_vpy = Math.round(T.$tileContainer[0].offsetTop);

		if (new_vpx == old_vpx && new_vpy == old_vpy) {
			animated = false;
		}

		T._x = x;
		T._y = y;
		T._zoom = zoom;

		T.trigger("change:position", T);

		var style = {};

		style[T.transitionStyle] = animated ? "left 0.5s, width 0.5s, height 0.5s, top 0.5s" : "none";

		T.$tileContainer.css(style);

		style = {
			width: T.model.get("width") * zoom,
			height: T.model.get("height") * zoom,
			left: new_vpx,
			top: new_vpy
		};
		T.$tileContainer.css(style);

		if (animated) {
			//debug("animating true");
			T._animating = true;
			T.hideTiles();
		} else {
			if (T._animating) {
				T.onAnimationEnd();
			}
			else {
				T.refresh();
			}
		}
	},

	resize: function () {
		var T = this,
			fit_values,
			was_zoomed = T.isZoomed();

		fit_values = T._computeFit();
		if (!fit_values) return;

		T._zoomFit = fit_values.z;

		if (was_zoomed) {
			// on était zoomé dans le doc, on se repositionne vers les mêmes positions
			var z = T._clampZoom(T._zoom);
			T.setPosition(T._x, T._y, z, true, false);
			T.refresh(); // force refresh
		} else {
			// on était en mode fit
			T.fit(false);
		}
	},

	getPosition: function () {
		var T = this;
		return {
			x: T._x,
			y: T._y,
			zoom: T._zoom
		};
	},

	refreshPDF: function () {
		// version qui calcule un canvas à chaque zoom
		var T = this;

		if (T._animating) {
			//debug("refresh PDF " + T.page + " aborted due to animation");
			return;
		}

		// on ne rien faire si le zoom n'a pas changé depuis le dernier refresh
		if (T._zoom == T._lastZoom) {
			//debug("refresh PDF " + T.page + " aborted due to zoom not changed since last time");
			return;
		}

		T._lastZoom = T._zoom;

		var nb_pages;
		if (T.isPortrait) {
			nb_pages = 1;
		}
		else {
			nb_pages = T.model.get("isDouble") ? 2 : 1;
		}

		for (var i = 0; i < nb_pages; i++) {
			T.renderPDFPage(i);
		}
	},

	renderPDFPage: function (i) {
		var T = this, nb_pages, canvas_width, canvas_height, canvas_width_percent;
		var resolution = T._zoom;

		debug("render page " + (T.page + i) + " " + resolution);

		T.documentModel.get("pdfDocument").getPage(T.page + i).then(function (page) {

			var tile_id = "T-PDF-" + (T.page + i) + "-" + String(resolution);
			var left;

			if (T.isPortrait) {
				nb_pages = 1;
				if (T.model.get("isDouble")) {
					canvas_width = Math.ceil(T.$tileContainer.width() / 2);
					if (T.isLeftPage()) {
						left = 0;
					}
					else {
						left = "50%";
					}
					canvas_width_percent = 50;
				}
				else {
					left = 0;
					canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
					canvas_width_percent = 100;
				}
			}
			else {
				nb_pages = T.model.get("isDouble") ? 2 : 1;
				left = (100 / nb_pages) * i + "%";
				canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
				canvas_width_percent = 100 / nb_pages;
			}

			canvas_height = Math.ceil(T.$tileContainer.height());



			//debug("create canvas");
			var $tile = $('<canvas/>', {
				class: "tile-pdf-" + i,
				id: tile_id,
				css: {
					position: "absolute",
					top: 0,
					left: left,
					backgroundColor: "transparent",
				}
			});

			if (window.devicePixelRatio > 1) {
				// on met plus de pixels pour les écrans type retina
				canvas_width *= 1.4;
				canvas_height *= 1.4;
				$tile.css({
					width: canvas_width_percent + "%",
					height: "100%"
				});
			}
			else {
				$tile.css({
					width: canvas_width,
					height: canvas_height
				});
			}

			var canvas = $tile[0];

			var viewport_original = page.getViewport({ scale: 1 });

			var scale = canvas_width / viewport_original.width;
			var viewport = page.getViewport({ scale: scale });

			var context = canvas.getContext('2d');
			canvas.height = canvas_height;
			canvas.width = canvas_width;

			var renderContext = {
				canvasContext: context,
				viewport: viewport,
				enableWebGL: true
			};

			page.render(renderContext).promise.then(function () {

				if (T._animating) {
					// le rendu se finit pendant qu'une animation est en cours, on ne fait rien avec la tuile, un refresh sera appelé à la fin de l'animation
					//debug("animation in progress");
					T._lastZoom = 0;
				}
				else {
					if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple
					T.$('.tile-pdf-' + i).remove();

					if (window.devicePixelRatio == 1) {
						// plus d'animation en cours, on met une taille en pixel pour que le texte soit bien net, pour ne pas avoir des dixièmes de pixels
						$tile.css({
							width: canvas_width,
							height: canvas_height,
						});
					}
					T.$tileContainer.append($tile);
				}

			});
		});
	},

	renderPageAuthorization: function () {
		var T = this;
		if (!T.authorizationTemplate) return;
		if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple

		var context = T.model.toJSON();

		if (T.documentModel.get("reversed")) {
			context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
		}

		context.thumbnailUrl = T.model.thumbnailUrl();

		var message;
		
		if (_.isFunction(T.authorizationMessage)) {
			var content_model = T.documentModel.toJSON();
			content_model.documentId=content_model.id;
			content_model.documentTitle=content_model.title;
			delete(content_model.id);
			delete(content_model.title);
			content_model.contentType = "page";
			content_model.pages = T.model.get("number");
			message = T.authorizationMessage(content_model);
		}
		else {
			message = T.authorizationMessage;
		}

		context.authorizationMessage = message;
		

		T.$tileContainer.empty();
		T.$tileContainer.addClass("page-auth-container");

		var html_code = T.authorizationTemplate(context);
		if (T.isPortrait && T.model.get("isDouble")) {
			T.$tileContainer.append($(html_code).addClass("mid"));
			T.$tileContainer.append($(html_code).addClass("mid"));
		}
		else {
			T.$tileContainer.append(html_code);
		}
	},

	/**
	 * tiles management (create/remove/position) depending of zoom and position into viewport
	 */
	refresh: function () {
		var T = this;

		if (T._pinching) return;

		if (!T.authorizedPage) {
			return;
		}

		if (T.usePDF) {
			T.refreshPDF();
			return;
		}

		var imTileSize = T.model.get("tileSize");

		// recherche du niveau de tuiles à charger en fonction du zoom
		// on cache les dernières valeurs obtenue si le zoom ne change pas pour éviter des calculs
		var ll, zdiv, its, t1, t2, nbtht, nbtvt;
		if (T._computeCache.zoom == T._zoom) {
			ll = T._computeCache.ll;
			zdiv = T._computeCache.zdiv;
			its = T._computeCache.its;
			t1 = T._computeCache.t1;
			t2 = T._computeCache.t2;
			nbtht = T._computeCache.nbtht;
			nbtvt = T._computeCache.nbtvt;
		} else {
			ll = T._determineLevel(T._zoom);
			zdiv = T._zoom / ll.z;
			its = imTileSize / ll.z; //taille d une tuile de ce level dans le repère de l image
			t1 = T.model.get("width") * ll.z; //largeur de l'image de ce level
			t2 = T.model.get("height") * ll.z; //hauteur de l'image de ce level
			nbtht = Math.ceil(t1 / imTileSize); // nombre total de tuiles horizontales
			nbtvt = Math.ceil(t2 / imTileSize); // nombre total de tuiles verticales

			T._computeCache = {
				ll: ll,
				zdiv: zdiv,
				its: its,
				t1: t1,
				t2: t2,
				nbtht: nbtht,
				nbtvt: nbtvt,
				zoom: T._zoom
			};
		}

		//viewport dans le repère de l image
		var ivpw = T.$el.width() / T._zoom;
		var ivph = T.$el.height() / T._zoom;

		var firstTileH = Math.floor(-T._x / its); // first tile
		var firstTileV = Math.floor(-T._y / its);
		if (firstTileH < 0) firstTileH = 0;
		if (firstTileV < 0) firstTileV = 0;

		var lastTileH = Math.floor((-T._x + ivpw) / its); // last tile
		var lastTileV = Math.floor((-T._y + ivph) / its);
		if (lastTileH > nbtht - 1) lastTileH = nbtht - 1;
		if (lastTileV > nbtvt - 1) lastTileV = nbtvt - 1;

		//IM.log("Page:"+T.numbering+" firstTileH:"+firstTileH+" firstTileV:"+firstTileV+" X:"+T._iX+" lastTileH:"+lastTileH+" lastTileV:"+lastTileV);

		// we hide all the tiles that are no longer useful
		for (var k = 0; k < T._visible.length; k++) {
			var $tile_visible = T._tiles[T._visible[k]],
				data = $tile_visible.pv5data;
			if (data.level == ll.l) {
				if (!(data.h >= firstTileH && data.h <= lastTileH && data.v >= firstTileV && data.v <= lastTileV)) {
					$tile_visible.hide();
				}
			} else {
				$tile_visible.hide();
			}
		}

		T._visible = [];

		// positionnement/chargement tuiles si nécéssaire
		var hDst, wDst, yDst, xDst;
		xDst = yDst = wDst = hDst = 0;
		yDst = Math.round(((firstTileV * its)) * T._zoom);

		for (var j = firstTileV; j <= lastTileV; j++) {
			xDst = Math.round(((firstTileH * its)) * T._zoom);
			if (j == nbtvt - 1)
				hDst = Math.round((t2 - (imTileSize * (nbtvt - 1))) * zdiv);
			else
				hDst = Math.round(imTileSize * zdiv);

			for (var i = firstTileH; i <= lastTileH; i++) {
				if (i == nbtht - 1)
					wDst = Math.round((t1 - (imTileSize * (nbtht - 1))) * zdiv); //dernière tuile horizontale
				else
					wDst = Math.round(imTileSize * zdiv);

				//console.log("Page:"+T.page+" Level:"+ll.l+" line:"+j+" col:"+i);
				var tile_id = "T-" + ll.l + "-" + i + "-" + j;
				var $tile = T._tiles[tile_id];

				if (!$tile) {
					// not found, create a new tile
					$tile = $("<img/>", {
						class: "tile",
						id: tile_id,
						src: T.model.tileUrl(i, j, ll.l),
						draggable: false
					});
					$tile.pv5data = {
						level: ll.l,
						h: i,
						v: j
					};
					T._tiles[tile_id] = $tile;
					T.$tileContainer.append($tile);
					//console.log("new tile "+i+" "+j+" "+ll.l);
				}

				if ($tile) {
					T._visible.push(tile_id);
					$tile.css({
						width: wDst,
						height: hDst,
						top: yDst,
						left: xDst,
						display: ""
					});
				}

				xDst += wDst;
			}
			yDst += hDst;
		}

	},

	/**
	 * zoom current page
	 * @param  {String|float} zoom  command ("in"|"out") or value (0->1)
	 * @param  {Bool} animated
	 */
	zoom: function (zoom, animated) {
		var T = this,
			z = 1,
			pt = {
				x: T.$el.width() / 2,
				y: T.$el.height() / 2
			};

		T._vpToImage(pt);

		if (_.isString(zoom)) {
			if (zoom == "in") {
				z = T._zoom * 2;
			} else if (zoom == "out") {
				z = T._zoom / 2;
			} else if (zoom == "fit") {
				T.fit(animated);
				return;
			} else {
				// unsupported command
				return;
			}
		} else {
			z = zoom;
		}

		z = T._clampZoom(z);

		T.zoomCentered(pt.x, pt.y, z, T.$el.width() / 2, T.$el.height() / 2, true, animated);

	},

	/**
	 * zoome la page, centré sur le le point passé
	 * @param {int} x position x dans le repère de l'image
	 * @param {int} y position y dans le repère de l'image
	 * @param {float} s nouveau facteur de zoom
	 * @param {int} vpx position x dans le repère du viewport
	 * @param {int} vpy position y dans le repère du viewport
	 * @param {bool} clamp autorise ou non à dépasser les limite du viewport
	 * @param {bool} animated zoome animé ou zoom direct
	 */
	zoomCentered: function (x, y, s, vpx, vpy, clamp, animated) { // jshint ignore:line
		var T = this,
			newX = 0,
			newY = -y + (vpy / s);

		if (!T.authorizedPage) return;

		//console.log("old: "+T._zoom+" new: "+s);
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					newX = -x + (vpx / s);
				} else {
					newX = -x + (vpx / s) - T.model.get("width") / 2;
				}
			} else {
				newX = -x + (vpx / s);
			}
		} else {
			newX = -x + (vpx / s);
		}
		//IM.log("X:"+x+" Y:"+y+" S:"+s);
		T.setPosition(newX, newY, s, clamp, animated);
	},

	/**
	 * donne la correspondance entre un point dans le viewport et un point dans l'image originale
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @ignore
	 */
	_vpToImage: function (pt) {
		var T = this,
			x,
			y;

		if (T.model.get("isDouble")) {
			if (T.isPortrait) {
				if (T.isLeftPage()) {
					x = (pt.x / T._zoom) - T._x;
					y = (pt.y / T._zoom) - T._y;
				} else {
					x = (pt.x / T._zoom) - T._x - T.model.get("width") / 2; // todo, à vérifier
					y = (pt.y / T._zoom) - T._y;
				}
			} else {
				x = (pt.x / T._zoom) - T._x;
				y = (pt.y / T._zoom) - T._y;
			}
		} else {
			x = (pt.x / T._zoom) - T._x;
			y = (pt.y / T._zoom) - T._y;
		}

		pt.x = x;
		pt.y = y;
	},

	/**
	 * limite une position x,y en fonction d'un facteur de zoom
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @param {float} z zoom demandé
	 * @ignore
	 */
	_clampPosition: function (x, y, z) { // jshint ignore:line

		var T = this,
			newX = x,
			newY = y,
			elW = T.$el.width(),
			elH = T.$el.height(),
			maxX = 0,
			minX = 0,
			imWidth = T.model.get("width"),
			imHeight = T.model.get("height");

		//todo : mettre le calcule de min et max une seule fois sur resize
		// clamp X
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					maxX -= ((imWidth / 2) - (elW / z)); // ok
					if (newX > minX) newX = minX;
					if (newX < maxX) newX = maxX;
				} else {
					minX = -(imWidth / 2); //ok
					maxX = -imWidth + (elW / z);
					if (newX < maxX) newX = maxX;
					if (newX > minX) newX = minX;
				}
			} else {
				maxX -= (imWidth - (elW / z)); // page simple centrée; ok
				if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
				if (newX > minX) newX = minX;
				if (newX < maxX) newX = maxX;
			}
		} else {
			maxX -= (imWidth - (elW / z));
			if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
			if (newX > minX) newX = minX;
			if (newX < maxX) newX = maxX;
		}

		//console.log("x: "+x+" MIN X:"+minX+" MAX X:"+maxX+" vp W :"+elW);

		// clamp Y
		var maxY = -(imHeight - (elH / z));
		if (maxY > 0) maxY /= 2; // cas où on a dézoomé assez et donc on centre verticalement
		if (newY > 0) newY = 0;
		if (newY < maxY) newY = maxY;

		//IM.log("MAX Y:"+maxY);
		return ({
			x: newX,
			y: newY
		});
	},

	_clampZoom: function (z) {
		var T = this;
		if (z > T.zoomMax) {
			z = T.zoomMax;
		} else if (z < T._zoomFit) {
			z = T._zoomFit;
		}
		return z;
	},

	/**
	 * determine image level needed for this image zoom value
	 * @param  {float} zoom
	 * @return {int}   image level
	 */
	_determineLevel: function (zoom) {
		var T = this,
			v = 1,
			l = 0,
			imLevels = T.model.get("nbLevels"),
			imDivider = T.model.get("divider");

		if (zoom > 0 && zoom < 1) {
			for (var k = 0; k < imLevels; k++) {
				v /= imDivider;
				if (v < zoom) {
					v *= imDivider;
					break;
				}
				l++;
			}
		}

		// en 2019 : force le niveau supérieur
		if (T.tileHd) {
			l--; v *= imDivider;
		}

		if (l >= imLevels) {
			l = imLevels - 1;
		} else if (l < 0) {
			l = 0;
			v = 1;
		}
		//debug("levels",l,v);
		return {
			l: l,
			z: v
		};
	},

	isZoomed: function () {
		var T = this;
		return (T._zoom >= T._zoomFit * 1.1) ? true : false;
	},

	onMouseWheel: function (ev) {
		var T = this,
			wheelDeltaY,
			new_zoom,
			e = ev.originalEvent;

		if (e.wheelDeltaX) {
			wheelDeltaY = e.wheelDeltaY / 12;
		} else if (e.wheelDelta) {
			wheelDeltaY = e.wheelDelta / 12;
		} else if (e.detail) {
			wheelDeltaY = -e.detail * 3;
		} else {
			return; //unknown case
		}

		new_zoom = T._zoom * Math.pow(2, 1 / 3 * (wheelDeltaY ? wheelDeltaY / Math.abs(wheelDeltaY) : 0));
		new_zoom = T._clampZoom(new_zoom);

		if (new_zoom != T._zoom) {
			var offset = T.$el.offset(),
				mouseX = e.pageX - offset.left,
				mouseY = e.pageY - offset.top,
				pt = {
					x: mouseX,
					y: mouseY
				};

			T._vpToImage(pt);
			//console.log(pt.x+" "+pt.y);
			T.zoomCentered(pt.x, pt.y, new_zoom, mouseX, mouseY, true, true);
			T.saveZoomFav(T._zoom);
		}

		// lignes ci-dessous necessaires pour le fonctionnement en iframe pour que l'action de zoom par scroll ne se transforme pas en scroll de la page web qui contient l'iframe
		e.stopPropagation();
		e.preventDefault();
	},

	onTransitionEnd: function (e) {
		var T = this;
		//debug("transition end",e.originalEvent.propertyName);
		if (e.target == T.$tileContainer[0] && e.originalEvent.propertyName == "width") {
			T.onAnimationEnd();
			e.stopPropagation();
		}
	},

	onAnimationEnd: function () {
		var T = this;
		T._animating = false;
		//debug("animating false"); 
		T.refresh();
	},

	onDragStart: function (e) {
		var T = this,
			offset,
			pt;

		if (!T.$tileContainer) return;

		T._pointers[e.originalEvent.pointerId] = {
			pageX: e.pageX,
			pageY: e.pageY
		};

		var keys = _.keys(T._pointers);

		if (keys.length == 1) {
			var now = Date.now(),
				isTapTap = false;

			if (now - T._lastTap < 400) {
				// double tap
				isTapTap = true;
			}

			if (isTapTap) {
				if (T.isZoomed()) {
					T.fit(true);
				} else {
					offset = T.$el.offset();
					pt = {
						x: e.pageX - offset.left,
						y: e.pageY - offset.top
					};
					T._vpToImage(pt);
					T.zoomCentered(pt.x, pt.y, T.zoomFav, T.$el.width() / 2, T.$el.height() / 2, true, true);
				}
				e.preventDefault();
			}

			T._lockTested = false;
			T._dragStartPagePoint.x = T._x;
			T._dragStartPagePoint.y = T._y;
			// en 2015 firefox donne le timlestamp en micro secondes au lieu de millisecondes ... bug ?
			// du coup on ne peut pas utiliser le timeStamp, on stocke la date
			e.pv5TimeStamp = now;
			T._dragEvents = [e]; // inertia management
			T._dragStartPoint.x = e.pageX;
			T._dragStartPoint.y = e.pageY;

			$(window).on("pointermove.pv5-page", function (e) {
				T.onDragMove(e);
			});
			$(window).on("pointerup.pv5-page", function (e) {
				T.onDragEnd(e);
			});
			$(window).on("pointercancel.pv5-page", function (e) {
				T.onDragEnd(e);
			});

			T._lastTap = now;
		} else if (keys.length == 2) {
			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];

			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			offset = T.$el.offset();
			pt = {
				x: midX - offset.left,
				y: midY - offset.top
			};
			T._vpToImage(pt);
			T._touchStartMidPt = pt;
			T._touchStartDist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			T._touchStartScale = T._zoom;
		}
	},

	onDragMove: function (e) {
		//console.log("Drag move");
		var T = this,
			x, y;

		T._pointers[e.originalEvent.pointerId] = {
			pageX: e.pageX,
			pageY: e.pageY
		};

		var keys = _.keys(T._pointers);
		if (keys.length == 1) {
			if (!T._pinching) {
				var now = Date.now();

				if (!T._lockTested && now - T._lastTap > 50) {
					// determine if we can lock a direction
					var deltaX = Math.abs(T._dragStartPoint.x - e.pageX);
					var deltaY = Math.abs(T._dragStartPoint.y - e.pageY);

					if (deltaY > deltaX * 1.5) {
						T._lockX = true;
					}

					T._lockTested = true;
				}

				if (T._lockX) {
					x = T._x;
				} else {
					x = T._dragStartPagePoint.x - ((T._dragStartPoint.x - e.pageX) / T._zoom);
				}

				y = T._dragStartPagePoint.y - ((T._dragStartPoint.y - e.pageY) / T._zoom);

				T.setPosition(x, y, T._zoom, true, false);


				// inertia management
				if (T._dragEvents.length) {
					e.pv5TimeStamp = now;
					if (e.pv5TimeStamp - T._dragEvents[T._dragEvents.length - 1].pv5TimeStamp > 40) {
						//console.log("add event "+e.originalEvent.timestamp);
						T._dragEvents.push(e);
						if (T._dragEvents.length > 2) {
							T._dragEvents.shift();
						}
					}
				}
			}
		} else if (keys.length == 2) {
			// pinch
			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];
			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			var dist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			var scale = dist / T._touchStartDist;
			var newS = scale * T._touchStartScale;
			newS = T._clampZoom(newS);

			if (!T._pinching) {
				T.hideTiles();
				T._pinching = true;
			}
			var offset = T.$el.offset();
			//var pt={x:midX-offset.left,y:midY-offset.top};
			//T._vpToImage(pt);

			//T.zoomCentered(pt.x,pt.y,newS,midX-offset.left,midY-offset.top,true,false);
			T.zoomCentered(T._touchStartMidPt.x, T._touchStartMidPt.y, newS, midX - offset.left, midY - offset.top, false, false);
		}
	},

	onDragEnd: function (e) {
		var T = this;

		//console.log("Drag end");

		delete T._pointers[e.originalEvent.pointerId];

		var keys = _.keys(T._pointers);

		if (!T._pinching && T._dragEvents.length > 1) {
			// inertia management
			// http://stackoverflow.com/questions/4443526/jquery-ui-drag-easing-inertia
			// http://james.padolsey.com/javascript/fun-with-jquerys-animate/

			var x1, x2,
				y1, y2,
				t1, t2; // Time

			var minDistance = 30; // Minimum px distance object must be dragged to enable momentum.
			var lastE = T._dragEvents.shift();

			x1 = lastE.pageX;
			y1 = lastE.pageY;
			t1 = lastE.pv5TimeStamp;
			x2 = e.pageX;
			y2 = e.pageY;
			t2 = Date.now();

			// Deltas
			var dX = x2 - x1,
				dY = y2 - y1,
				dMs = Math.max(t2 - t1, 1);

			// Speeds
			var speedX = Math.max(Math.min(dX / dMs, 1), -1),
				speedY = Math.max(Math.min(dY / dMs, 1), -1);

			// Distance moved (Euclidean distance)
			var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));

			var lockedX = T._lockX;

			T._lockX = false;

			if (distance > minDistance) {
				// Momentum
				//console.log("start momentum");
				var lastStepTime = new Date();
				$({
					count: 100
				}).animate({
					count: 0
				}, {
					duration: Math.max(Math.abs(speedX), Math.abs(speedY)) * 1500,
					step: function () {
						speedX *= (this.count / 100);
						speedY *= (this.count / 100);

						var now = Date.now();
						var stepDuration = now - lastStepTime;

						lastStepTime = now;

						//console.log("count: "+this.count+" speedY: "+speedY +" stepDuration:" +stepDuration);

						var new_x, new_y;
						if (lockedX) {
							new_x = T._x;
						} else {
							new_x = (T._x + ((speedX * stepDuration / 4) / T._zoom));
						}

						new_y = (T._y + ((speedY * stepDuration / 4) / T._zoom));

						T.setPosition(new_x, new_y, T._zoom, true, false);
					}
				});
			}
		}

		if (!keys.length) {
			$(window).off(".pv5-page");
			if (T._pinching) {
				T._pinching = false;
				T.saveZoomFav(T._zoom);
				T.setPosition(T._x, T._y, T._zoom, true, true);
				T.refresh();
			}
		}
	},

	/**
	 * save favorite zoom
	 * @param  {[type]} z [description]
	 * @return {[type]}   [description]
	 */
	saveZoomFav: function (z) {
		var T = this;
		if (z > T._zoomFit * 1.4) {
			T.zoomFav = z;
			T.trigger("change:zoom-fav", T);
		}
	},

	/**
	 * Hide all hd tiles, only background while be shown. Call refresh to reactivate tiles.
	 * This functionality is used while animating
	 */
	hideTiles: function () {
		var T = this;

		if (T.usePDF) {
			var nb_pages = T.model.get("isDouble") ? 2 : 1;
			if (window.devicePixelRatio <= 1) {
				// on passe en % pour faire l'animation
				T.$('canvas').css({
					width: (100 / nb_pages) + "%",
					height: "100%"
				});
			}
		}
		else {
			T.$(".tile").hide();
		}
	},

	/**
	 * Check if page displayed is a left page, useful only if we are in portrait orientation
	 * @return {Boolean}
	 */
	isLeftPage: function () {
		return this.page % 2 ? false : true;
	},

	close: function () {
		var T = this;
		T.$tileContainer = null;
		T._dragEvents = [];
		T._pointers = {};
		T._visible = [];
		T._tiles = {};
		T.stopListening();
		T.undelegateEvents();
	}

});
},{"../../common/utils/dom-util":39,"backbone":55,"debug":56,"jquery":58,"underscore":46}],52:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

var debug           = require("debug")("models:AggregationModel");    //https://github.com/visionmedia/debug

// AggregationModel
module.exports = Backbone.Model.extend({
  
    defaults: {
        name:null,
        queryModel:null,
        agg:null         // result aggregation from elastic, multiple form ...
    },

    initialize: function (attributes, options) {
        debug("initialize");
        _.extend(this, options);    

    }

});
},{"backbone":55,"debug":56,"underscore":46}],53:[function(require,module,exports){
"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");
var $               = require("jquery");
var UrlUtil         = require("../../common/utils/url-util");
var AggregationModel= require("./aggregation-model");


Backbone.$          = $;

// QueryModel : query pv5 search engine, this abstract class must be extended
module.exports = Backbone.Model.extend({

    pv5api: null,
    fetched: false,
    fetching:false,
    token:null,

    defaults: {
        query:null,         // query name : must be filled by derived class
        page:0,      // page de résultat actuelle
        pendingPage:0,      // page de résultat actuellement fetched
        pageSize:10,        // nombre de résultats récupérés en une fois
        total:0,            // nombre total de résultats, rempli après une première synchro
        results:null,       // results collection
        aggregations:null,  // aggregations result collection
        sort:null
    },

    initialize: function (attributes, options) {
        var T = this;
        _.extend(T, options);

        /*if (!T.pv5api) {
            throw new Error("You need to define a 'pv5api' property");
        }*/

        T.set(
            {
                results:new Backbone.Collection(),          // results collection
                aggregations:new Backbone.Collection()      // aggregations collection
            }
        );

    },

    // overide sync to call elasticsearch
    sync: function (method, model, options, defaults) {
        var T=this;

        // only read is allowed
        if (method !== "read") {
            throw new Error("method not allowed "+method);
        }

        var data=_.defaults(defaults, {
            size: model.get("pageSize")
        });

        var q={};
        if(_.isFunction(model.buildQuery)){
            q=model.buildQuery();
        }
        data=_.extend(data,q);// build query

        // JSON request options
        var params = {
            type: "POST",
            dataType:"json",
            jsonp: false,
            contentType:"application/json",
            crossDomain:true,
            data:JSON.stringify(data),
            url:model.pv5api+"/search/"+model.get("query")
        };

        // ajout token
        if(T.token){
            if(!params.headers){
                params.headers={};
            }
            params.headers["x-access-token"]=T.token;
        }

        params=_.extend(params, options);
        var xhr=Backbone.ajax(params);
        model.trigger("request", model, xhr, options);
        return xhr;
    },

    // override fetch method to update local collections
    // instead of recreating the model
    fetch: function(defaults, options) {
        //console.log("fetch");
        options = options ? _.clone(options) : {};
        defaults = defaults || {};

        var T = this;
        var success_cb = options.success;
        var error_cb = options.error;

        T.fetching=true;

        options.success = function(res, status, xhr) {
            T.set("page", T.get("pendingPage"));

            T.fetched=true;
            T.fetching=false;

            if(_.isFunction(T.parse)){
                res = T.parse(res, xhr);
            }

            var results = T.parseResults(res, xhr);
            var aggs = T.parseAggregations(res, xhr);

            if (options.add) {
                T.get("results").add(results);
            }
            else {
                T.get("results").reset(results);
                T.get("aggregations").reset(aggs);
            }  

            if (success_cb){
                success_cb(T, res);
            }
            T.trigger("sync", T, res, options);
        };
        options.error = function(xhr){
            T.fetching=false;
            if (error_cb){
                error_cb(T, xhr, options);
            }
            T.trigger("error", T, xhr, options);
        };

        return T.sync("read", T, options, defaults);
    },

    parse: function (response/*, xhr*/) {
        return response;
    },

    parseResults: function (response/*, xhr*/) {

        var res = [];
        var total=0;

        if(response.hits && response.hits.total){
            total=response.hits.total;
        }

        this.set("total", total);
        if (!total) {
            return res;
        }

        response.hits.hits.forEach(function(hit){
            var result=hit.fields;
            result.highlight=hit.highlight;
            result.score=hit.score;
            res.push(result);
        });
        return res;
    },

    parseAggregations:function(response/*, xhr*/){
        var aggs = [];
        if(response.aggregations){
            for(var index in response.aggregations) {
                var agg = response.aggregations[index];
                var aggm = new AggregationModel({name:index,queryModel:this});
                aggm.set("agg",agg);
                aggs.push(aggm);
            }
        }
        return aggs;
    },

    hasNextPage: function () {
        return this.get("page") < this.getTotalPages();
    },

    hasPage: function (page) {
        var ret=true;
        if(page <  1 || page > this.getTotalPages()){
            ret=false;
        }
        return ret;
    },

    getTotalPages: function () {
        return Math.ceil(this.get("total") / this.get("pageSize")) ;
    },

    /**
     * fetch page, reset result from previous query
     * @param  {Number} page    page to retrieve from server, first page is 1
     * @param  {bool} add  add or reset result array
     * @param  {Object} options
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchPage:function(page,add,options){
        if(this.fetching){
            return;
        }
        var final_options=options||{};
        final_options.add=add;
        this.set("pendingPage",page);
        return this.fetch({
            "from": (page-1)*this.get("pageSize")
        }, final_options);
    },

    /**
     * fetch next page, add result to previous result collection
     * @param  {Object} options
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchNextPage: function (options) {
        return this.fetchPage(this.get("page")+1,true,options);
    },


    /**
     * fetch first page result, reset result collection
     * @param  {[type]} options [description]
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchFirstPage:function(options){
        return this.fetchPage(1,false, options);
    },

    /**
     * fetchFirstPage alias
     * @param  {[type]} options [description]
     * @return {xhr||false} return false if a fetch is already in progress
     */
    search:function(options){
        return this.fetchFirstPage(options);
    },

    /**
     * analyse query string and fill model
     * @param {String} queryString [description]
     */
    setQueryString:function(queryString){
        var T=this;

        var objs=UrlUtil.parseQueryString(queryString,T.whiteList);
        _.each(objs,function(value, key){
            var v=T.get(key);
            if(_.isBoolean(v)){
                objs[key]=(value=="true")?true:false;
            }
            else if(_.isNumber(v)){
                objs[key]=parseInt(value,10);
            }
        });
        T.set(objs);
    },

    /**
     * generate query string from model
     * @return {String} allTerms=joseph&someTerms=vendu
     */
    getQueryString:function(){
        var T=this;
        return UrlUtil.generateQueryString(T.toJSON(),T.whiteList);
    },

});
},{"../../common/utils/url-util":41,"./aggregation-model":52,"backbone":55,"jquery":58,"underscore":46}],54:[function(require,module,exports){
"use strict";

var Backbone    = require("backbone");
var $           = require("jquery");
var _           = require("underscore");
Backbone.$      = $;

var debug       = require("debug")("views:SearchInputView");    //https://github.com/visionmedia/debug

// SearchInputView : bind a text input and a query model
module.exports = Backbone.View.extend({

    model:null,
    fieldName:null,

    events: {
        "keypress": "onKeyPress",
        "blur":     "onBlur",
        "focus":    "onFocus"
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        T.listenTo(T.model, "change:"+T.fieldName, T.render); 
    },

    render: function(){
        var T=this;
        debug("render "+T.fieldName);
        T.$el.val(T.model.get(T.fieldName));
        return T;
    },

    search: function () {
        var T=this;
        T.model.search();    
    },

    getInputValue:function(){
        return this.$el.val();
    },

    onBlur:function(){
        var T=this;
        T.model.set(T.fieldName,T.getInputValue());
    },

    onFocus:function(){
        var T=this;
        setTimeout(function(){
            T.$el.select();
        },0);
    },

    onKeyPress: function (ev) {
        var T=this;
        if (ev.keyCode === 13) { // enter key pressed
            ev.preventDefault();
            T.model.set(T.fieldName,T.getInputValue());
            T.$el.blur(); // pour refermer le clavier android
            T.trigger("submit");
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }

});
},{"backbone":55,"debug":56,"jquery":58,"underscore":46}],55:[function(require,module,exports){
(function (global){
//     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.3.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(obj.attributes || obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"jquery":58,"underscore":61}],56:[function(require,module,exports){
(function (process){
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this,require('_process'))

},{"./debug":57,"_process":60}],57:[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":59}],58:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],59:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],60:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],61:[function(require,module,exports){
(function (global){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.1
  //     https://underscorejs.org
  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.1';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key]; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = array && max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}]},{},[7])(7)
});

